webpackJsonp([0],[
/* 0 */,
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var _class = function () {
    function _class() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, _class);

        this.apiToken = '$2y$10$Q8DXfG009VhLIFQ.jVOUc.PQP9veEMmsqkthzMdi8xIFTCRkf2AEm';

        this.baseURL = 'https://prep.dev.cityneeds.ng/koko/v1/api/';
        this.imageURL = 'https://prep.dev.cityneeds.ng/koko/v1/api/server/x52rs6c/pr.im.ti.ny.8/';

        this.koUrl = this.baseURL + 'prx/';

        this.paga_apiBaseUrl = this.koUrl + 'https://www.mypaga.com/paga-webservices/business-rest/secured/';
        this.paga_principal = 'FFEEF6C1-18C6-40C4-AD90-B9FED2CE9C9F';
        this.paga_password = 'tP8@uv%dQHguBXR';
        this.paga_apiKey = 'bb9363108ed947c4932b42cbd0068ff291133e0a5ee04ac3afb3f4e365fa0de7aec14f90a5cb463f95f41587390efc3a50f40ce0d2a74acb9784007a21a202c9';
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(_class, [{
        key: 'getStates',
        value: function getStates(context) {
            return context.$http.get(this.baseURL + 'states');
        }
    }, {
        key: 'getStateName',
        value: function getStateName(context, id) {
            return context.$http.get(this.baseURL + 'states/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getCityName',
        value: function getCityName(context, id) {
            return context.$http.get(this.baseURL + 'cities/name/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getCities',
        value: function getCities(context, id) {
            return context.$http.get(this.baseURL + 'cities/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getUserID',
        value: function getUserID(context, id) {
            return context.$http.post(this.baseURL + 'auth/sessions/id', id);
        }
    }, {
        key: 'getDataItem',
        value: function getDataItem(context, data, id) {
            return context.$http.post(this.baseURL + 'auth/data/' + id, data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'uploadDataPhoto',
        value: function uploadDataPhoto(context, data) {
            return context.$http.post(this.baseURL + '/uploads', data, {
                headers: {
                    'Api-Token': this.apiToken,
                    'Content-Type': 'multipart/form-data'
                }
            });
        }
    }, {
        key: 'regUser',
        value: function regUser(context, data) {
            return context.$http.post(this.baseURL + 'users', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'loginAdmin',
        value: function loginAdmin(context, data) {
            return context.$http.post(this.baseURL + 'admin/login', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'sessionGuard',
        value: function sessionGuard(context, data) {
            return context.$http.post(this.baseURL + 'auth/sessions', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'verifyEmail',
        value: function verifyEmail(context, data) {
            return context.$http.post(this.baseURL + 'auth/verify/email', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'forgotPassword',
        value: function forgotPassword(context, data) {
            return context.$http.post(this.baseURL + 'admin/auth/password/forgot', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'verifyResetToken',
        value: function verifyResetToken(context, token) {
            return context.$http.post(this.baseURL + 'admin/auth/verify/reset/token/' + token, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'resetForgotPassword',
        value: function resetForgotPassword(context, data) {
            return context.$http.post(this.baseURL + 'admin/auth/password/forgot/reset', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'resetPassword',
        value: function resetPassword(context, data) {
            return context.$http.post(this.baseURL + 'admin/auth/password/reset', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'resetEmail',
        value: function resetEmail(context, data) {
            return context.$http.post(this.baseURL + 'admin/auth/email/reset', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getUsers',
        value: function getUsers(context, id) {
            return context.$http.get(this.baseURL + 'users', {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getUser',
        value: function getUser(context, id) {
            return context.$http.get(this.baseURL + 'users/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'editProfile',
        value: function editProfile(context, data, id) {
            return context.$http.put(this.baseURL + 'users/' + id, data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'deleteUsers',
        value: function deleteUsers(context, id) {
            return context.$http.delete(this.baseURL + 'users/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'adminEditUsers',
        value: function adminEditUsers(context, id, data) {
            return context.$http.put(this.baseURL + 'admin/users/' + id, data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getBusinessCategories',
        value: function getBusinessCategories(context) {
            return context.$http.get(this.baseURL + 'businesscategories', {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'addBusinessCategory',
        value: function addBusinessCategory(context, data) {
            return context.$http.post(this.baseURL + 'businessescategories', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'editBusinessCategories',
        value: function editBusinessCategories(context, id, data) {
            return context.$http.put(this.baseURL + 'businesscategories/' + id, data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getAllBusinesses',
        value: function getAllBusinesses(context, id) {
            return context.$http.get(this.baseURL + 'businesses', {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getBusinesses',
        value: function getBusinesses(context, id) {
            return context.$http.get(this.baseURL + 'businesses/user/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getBusiness',
        value: function getBusiness(context, id) {
            return context.$http.get(this.baseURL + 'businesses/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'addBusiness',
        value: function addBusiness(context, data) {
            return context.$http.post(this.baseURL + 'businesses', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'editBusiness',
        value: function editBusiness(context, id, data) {
            return context.$http.put(this.baseURL + 'businesses/' + id, data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'deleteBusiness',
        value: function deleteBusiness(context, id) {
            return context.$http.delete(this.baseURL + 'businesses/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'adminDeleteBusiness',
        value: function adminDeleteBusiness(context, id) {
            return context.$http.delete(this.baseURL + 'admin/businesses/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'searchBusinesses',
        value: function searchBusinesses(context, data) {
            return context.$http.post(this.baseURL + 'businesses/search', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'citisaveBusinesses',
        value: function citisaveBusinesses(context, data) {
            return context.$http.post(this.baseURL + 'businesses/citisave', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getCnproParentCategories',
        value: function getCnproParentCategories(context) {
            return context.$http.get(this.baseURL + 'cnprocategories/parent', {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'editCnproParentCategories',
        value: function editCnproParentCategories(context, id, data) {
            return context.$http.put(this.baseURL + 'cnprocategories/parent/' + id, data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getCnproCategories',
        value: function getCnproCategories(context, id) {
            return context.$http.get(this.baseURL + 'cnprocategories/sub/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getCnproSubCategories',
        value: function getCnproSubCategories(context, id) {
            return context.$http.get(this.baseURL + 'cnprocategories/sub', {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'editCnproSubCategories',
        value: function editCnproSubCategories(context, id, data) {
            return context.$http.put(this.baseURL + 'cnprocategories/sub/' + id, data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'addCnproParentCategory',
        value: function addCnproParentCategory(context, data) {
            return context.$http.post(this.baseURL + 'cnprocategories', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'addCnproSubCategory',
        value: function addCnproSubCategory(context, data) {
            return context.$http.post(this.baseURL + 'cnprocategories/sub', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getAllCnpros',
        value: function getAllCnpros(context) {
            return context.$http.get(this.baseURL + '/settings/cnpros', {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getCnpros',
        value: function getCnpros(context, id) {
            return context.$http.get(this.baseURL + 'cnpros/user/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getCnpro',
        value: function getCnpro(context, id) {
            return context.$http.get(this.baseURL + 'cnpros/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'addCnpro',
        value: function addCnpro(context, data) {
            return context.$http.post(this.baseURL + 'cnpros', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'addCnproPhoto',
        value: function addCnproPhoto(context, data) {
            return context.$http.post(this.baseURL + 'cnpros/uploads', data, {
                headers: {
                    'Api-Token': this.apiToken,
                    'Content-Type': 'multipart/form-data'

                }
            });
        }
    }, {
        key: 'editCnpro',
        value: function editCnpro(context, data, id) {
            return context.$http.put(this.baseURL + 'cnpros/' + id, data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'approveCnpro',
        value: function approveCnpro(context, id, data) {
            return context.$http.put(this.baseURL + 'cnpros/approvals/' + id, data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'deleteCnpro',
        value: function deleteCnpro(context, id) {
            return context.$http.delete(this.baseURL + 'cnpros/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'adminDeleteCnpros',
        value: function adminDeleteCnpros(context, id) {
            return context.$http.delete(this.baseURL + 'admin/cnpros/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'adminEditCnpros',
        value: function adminEditCnpros(context, id, data) {
            return context.$http.put(this.baseURL + 'admin/cnpros/' + id, data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'searchCnpros',
        value: function searchCnpros(context, data) {
            return context.$http.post(this.baseURL + 'cnpros/search', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getSavedListings',
        value: function getSavedListings(context, id) {
            return context.$http.get(this.baseURL + 'citisaves/users/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getSavedListing',
        value: function getSavedListing(context, id) {
            return context.$http.get(this.baseURL + 'citisaves/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'saveListing',
        value: function saveListing(context, data) {
            return context.$http.post(this.baseURL + 'citisaves', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getContracts',
        value: function getContracts(context, id) {
            return context.$http.get(this.baseURL + 'contracts', {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getUserContracts',
        value: function getUserContracts(context, id) {
            return context.$http.get(this.baseURL + 'contracts/user/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getCnproContracts',
        value: function getCnproContracts(context, id) {
            return context.$http.get(this.baseURL + 'contracts/cnpro/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getContract',
        value: function getContract(context, id) {
            return context.$http.get(this.baseURL + 'contracts/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'checkCnproContractRequest',
        value: function checkCnproContractRequest(context, data) {
            return context.$http.post(this.baseURL + 'contracts/checks', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'requestQuote',
        value: function requestQuote(context, data) {
            return context.$http.post(this.baseURL + 'contracts', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'replyQuote',
        value: function replyQuote(context, id, data) {
            return context.$http.post(this.baseURL + 'contracts/reply', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'setQuote',
        value: function setQuote(context, id, data) {
            return context.$http.put(this.baseURL + 'contracts/set/' + id, data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'updateQuote',
        value: function updateQuote(context, id, data) {
            return context.$http.put(this.baseURL + 'contracts/update/' + id, data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'acceptQuote',
        value: function acceptQuote(context, id, data) {
            return context.$http.put(this.baseURL + 'contracts/accept/' + id, data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'rejectQuote',
        value: function rejectQuote(context, id, data) {
            return context.$http.put(this.baseURL + 'contracts/reject/' + id, data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'confirmContractCnpro',
        value: function confirmContractCnpro(context, id, data) {
            return context.$http.put(this.baseURL + 'contracts/confirm/cnpro/' + id, data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'confirmContract',
        value: function confirmContract(context, id, data) {
            return context.$http.put(this.baseURL + 'contracts/confirm/' + id, data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'closeContract',
        value: function closeContract(context, id, data) {
            return context.$http.put(this.baseURL + 'contracts/close/' + id, data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'endContract',
        value: function endContract(context, id, data) {
            return context.$http.put(this.baseURL + 'contracts/end/' + id, data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'updatePayment',
        value: function updatePayment(context, id, data) {
            return context.$http.put(this.baseURL + 'contracts/payments/' + id, data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getContractComplaints',
        value: function getContractComplaints(context, id) {
            return context.$http.get(this.baseURL + 'contracts/complaints/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'makeComplaint',
        value: function makeComplaint(context, id, data) {
            return context.$http.post(this.baseURL + 'contracts/complaints', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getAllReviews',
        value: function getAllReviews(context) {
            return context.$http.get(this.baseURL + 'reviews', {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'submitReview',
        value: function submitReview(context, data) {
            return context.$http.post(this.baseURL + 'reviews', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'submitRating',
        value: function submitRating(context, data) {
            return context.$http.post(this.baseURL + 'ratings', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getAllForums',
        value: function getAllForums(context) {
            return context.$http.get(this.baseURL + 'forums', {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'postThread',
        value: function postThread(context, data) {
            return context.$http.post(this.baseURL + 'forums', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getUserThreads',
        value: function getUserThreads(context, id) {
            return context.$http.get(this.baseURL + 'forums/users/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getThread',
        value: function getThread(context, id) {
            return context.$http.get(this.baseURL + 'forums/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'deleteForum',
        value: function deleteForum(context, id) {
            return context.$http.delete(this.baseURL + 'forums/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'deleteForumComment',
        value: function deleteForumComment(context, id) {
            return context.$http.delete(this.baseURL + 'forums/comments/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'forumComments',
        value: function forumComments(context, id) {
            return context.$http.get(this.baseURL + 'forums/comments/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'addThreadComment',
        value: function addThreadComment(context, data) {
            return context.$http.post(this.baseURL + 'forums/comments', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getSurveys',
        value: function getSurveys(context) {
            return context.$http.get(this.baseURL + 'settings/cnsurveys', {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'survey',
        value: function survey(context, data) {
            return context.$http.post(this.baseURL + 'cnsurveys', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'addSurveyQuestion',
        value: function addSurveyQuestion(context, data) {
            return context.$http.post(this.baseURL + 'cnsurveys/questions', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'editSurvey',
        value: function editSurvey(context, data, id) {
            return context.$http.put(this.baseURL + 'cnsurveys/' + id, data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'editSurveyQuestion',
        value: function editSurveyQuestion(context, data, id) {
            return context.$http.put(this.baseURL + 'cnsurveys/questions/' + id, data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'userSurveys',
        value: function userSurveys(context, id) {
            return context.$http.get(this.baseURL + 'cnsurveys/users/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getUserSurveys',
        value: function getUserSurveys(context, id) {
            return context.$http.get(this.baseURL + 'cnsurveys/users/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'allSurveys',
        value: function allSurveys(context) {
            return context.$http.get(this.baseURL + 'cnsurveys', {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'surveyAns',
        value: function surveyAns(context, data) {
            return context.$http.post(this.baseURL + 'cnsurveys/answers', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'deleteSurvey',
        value: function deleteSurvey(context, id) {
            return context.$http.delete(this.baseURL + 'cnsurveys/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'deleteSurveyQuestion',
        value: function deleteSurveyQuestion(context, id) {
            return context.$http.delete(this.baseURL + 'cnsurveys/questions/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'approveSurvey',
        value: function approveSurvey(context, id, data) {
            return context.$http.put(this.baseURL + 'cnsurveys/approvals/' + id, data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'setActivationFee',
        value: function setActivationFee(context, id, data) {
            return context.$http.put(this.baseURL + 'cnsurveys/activations/' + id, data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getPaymentPlans',
        value: function getPaymentPlans(context) {
            return context.$http.get(this.baseURL + 'plans', {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'setPaymentPlan',
        value: function setPaymentPlan(context, data) {
            return context.$http.post(this.baseURL + 'plans/users', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'updatePaymentPlan',
        value: function updatePaymentPlan(context, id, data) {
            return context.$http.put(this.baseURL + 'plans/payments/' + id, data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getTransactions',
        value: function getTransactions(context, id) {
            return context.$http.get(this.baseURL + 'transactions', {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getPayments',
        value: function getPayments(context, id) {
            return context.$http.get(this.baseURL + 'monies', {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getMonies',
        value: function getMonies(context, id) {
            return context.$http.get(this.baseURL + 'monies/users/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getMoney',
        value: function getMoney(context, id) {
            return context.$http.get(this.baseURL + 'monies/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'updateMoniesPaid',
        value: function updateMoniesPaid(context, id, data) {
            return context.$http.put(this.baseURL + 'monies/payments/' + id, data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'updateMoniesPayOut',
        value: function updateMoniesPayOut(context, id, data) {
            return context.$http.put(this.baseURL + 'monies/payouts/' + id, data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getCNpayments',
        value: function getCNpayments(context) {
            return context.$http.get(this.baseURL + 'cnpayments', {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getCNpaymentsPaga',
        value: function getCNpaymentsPaga(context) {
            return context.$http.get(this.baseURL + 'cnpayments/paga', {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getCNpayCharges',
        value: function getCNpayCharges(context, id) {
            return context.$http.get(this.baseURL + 'cnpayments/cnpaycharges', {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getCNpayCommissions',
        value: function getCNpayCommissions(context, id) {
            return context.$http.get(this.baseURL + 'cnpayments/commissions', {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'editCnpayCharges',
        value: function editCnpayCharges(context, id, data) {
            return context.$http.put(this.baseURL + 'cnpayments/charges/' + id, data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'editCnpayCommissions',
        value: function editCnpayCommissions(context, id, data) {
            return context.$http.put(this.baseURL + 'cnpayments/commissions/' + id, data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getWalletProcessingCharges',
        value: function getWalletProcessingCharges(context) {
            return context.$http.get(this.baseURL + 'cnwallet/charges', {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'addWalletProcessingCharge',
        value: function addWalletProcessingCharge(context, data) {
            return context.$http.post(this.baseURL + 'cnwallet/charges', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'editWalletProcessingCharge',
        value: function editWalletProcessingCharge(context, id, data) {
            return context.$http.put(this.baseURL + 'cnwallet/charges/' + id, data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'deleteWalletProcessingCharge',
        value: function deleteWalletProcessingCharge(context, id) {
            return context.$http.delete(this.baseURL + 'cnwallet/charges/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getWalletTransactions',
        value: function getWalletTransactions(context) {
            return context.$http.get(this.baseURL + 'cnwallet/admin/all/transactions', {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getUserWalletTransactions',
        value: function getUserWalletTransactions(context, id) {
            return context.$http.get(this.baseURL + 'cnwallet/admin/user/transactions/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'postWalletTopup',
        value: function postWalletTopup(context, data) {
            return context.$http.post(this.baseURL + 'cnwallet/transactions/topup', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getServiceRewards',
        value: function getServiceRewards(context) {
            return context.$http.get(this.baseURL + 'rewards/services', {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'addServiceRewards',
        value: function addServiceRewards(context, data) {
            return context.$http.post(this.baseURL + 'rewards/services', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'editServiceRewards',
        value: function editServiceRewards(context, id, data) {
            return context.$http.put(this.baseURL + 'rewards/services/' + id, data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'deleteServiceRewards',
        value: function deleteServiceRewards(context, id) {
            return context.$http.delete(this.baseURL + 'rewards/services/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getRewardsTransactions',
        value: function getRewardsTransactions(context) {
            return context.$http.get(this.baseURL + 'rewards/admin/all/transactions', {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getUserReferralTransactions',
        value: function getUserReferralTransactions(context, id) {
            return context.$http.get(this.baseURL + 'referrals/admin/user/transactions/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getReferralsTransactions',
        value: function getReferralsTransactions(context) {
            return context.$http.get(this.baseURL + 'referrals/admin/all/transactions', {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getCNdiscounts',
        value: function getCNdiscounts(context) {
            return context.$http.get(this.baseURL + 'cndiscounts', {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getCNinsurance',
        value: function getCNinsurance(context) {
            return context.$http.get(this.baseURL + 'cninsurance/listings', {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getCNinsuranceForms',
        value: function getCNinsuranceForms(context, id) {
            return context.$http.get(this.baseURL + 'cninsurance/forms/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getCNinsuranceClaims',
        value: function getCNinsuranceClaims(context, id) {
            return context.$http.get(this.baseURL + 'cninsurance/claims/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getCNinsuranceComplaints',
        value: function getCNinsuranceComplaints(context, id) {
            return context.$http.get(this.baseURL + 'cninsurance/complaints/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'addCNinsuranceDiscount',
        value: function addCNinsuranceDiscount(context, data) {
            return context.$http.post(this.baseURL + 'cninsurance/discounts', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'updateCNinsuranceDetails',
        value: function updateCNinsuranceDetails(context, id, data) {
            return context.$http.put(this.baseURL + 'cninsurance/' + id, data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'updateCNinsuraceFormPrice',
        value: function updateCNinsuraceFormPrice(context, id, data) {
            return context.$http.put(this.baseURL + 'cninsurance/prices/' + id, data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'updateCNinsuranceDiscount',
        value: function updateCNinsuranceDiscount(context, id, data) {
            return context.$http.put(this.baseURL + 'cninsurance/discounts/' + id, data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getCNdiscounts',
        value: function getCNdiscounts(context, offset, items) {
            return context.$http.get(this.baseURL + 'cndiscounts/all/' + offset + '/' + items, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'updateCNdiscount',
        value: function updateCNdiscount(context, id, data) {
            return context.$http.put(this.baseURL + 'cndiscounts/' + id, data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getUserAnalytics',
        value: function getUserAnalytics(context, id) {
            return context.$http.get(this.baseURL + 'analytics/users/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getActivities',
        value: function getActivities(context, id) {
            return context.$http.get(this.baseURL + 'activities', {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getCNServices',
        value: function getCNServices(context, id) {
            return context.$http.get(this.baseURL + 'settings/cnservices', {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getServiceCharges',
        value: function getServiceCharges(context, id) {
            return context.$http.get(this.baseURL + 'settings/servicecharges', {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'editServiceCharges',
        value: function editServiceCharges(context, id, data) {
            return context.$http.put(this.baseURL + 'settings/servicecharges/' + id, data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getDefaultCharges',
        value: function getDefaultCharges(context, id) {
            return context.$http.get(this.baseURL + 'settings/defaultcharges', {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'editDefaultCharges',
        value: function editDefaultCharges(context, id, data) {
            return context.$http.put(this.baseURL + 'settings/defaultcharges/' + id, data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'editPlansAndPricing',
        value: function editPlansAndPricing(context, id, data) {
            return context.$http.put(this.baseURL + 'plans/' + id, data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'pagaGetMerchants',
        value: function pagaGetMerchants(context) {
            return context.$http.post(this.paga_apiBaseUrl + 'getMerchants', {
                headers: {
                    'Content-Type': 'application/json',
                    principal: this.paga_principal,
                    Credentials: this.paga_password
                }
            });
        }
    }, {
        key: 'pagaGetMobileOperators',
        value: function pagaGetMobileOperators(context) {
            return context.$http.post(this.paga_apiBaseUrl + 'getMobileOperators', {
                headers: {
                    'Content-Type': 'application/json',
                    principal: this.paga_principal,
                    Credentials: this.paga_password,
                    Accept: 'application/json'
                }
            });
        }
    }, {
        key: 'getPagaRequest',
        value: function getPagaRequest(context, data, url, hash) {
            return context.$http.post(url, data, {
                headers: {
                    'Content-Type': 'application/json',
                    principal: this.paga_principal,
                    credentials: this.paga_password,
                    hash: hash,
                    accept: 'application/json'
                }
            });
        }
    }, {
        key: 'postPagaMerchants',
        value: function postPagaMerchants(context, data) {
            return context.$http.post(this.baseURL + 'cnpay/paga/merchants', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'postPagaMobileOperators',
        value: function postPagaMobileOperators(context, data) {
            return context.$http.post(this.baseURL + 'cnpay/paga/mobileoperators', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getPagaMerchants',
        value: function getPagaMerchants(context) {
            return context.$http.get(this.baseURL + 'cnpay/paga/merchants', {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getPagaMobileOperators',
        value: function getPagaMobileOperators(context) {
            return context.$http.get(this.baseURL + 'cnpay/paga/mobileoperators', {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getPagaServiceGroups',
        value: function getPagaServiceGroups(context) {
            return context.$http.get(this.baseURL + 'cnpay/paga/servicegroups', {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'addPagaServiceGroups',
        value: function addPagaServiceGroups(context, data) {
            return context.$http.post(this.baseURL + 'cnpay/paga/servicegroups', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'addPagaServiceGroupMerchants',
        value: function addPagaServiceGroupMerchants(context, data) {
            return context.$http.post(this.baseURL + 'cnpay/paga/servicegroups/merchants', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'editPagaServiceGroups',
        value: function editPagaServiceGroups(context, id, data) {
            return context.$http.put(this.baseURL + 'cnpay/paga/servicegroups/' + id, data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'deletePagaServiceGroups',
        value: function deletePagaServiceGroups(context, id) {
            return context.$http.delete(this.baseURL + 'cnpay/paga/servicegroups/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'editPagaServiceGroupMerchants',
        value: function editPagaServiceGroupMerchants(context, id, data) {
            return context.$http.put(this.baseURL + 'cnpay/paga/servicegroups/merchants/' + id, data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'deletePagaServiceGroupMerchants',
        value: function deletePagaServiceGroupMerchants(context, id) {
            return context.$http.delete(this.baseURL + 'cnpay/paga/servicegroups/merchants/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'postPagaMerchantDoNotDisplayServices',
        value: function postPagaMerchantDoNotDisplayServices(context, data) {
            return context.$http.post(this.baseURL + 'cnpay/paga/merchant/donotdisplayservices', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'deletePagaMerchantDoNotDisplayServices',
        value: function deletePagaMerchantDoNotDisplayServices(context, id, merchant) {
            return context.$http.delete(this.baseURL + 'cnpay/paga/merchant/donotdisplayservices/' + id + '/' + merchant, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getMessages',
        value: function getMessages(context) {
            return context.$http.get(this.baseURL + 'systemmessages', {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'readMessages',
        value: function readMessages(context) {
            return context.$http.get(this.baseURL + 'readmessages', {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getSubscribers',
        value: function getSubscribers(context) {
            return context.$http.get(this.baseURL + 'subscriptions/requests', {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getNotifications',
        value: function getNotifications(context) {
            return context.$http.get(this.baseURL + 'notifications', {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getAdminNotifications',
        value: function getAdminNotifications(context) {
            return context.$http.get(this.baseURL + '/admin/notifications', {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'postNotifications',
        value: function postNotifications(context, data) {
            return context.$http.post(this.baseURL + 'notifications/admin', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'pushNotifications',
        value: function pushNotifications(context, id) {
            return context.$http.get(this.baseURL + 'notifications/admin/push/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'deleteNotifications',
        value: function deleteNotifications(context, id) {
            return context.$http.get(this.baseURL + 'notifications/delete/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'SHA512',
        value: function SHA512(str) {
            function int64(msint_32, lsint_32) {
                this.highOrder = msint_32;
                this.lowOrder = lsint_32;
            }

            var H = [new int64(0x6a09e667, 0xf3bcc908), new int64(0xbb67ae85, 0x84caa73b), new int64(0x3c6ef372, 0xfe94f82b), new int64(0xa54ff53a, 0x5f1d36f1), new int64(0x510e527f, 0xade682d1), new int64(0x9b05688c, 0x2b3e6c1f), new int64(0x1f83d9ab, 0xfb41bd6b), new int64(0x5be0cd19, 0x137e2179)];

            var K = [new int64(0x428a2f98, 0xd728ae22), new int64(0x71374491, 0x23ef65cd), new int64(0xb5c0fbcf, 0xec4d3b2f), new int64(0xe9b5dba5, 0x8189dbbc), new int64(0x3956c25b, 0xf348b538), new int64(0x59f111f1, 0xb605d019), new int64(0x923f82a4, 0xaf194f9b), new int64(0xab1c5ed5, 0xda6d8118), new int64(0xd807aa98, 0xa3030242), new int64(0x12835b01, 0x45706fbe), new int64(0x243185be, 0x4ee4b28c), new int64(0x550c7dc3, 0xd5ffb4e2), new int64(0x72be5d74, 0xf27b896f), new int64(0x80deb1fe, 0x3b1696b1), new int64(0x9bdc06a7, 0x25c71235), new int64(0xc19bf174, 0xcf692694), new int64(0xe49b69c1, 0x9ef14ad2), new int64(0xefbe4786, 0x384f25e3), new int64(0x0fc19dc6, 0x8b8cd5b5), new int64(0x240ca1cc, 0x77ac9c65), new int64(0x2de92c6f, 0x592b0275), new int64(0x4a7484aa, 0x6ea6e483), new int64(0x5cb0a9dc, 0xbd41fbd4), new int64(0x76f988da, 0x831153b5), new int64(0x983e5152, 0xee66dfab), new int64(0xa831c66d, 0x2db43210), new int64(0xb00327c8, 0x98fb213f), new int64(0xbf597fc7, 0xbeef0ee4), new int64(0xc6e00bf3, 0x3da88fc2), new int64(0xd5a79147, 0x930aa725), new int64(0x06ca6351, 0xe003826f), new int64(0x14292967, 0x0a0e6e70), new int64(0x27b70a85, 0x46d22ffc), new int64(0x2e1b2138, 0x5c26c926), new int64(0x4d2c6dfc, 0x5ac42aed), new int64(0x53380d13, 0x9d95b3df), new int64(0x650a7354, 0x8baf63de), new int64(0x766a0abb, 0x3c77b2a8), new int64(0x81c2c92e, 0x47edaee6), new int64(0x92722c85, 0x1482353b), new int64(0xa2bfe8a1, 0x4cf10364), new int64(0xa81a664b, 0xbc423001), new int64(0xc24b8b70, 0xd0f89791), new int64(0xc76c51a3, 0x0654be30), new int64(0xd192e819, 0xd6ef5218), new int64(0xd6990624, 0x5565a910), new int64(0xf40e3585, 0x5771202a), new int64(0x106aa070, 0x32bbd1b8), new int64(0x19a4c116, 0xb8d2d0c8), new int64(0x1e376c08, 0x5141ab53), new int64(0x2748774c, 0xdf8eeb99), new int64(0x34b0bcb5, 0xe19b48a8), new int64(0x391c0cb3, 0xc5c95a63), new int64(0x4ed8aa4a, 0xe3418acb), new int64(0x5b9cca4f, 0x7763e373), new int64(0x682e6ff3, 0xd6b2b8a3), new int64(0x748f82ee, 0x5defb2fc), new int64(0x78a5636f, 0x43172f60), new int64(0x84c87814, 0xa1f0ab72), new int64(0x8cc70208, 0x1a6439ec), new int64(0x90befffa, 0x23631e28), new int64(0xa4506ceb, 0xde82bde9), new int64(0xbef9a3f7, 0xb2c67915), new int64(0xc67178f2, 0xe372532b), new int64(0xca273ece, 0xea26619c), new int64(0xd186b8c7, 0x21c0c207), new int64(0xeada7dd6, 0xcde0eb1e), new int64(0xf57d4f7f, 0xee6ed178), new int64(0x06f067aa, 0x72176fba), new int64(0x0a637dc5, 0xa2c898a6), new int64(0x113f9804, 0xbef90dae), new int64(0x1b710b35, 0x131c471b), new int64(0x28db77f5, 0x23047d84), new int64(0x32caab7b, 0x40c72493), new int64(0x3c9ebe0a, 0x15c9bebc), new int64(0x431d67c4, 0x9c100d4c), new int64(0x4cc5d4be, 0xcb3e42b6), new int64(0x597f299c, 0xfc657e2a), new int64(0x5fcb6fab, 0x3ad6faec), new int64(0x6c44198c, 0x4a475817)];

            var W = new Array(64);
            var a, b, c, d, e, f, g, h, i, j;
            var T1, T2;
            var charsize = 8;

            function utf8_encode(str) {
                return unescape(encodeURIComponent(str));
            }

            function str2binb(str) {
                var bin = [];
                var mask = (1 << charsize) - 1;
                var len = str.length * charsize;

                for (var i = 0; i < len; i += charsize) {
                    bin[i >> 5] |= (str.charCodeAt(i / charsize) & mask) << 32 - charsize - i % 32;
                }

                return bin;
            }

            function binb2hex(binarray) {
                var hex_tab = '0123456789abcdef';
                var str = '';
                var length = binarray.length * 4;
                var srcByte;

                for (var i = 0; i < length; i += 1) {
                    srcByte = binarray[i >> 2] >> (3 - i % 4) * 8;
                    str += hex_tab.charAt(srcByte >> 4 & 0xF) + hex_tab.charAt(srcByte & 0xF);
                }

                return str;
            }

            function safe_add_2(x, y) {
                var lsw, msw, lowOrder, highOrder;

                lsw = (x.lowOrder & 0xFFFF) + (y.lowOrder & 0xFFFF);
                msw = (x.lowOrder >>> 16) + (y.lowOrder >>> 16) + (lsw >>> 16);
                lowOrder = (msw & 0xFFFF) << 16 | lsw & 0xFFFF;

                lsw = (x.highOrder & 0xFFFF) + (y.highOrder & 0xFFFF) + (msw >>> 16);
                msw = (x.highOrder >>> 16) + (y.highOrder >>> 16) + (lsw >>> 16);
                highOrder = (msw & 0xFFFF) << 16 | lsw & 0xFFFF;

                return new int64(highOrder, lowOrder);
            }

            function safe_add_4(a, b, c, d) {
                var lsw, msw, lowOrder, highOrder;

                lsw = (a.lowOrder & 0xFFFF) + (b.lowOrder & 0xFFFF) + (c.lowOrder & 0xFFFF) + (d.lowOrder & 0xFFFF);
                msw = (a.lowOrder >>> 16) + (b.lowOrder >>> 16) + (c.lowOrder >>> 16) + (d.lowOrder >>> 16) + (lsw >>> 16);
                lowOrder = (msw & 0xFFFF) << 16 | lsw & 0xFFFF;

                lsw = (a.highOrder & 0xFFFF) + (b.highOrder & 0xFFFF) + (c.highOrder & 0xFFFF) + (d.highOrder & 0xFFFF) + (msw >>> 16);
                msw = (a.highOrder >>> 16) + (b.highOrder >>> 16) + (c.highOrder >>> 16) + (d.highOrder >>> 16) + (lsw >>> 16);
                highOrder = (msw & 0xFFFF) << 16 | lsw & 0xFFFF;

                return new int64(highOrder, lowOrder);
            }

            function safe_add_5(a, b, c, d, e) {
                var lsw, msw, lowOrder, highOrder;

                lsw = (a.lowOrder & 0xFFFF) + (b.lowOrder & 0xFFFF) + (c.lowOrder & 0xFFFF) + (d.lowOrder & 0xFFFF) + (e.lowOrder & 0xFFFF);
                msw = (a.lowOrder >>> 16) + (b.lowOrder >>> 16) + (c.lowOrder >>> 16) + (d.lowOrder >>> 16) + (e.lowOrder >>> 16) + (lsw >>> 16);
                lowOrder = (msw & 0xFFFF) << 16 | lsw & 0xFFFF;

                lsw = (a.highOrder & 0xFFFF) + (b.highOrder & 0xFFFF) + (c.highOrder & 0xFFFF) + (d.highOrder & 0xFFFF) + (e.highOrder & 0xFFFF) + (msw >>> 16);
                msw = (a.highOrder >>> 16) + (b.highOrder >>> 16) + (c.highOrder >>> 16) + (d.highOrder >>> 16) + (e.highOrder >>> 16) + (lsw >>> 16);
                highOrder = (msw & 0xFFFF) << 16 | lsw & 0xFFFF;

                return new int64(highOrder, lowOrder);
            }

            function maj(x, y, z) {
                return new int64(x.highOrder & y.highOrder ^ x.highOrder & z.highOrder ^ y.highOrder & z.highOrder, x.lowOrder & y.lowOrder ^ x.lowOrder & z.lowOrder ^ y.lowOrder & z.lowOrder);
            }

            function ch(x, y, z) {
                return new int64(x.highOrder & y.highOrder ^ ~x.highOrder & z.highOrder, x.lowOrder & y.lowOrder ^ ~x.lowOrder & z.lowOrder);
            }

            function rotr(x, n) {
                if (n <= 32) {
                    return new int64(x.highOrder >>> n | x.lowOrder << 32 - n, x.lowOrder >>> n | x.highOrder << 32 - n);
                } else {
                    return new int64(x.lowOrder >>> n | x.highOrder << 32 - n, x.highOrder >>> n | x.lowOrder << 32 - n);
                }
            }

            function sigma0(x) {
                var rotr28 = rotr(x, 28);
                var rotr34 = rotr(x, 34);
                var rotr39 = rotr(x, 39);

                return new int64(rotr28.highOrder ^ rotr34.highOrder ^ rotr39.highOrder, rotr28.lowOrder ^ rotr34.lowOrder ^ rotr39.lowOrder);
            }

            function sigma1(x) {
                var rotr14 = rotr(x, 14);
                var rotr18 = rotr(x, 18);
                var rotr41 = rotr(x, 41);

                return new int64(rotr14.highOrder ^ rotr18.highOrder ^ rotr41.highOrder, rotr14.lowOrder ^ rotr18.lowOrder ^ rotr41.lowOrder);
            }

            function gamma0(x) {
                var rotr1 = rotr(x, 1),
                    rotr8 = rotr(x, 8),
                    shr7 = shr(x, 7);

                return new int64(rotr1.highOrder ^ rotr8.highOrder ^ shr7.highOrder, rotr1.lowOrder ^ rotr8.lowOrder ^ shr7.lowOrder);
            }

            function gamma1(x) {
                var rotr19 = rotr(x, 19);
                var rotr61 = rotr(x, 61);
                var shr6 = shr(x, 6);

                return new int64(rotr19.highOrder ^ rotr61.highOrder ^ shr6.highOrder, rotr19.lowOrder ^ rotr61.lowOrder ^ shr6.lowOrder);
            }

            function shr(x, n) {
                if (n <= 32) {
                    return new int64(x.highOrder >>> n, x.lowOrder >>> n | x.highOrder << 32 - n);
                } else {
                    return new int64(0, x.highOrder << 32 - n);
                }
            }

            var str = utf8_encode(str);
            var strlen = str.length * charsize;
            var str = str2binb(str);

            str[strlen >> 5] |= 0x80 << 24 - strlen % 32;
            str[(strlen + 128 >> 10 << 5) + 31] = strlen;

            for (var i = 0; i < str.length; i += 32) {
                a = H[0];
                b = H[1];
                c = H[2];
                d = H[3];
                e = H[4];
                f = H[5];
                g = H[6];
                h = H[7];

                for (var j = 0; j < 80; j++) {
                    if (j < 16) {
                        W[j] = new int64(str[j * 2 + i], str[j * 2 + i + 1]);
                    } else {
                        W[j] = safe_add_4(gamma1(W[j - 2]), W[j - 7], gamma0(W[j - 15]), W[j - 16]);
                    }

                    T1 = safe_add_5(h, sigma1(e), ch(e, f, g), K[j], W[j]);
                    T2 = safe_add_2(sigma0(a), maj(a, b, c));
                    h = g;
                    g = f;
                    f = e;
                    e = safe_add_2(d, T1);
                    d = c;
                    c = b;
                    b = a;
                    a = safe_add_2(T1, T2);
                }

                H[0] = safe_add_2(a, H[0]);
                H[1] = safe_add_2(b, H[1]);
                H[2] = safe_add_2(c, H[2]);
                H[3] = safe_add_2(d, H[3]);
                H[4] = safe_add_2(e, H[4]);
                H[5] = safe_add_2(f, H[5]);
                H[6] = safe_add_2(g, H[6]);
                H[7] = safe_add_2(h, H[7]);
            }

            var binarray = [];
            for (var i = 0; i < H.length; i++) {
                binarray.push(H[i].highOrder);
                binarray.push(H[i].lowOrder);
            }
            return binb2hex(binarray);
        }
    }]);

    return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(133)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(74),
  /* template */
  __webpack_require__(163),
  /* scopeId */
  "data-v-69463d26",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(134)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(75),
  /* template */
  __webpack_require__(164),
  /* scopeId */
  "data-v-6cc5f042",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(136)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(82),
  /* template */
  __webpack_require__(166),
  /* scopeId */
  "data-v-9059748c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(144)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(58),
  /* template */
  __webpack_require__(174),
  /* scopeId */
  "data-v-f1890018",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(137)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(59),
  /* template */
  __webpack_require__(167),
  /* scopeId */
  "data-v-90791e34",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(141)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(60),
  /* template */
  __webpack_require__(171),
  /* scopeId */
  "data-v-cccc4af6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(128)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(61),
  /* template */
  __webpack_require__(158),
  /* scopeId */
  "data-v-3f1eb290",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(124)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(62),
  /* template */
  __webpack_require__(154),
  /* scopeId */
  "data-v-11f9840d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(125)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(63),
  /* template */
  __webpack_require__(155),
  /* scopeId */
  "data-v-17898a4a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(129)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(64),
  /* template */
  __webpack_require__(159),
  /* scopeId */
  "data-v-5c0f70e8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(132)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(65),
  /* template */
  __webpack_require__(162),
  /* scopeId */
  "data-v-68443070",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(122)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(66),
  /* template */
  __webpack_require__(152),
  /* scopeId */
  "data-v-04c83b1c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(143)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(67),
  /* template */
  __webpack_require__(173),
  /* scopeId */
  "data-v-cea24266",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(123)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(68),
  /* template */
  __webpack_require__(153),
  /* scopeId */
  "data-v-115364ee",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(140)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(69),
  /* template */
  __webpack_require__(170),
  /* scopeId */
  "data-v-c820cea8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(131)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(70),
  /* template */
  __webpack_require__(161),
  /* scopeId */
  "data-v-60ee74ff",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(145)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(71),
  /* template */
  __webpack_require__(175),
  /* scopeId */
  "data-v-f4980b9c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(135)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(72),
  /* template */
  __webpack_require__(165),
  /* scopeId */
  "data-v-75c8ad6a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(120)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(73),
  /* template */
  __webpack_require__(150),
  /* scopeId */
  "data-v-02941b72",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(127)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(76),
  /* template */
  __webpack_require__(157),
  /* scopeId */
  "data-v-3922a8f8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(139)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(77),
  /* template */
  __webpack_require__(169),
  /* scopeId */
  "data-v-c58ed7b6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(126)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(78),
  /* template */
  __webpack_require__(156),
  /* scopeId */
  "data-v-2ef8d4d8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(142)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(79),
  /* template */
  __webpack_require__(172),
  /* scopeId */
  "data-v-ce4490fc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(130)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(81),
  /* template */
  __webpack_require__(160),
  /* scopeId */
  "data-v-5e2e059b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(119)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(83),
  /* template */
  __webpack_require__(149),
  /* scopeId */
  "data-v-00d7d3b4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var inBrowser = typeof window !== 'undefined';
/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'VueProgress',
    serverCacheKey: function serverCacheKey() {
        return 'Progress';
    },
    computed: {
        style: function style() {
            var location = this.progress.options.location;
            var style = {
                'background-color': this.progress.options.canSuccess ? this.progress.options.color : this.progress.options.failedColor,
                'opacity': this.progress.options.show ? 1 : 0
            };
            if (location == 'top' || location == 'bottom') {
                location === 'top' ? style.top = '0px' : style.bottom = '0px';
                if (!this.progress.options.inverse) {
                    style.left = '0px';
                } else {
                    style.right = '0px';
                }
                style.width = this.progress.percent + '%';
                style.height = this.progress.options.thickness;
                style.transition = "width " + this.progress.options.transition.speed + ", opacity " + this.progress.options.transition.opacity;
            } else if (location == 'left' || location == 'right') {
                location === 'left' ? style.left = '0px' : style.right = '0px';
                if (!this.progress.options.inverse) {
                    style.bottom = '0px';
                } else {
                    style.top = '0px';
                }
                style.height = this.progress.percent + '%';
                style.width = this.progress.options.thickness;
                style.transition = "height " + this.progress.options.transition.speed + ", opacity " + this.progress.options.transition.opacity;
            }
            return style;
        },
        progress: function progress() {
            if (inBrowser) {
                return window.VueProgressBarEventBus.RADON_LOADING_BAR;
            } else {
                return {
                    percent: 0,
                    options: {
                        canSuccess: true,
                        show: false,
                        color: 'rgb(19, 91, 55)',
                        failedColor: 'red',
                        thickness: '2px',
                        transition: {
                            speed: '0.2s',
                            opacity: '0.6s',
                            termination: 300
                        },
                        location: 'top',
                        autoRevert: true,
                        inverse: false
                    }
                };
            }
        }
    }
});

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Main_Header_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Main_Header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Main_Header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue__);




var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Cnpros',
    data: function data() {
        return {
            admin: {},
            categories: {},
            category: {},
            img_url: service.imageURL,
            deleteRequest: false,
            editRequest: false,
            addRequest: false,
            disable_btn: false
        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__Main_Header_index_vue___default.a,
        'component-sidebar': __WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue___default.a
    },
    methods: {
        setComponent: function setComponent(attr, attr2) {
            this.panelFlag = true;
            if (attr == "add") {
                this.category = {};
                this.addRequest = true;
            }
            if (attr == "edit") {
                this.category = {};
                this.category = attr2;
                this.category.editRequest = true;
            }
            if (attr == "reset-action") {
                this.category = {};
                this.category.editRequest = false;
                this.addRequest = false;
            }
        },
        preset: function preset() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("cityneeds_a_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.admin.admin_id = element.admin_id;
                        }, _this);
                    } else {
                        _this.$router.push('/');
                    }
                }).catch(function (err) {
                    if (err) {
                        _this.$router.push('/');
                    }
                });
            } else {
                this.$router.push('/');
            }
        },
        addBusinessCategory: function addBusinessCategory() {
            var _this2 = this;

            service.addBusinessCategory(this, this.category).then(function (data) {
                if (data.body.status == 201) {
                    _this2.getBusinessCategories();
                }
                _this2.addRequest = false;
                _this2.category = {};
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        },
        getBusinessCategories: function getBusinessCategories() {
            var _this3 = this;

            service.getBusinessCategories(this).then(function (data) {
                if (data.body.status == 200) {
                    _this3.categories = data.body.data;
                }
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        },
        editBusinessCategories: function editBusinessCategories() {
            var _this4 = this;

            service.editBusinessCategories(this, this.category.business_category_id, this.category).then(function (data) {
                if (data.body.status == 200) {
                    _this4.getBusinessCategories();
                    _this4.category.editRequest = false;
                }
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        }
    },
    created: function created() {
        this.preset();
        this.getBusinessCategories();
    }
});

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Main_Header_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Main_Header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Main_Header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue__);




var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'businesses',
    data: function data() {
        return {
            admin: {},
            businesses: {},
            business: {},
            viewFlag: "",
            img_url: service.imageURL,
            deleteRequest: false
        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__Main_Header_index_vue___default.a,
        'component-sidebar': __WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue___default.a
    },
    methods: {
        setPanel: function setPanel(attr, attr2) {
            this.panelFlag = true;
            if (attr == "view") {
                this.viewFlag = true;
                this.business = attr2;
            }
        },
        requests: function requests(req) {
            if (req == "delete") {
                this.deleteRequest = true;
            }
        },
        isActive: function isActive(index) {
            if (index == 1) {
                return "active";
            }
        },
        preset: function preset() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("cityneeds_a_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.admin.admin_id = element.admin_id;
                        }, _this);
                    } else {
                        _this.$router.push('/');
                    }
                }).catch(function (err) {
                    if (err) {
                        _this.$router.push('/');
                    }
                });
            } else {
                this.$router.push('/');
            }
        },
        getBusinesses: function getBusinesses() {
            var _this2 = this;

            service.getAllBusinesses(this).then(function (data) {
                if (data.body.status == 200) {
                    _this2.businesses = data.body.data;
                }
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        },
        deleteListing: function deleteListing() {
            service.adminDeleteBusiness(this, this.business.business_id).then(function (data) {
                if (data.body.status == 200) {
                    toastr.error('removed', 'Warning!');
                    location.reload(true);
                }
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        }
    },
    created: function created() {
        this.preset();
        this.getBusinesses();
    }
});

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Main_Header_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Main_Header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Main_Header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue__);




var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'CNdiscounts',
    data: function data() {
        return {
            admin: {},
            cndiscounts: {},
            cndiscount: {},
            panelFlag: false,
            viewFlag: false,
            img_url: service.imageURL,
            count_today: 0
        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__Main_Header_index_vue___default.a,
        'component-sidebar': __WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue___default.a
    },
    methods: {
        setPanel: function setPanel(attr, attr2) {
            this.panelFlag = true;
            if (attr == "view") {
                this.viewFlag = true;
                this.cndiscount = attr2;
            }
        },
        isActive: function isActive(index) {
            if (index == 1) {
                return "active";
            }
        },
        preset: function preset() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("cityneeds_a_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.admin.admin_id = element.admin_id;
                        }, _this);
                    } else {
                        _this.$router.push('/');
                    }
                }).catch(function (err) {
                    if (err) {
                        _this.$router.push('/');
                    }
                });
            } else {
                this.$router.push('/');
            }
        },
        getCNdiscounts: function getCNdiscounts() {
            var _this2 = this;

            service.getCNdiscounts(this, 0, 250).then(function (data) {
                if (data.body.status == 200) {
                    _this2.cndiscounts = data.body.data;
                }
                _this2.count_today = data.body.data_count_today;
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        },
        updateDiscountStatus: function updateDiscountStatus(cndiscount, index, status) {
            var _this3 = this;

            this.$router.push('cndiscounts');
            var payload = {
                cndiscount_action: 1,
                cndiscount_update: status || 0
            };
            if (payload.cndiscount_update > 0) {
                service.updateCNdiscount(this, cndiscount.cndiscount_id, payload).then(function (data) {
                    if (data.body.status == 200) {
                        _this3.cndiscounts[index].cndiscount_status = status;
                    }
                    _this3.getCNdiscounts();
                }).catch(function (err) {
                    if (err) {}
                });
            }
        }
    },
    created: function created() {
        this.preset();
        this.getCNdiscounts();
    }
});

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Main_Header_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Main_Header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Main_Header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue__);




var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'CNpayments',
    data: function data() {
        return {
            admin: {},
            cnpayments: {},
            cnpayment: {},
            panelFlag: false,
            viewFlag: false
        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__Main_Header_index_vue___default.a,
        'component-sidebar': __WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue___default.a
    },
    methods: {
        setPanel: function setPanel(attr, attr2) {
            this.panelFlag = true;
            if (attr == "view") {
                this.viewFlag = true;
                this.cnpayment = attr2;
            }
        },
        isActive: function isActive(index) {
            if (index == 1) {
                return "active";
            }
        },
        preset: function preset() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("cityneeds_a_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.admin.admin_id = element.admin_id;
                        }, _this);
                    } else {
                        _this.$router.push('/');
                    }
                }).catch(function (err) {
                    if (err) {
                        _this.$router.push('/');
                    }
                });
            } else {
                this.$router.push('/');
            }
        },
        getCNpayments: function getCNpayments() {
            var _this2 = this;

            service.getCNpaymentsPaga(this).then(function (data) {
                if (data.body.status == 200) {
                    _this2.cnpayments = data.body.data;
                }
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        }
    },
    created: function created() {
        this.preset();
        this.getCNpayments();
    }
});

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Main_Header_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Main_Header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Main_Header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue__);




var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'CNinsurance',
    data: function data() {
        return {
            admin: {},
            cninsurance_listings: {},
            cninsurance: {},
            cninsurance_forms: {},
            cninsurance_form: {},
            cninsurance_claim: {},
            cninsurance_complaint: {},
            cninsurance_discount: {},
            panelFlag: false,
            viewFlag: false,
            component_view: {},
            component_attr_view: {},
            set_component_view: {},
            toggle_indexes: {},
            load_processes: true,
            data_processing_message: ""
        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__Main_Header_index_vue___default.a,
        'component-sidebar': __WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue___default.a
    },
    methods: {
        closeModal: function closeModal(modal) {
            $(modal).modal("hide");
        },
        setProcessLoading: function setProcessLoading() {
            this.disable_btn = true;
            this.process_loading = true;
        },
        stopProcessLoading: function stopProcessLoading() {
            this.disable_btn = false;
            this.process_loading = false;
        },
        setPanel: function setPanel(attr, attr2) {
            this.panelFlag = true;
            if (attr == "view") {
                this.viewFlag = true;
                this.cninsurance = attr2;
            }
        },
        setComponentView: function setComponentView(view) {
            this.component_view = {};
            this.component_view[view] = true;
        },
        setComponentAttributeView: function setComponentAttributeView(view) {
            this.component_attr_view = {};
            this.component_attr_view[view] = true;
        },
        storeActiveToggleIndex: function storeActiveToggleIndex(view, attr) {
            this.toggle_indexes = {};
            this.toggle_indexes[view] = attr;
        },
        togglePanView: function togglePanView(view) {
            var view_set = document.getElementById(view).style.display;
            if (view_set == "none") {
                document.getElementById(view).style.display = "block";
            } else if (view_set == "block") {
                document.getElementById(view).style.display = "none";
            }
        },
        isActive: function isActive(index) {
            if (index == 1) {
                return "active";
            }
        },
        preset: function preset() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("cityneeds_a_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.admin.admin_id = element.admin_id;
                        }, _this);
                    } else {
                        _this.$router.push('/');
                    }
                }).catch(function (err) {
                    if (err) {
                        _this.$router.push('/');
                    }
                });
            } else {
                this.$router.push('/');
            }
        },
        setContentView: function setContentView(view, attr1, attr2) {
            if (view == 'form_content') {
                this.cninsurance_form = attr1;
                $('#form_content').modal();
            } else if (view == 'claim_content') {
                this.cninsurance_claim = attr1;
                $('#claim_content').modal();
            } else if (view == 'complaint_content') {
                this.cninsurance_complaint = attr1;
                $('#complaint_content').modal();
            }
        },
        setGetComponentView: function setGetComponentView(view, attr) {
            this.component_view = {};
            this.component_view[view] = true;

            if (view == 'viewForm') {
                this.cninsurance_form = attr;
            }
            if (view == 'viewSubmittedForms') {
                this.getCNinsuranceForms();
            } else if (view == 'viewFiledClaims') {
                this.getCNinsuranceFiledClaims();
            } else if (view == 'viewFiledComplaints') {
                this.getCNinsuranceFiledComplaints();
            }
        },
        getCNinsuranceFiledComplaints: function getCNinsuranceFiledComplaints() {
            var _this2 = this;

            service.getCNinsurance(this).then(function (data) {
                if (data.body.status == 200) {
                    _this2.cninsurance_listings = data.body.data;
                }
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        },
        getCNinsuranceFiledClaims: function getCNinsuranceFiledClaims() {
            var _this3 = this;

            service.getCNinsurance(this).then(function (data) {
                if (data.body.status == 200) {
                    _this3.cninsurance_listings = data.body.data;
                }
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        },
        getCNinsuranceForms: function getCNinsuranceForms() {
            var _this4 = this;

            this.load_processes = true;
            service.getCNinsuranceForms(this, this.cninsurance.cninsurance_id).then(function (data) {
                if (data.body.status == 200) {
                    _this4.cninsurance_forms = data.body.data;
                    _this4.load_processes = false;
                }
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
                _this4.load_processes = false;
            });
        },
        getCNinsuranceListings: function getCNinsuranceListings() {
            var _this5 = this;

            this.setProcessLoading();
            service.getCNinsurance(this).then(function (data) {
                if (data.body.status == 200) {
                    _this5.cninsurance_listings = data.body.data;
                    _this5.setPanel('view', _this5.cninsurance_listings[0]);
                    _this5.stopProcessLoading();
                    _this5.load_processes = false;
                }
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        },
        editCNinsuranceDetails: function editCNinsuranceDetails() {
            var _this6 = this;

            this.setProcessLoading();
            if (this.cninsurance.cninsurance_name != '' && this.cninsurance.cninsurance_name != undefined) {
                service.updateCNinsuranceDetails(this, this.cninsurance.cninsurance_id, this.cninsurance).then(function (data) {
                    _this6.getCNinsuranceListings();
                    _this6.setComponentView('');
                }).catch(function (err) {
                    if (err) {}
                    _this6.getCNinsuranceListings();
                    _this6.setComponentAttributeView('');
                });
            }
        },
        setCNinsuraceFormPrice: function setCNinsuraceFormPrice(cninsurance, fv) {
            var _this7 = this;

            this.setProcessLoading();
            var payload = {
                cninsurance_price_id: fv.cninsurance_form_variable_price_id,
                cninsurance_new_price: fv.cninsurance_form_price
            };
            if (payload.cninsurance_new_price > 0) {
                service.updateCNinsuraceFormPrice(this, cninsurance.cninsurance_id, payload).then(function (data) {
                    if (data.body.status == 200) {
                        _this7.setComponentAttributeView('');
                    }
                    _this7.getCNinsuranceListings();
                }).catch(function (err) {
                    if (err) {}
                });
            }
        },
        addNewDiscount: function addNewDiscount() {
            var _this8 = this;

            this.data_processing_message = "";
            var payload = {
                cninsurance_discount_cninsurance: this.cninsurance.cninsurance_id,
                cninsurance_discount_code: this.cninsurance_discount.discount_code || "",
                cninsurance_discount_type: this.cninsurance_discount.discount_type || "C",
                cninsurance_discount_value: this.cninsurance_discount.discount_value || 0,
                cninsurance_discount_start_date: this.cninsurance_discount.discount_start_date || "",
                cninsurance_discount_expiry_date: this.cninsurance_discount.discount_expiry_date || ""
            };
            if (payload.cninsurance_discount_cninsurance > 0 && payload.cninsurance_discount_value > 0 && payload.cninsurance_discount_code != '' && payload.cninsurance_discount_start_date != '' && payload.cninsurance_discount_expiry_date != '') {
                this.setProcessLoading();
                service.addCNinsuranceDiscount(this, payload).then(function (data) {
                    if (data.body.status == 201) {
                        _this8.setComponentView('');
                    }
                    _this8.getCNinsuranceListings();
                }).catch(function (err) {
                    if (err) {
                        _this8.stopProcessLoading();
                    }
                });
            } else {
                this.data_processing_message = 'Please check details entered';
            }
        },
        updateDiscount: function updateDiscount(discount) {
            var _this9 = this;

            this.setProcessLoading();
            if (discount.cninsurance_discount_code != '' && discount.cninsurance_discount_code != undefined) {
                service.updateCNinsuranceDiscount(this, discount.cninsurance_discount_id, discount).then(function (data) {
                    _this9.getCNinsuranceListings();
                    _this9.setComponentAttributeView('');
                }).catch(function (err) {
                    if (err) {}
                    _this9.getCNinsuranceListings();
                    _this9.setComponentAttributeView('');
                });
            }
        }
    },
    created: function created() {
        this.preset();
        this.getCNinsuranceListings();
    }
});

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Main_Header_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Main_Header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Main_Header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue__);




var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'CNpayments',
    data: function data() {
        return {
            admin: {},
            cnpayments: {},
            cnpayment: {},
            panelFlag: false,
            viewFlag: false
        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__Main_Header_index_vue___default.a,
        'component-sidebar': __WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue___default.a
    },
    methods: {
        setPanel: function setPanel(attr, attr2) {
            this.panelFlag = true;
            if (attr == "view") {
                this.viewFlag = true;
                this.cnpayment = attr2;
            }
        },
        isActive: function isActive(index) {
            if (index == 1) {
                return "active";
            }
        },
        preset: function preset() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("cityneeds_a_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.admin.admin_id = element.admin_id;
                        }, _this);
                    } else {
                        _this.$router.push('/');
                    }
                }).catch(function (err) {
                    if (err) {
                        _this.$router.push('/');
                    }
                });
            } else {
                this.$router.push('/');
            }
        },
        getCNpayments: function getCNpayments() {
            var _this2 = this;

            service.getCNpaymentsPaga(this).then(function (data) {
                if (data.body.status == 200) {
                    _this2.cnpayments = data.body.data;
                }
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        }
    },
    created: function created() {
        this.preset();
        this.getCNpayments();
    }
});

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Main_Header_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Main_Header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Main_Header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue__);




var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'CNpayments',
    data: function data() {
        return {
            admin: {},
            cnpayments: {},
            cnpayment: {},
            panelFlag: false,
            viewFlag: false
        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__Main_Header_index_vue___default.a,
        'component-sidebar': __WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue___default.a
    },
    methods: {
        setPanel: function setPanel(attr, attr2) {
            this.panelFlag = true;
            if (attr == "view") {
                this.viewFlag = true;
                this.cnpayment = attr2;
            }
        },
        isActive: function isActive(index) {
            if (index == 1) {
                return "active";
            }
        },
        preset: function preset() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("cityneeds_a_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.admin.admin_id = element.admin_id;
                        }, _this);
                    } else {
                        _this.$router.push('/');
                    }
                }).catch(function (err) {
                    if (err) {
                        _this.$router.push('/');
                    }
                });
            } else {
                this.$router.push('/');
            }
        },
        getCNpayments: function getCNpayments() {
            var _this2 = this;

            service.getCNpayments(this).then(function (data) {
                if (data.body.status == 200) {
                    _this2.cnpayments = data.body.data;
                }
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        }
    },
    created: function created() {
        this.preset();
        this.getCNpayments();
    }
});

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Main_Header_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Main_Header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Main_Header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue__);




var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'CNpayments',
    data: function data() {
        return {
            admin: {},
            transactions: {},
            transaction: {},
            todays_count: 0,
            panelFlag: false,
            viewFlag: false
        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__Main_Header_index_vue___default.a,
        'component-sidebar': __WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue___default.a
    },
    methods: {
        setPanel: function setPanel(attr, attr2) {
            this.panelFlag = true;
            if (attr == "view") {
                this.viewFlag = true;
                this.transaction = attr2;
            }
        },
        isActive: function isActive(index) {
            if (index == 1) {
                return "active";
            }
        },
        preset: function preset() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("cityneeds_a_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.admin.admin_id = element.admin_id;
                        }, _this);
                    } else {
                        _this.$router.push('/');
                    }
                }).catch(function (err) {
                    if (err) {
                        _this.$router.push('/');
                    }
                });
            } else {
                this.$router.push('/');
            }
        },
        getTransactions: function getTransactions() {
            var _this2 = this;

            service.getTransactions(this).then(function (data) {
                if (data.body.status == 200) {
                    _this2.transactions = data.body.data;
                    _this2.todays_count = data.body.data_count_today;
                }
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        }
    },
    created: function created() {
        this.preset();
        this.getTransactions();
    }
});

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Main_Header_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Main_Header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Main_Header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue__);




var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Cnpros',
    data: function data() {
        return {
            admin: {},
            categories: {},
            category: {},
            sub_categories: {},
            sub_category: {},
            img_url: service.imageURL,
            deleteRequest: false,
            editRequest: false,
            addRequest: false,
            addSubRequest: false,
            disable_btn: false
        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__Main_Header_index_vue___default.a,
        'component-sidebar': __WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue___default.a
    },
    methods: {
        setComponent: function setComponent(attr, attr2) {
            this.panelFlag = true;
            if (attr == "add") {
                this.category = {};
                this.addRequest = true;
            }
            if (attr == "add_sub") {
                this.category = attr2;
                this.sub_category = {};
                this.addSubRequest = true;
            }
            if (attr == "edit") {
                this.category = {};
                this.category = attr2;
                this.category.editRequest = true;
            }
            if (attr == "edit_sub") {
                this.sub_category = {};
                this.sub_category = attr2;
                this.sub_category.editRequest = true;
            }
            if (attr == "reset-action") {
                this.category = {};
                this.sub_category = {};
                this.category.editRequest = false;
                this.sub_category.editRequest = false;
            }
        },
        preset: function preset() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("cityneeds_a_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.admin.admin_id = element.admin_id;
                        }, _this);
                    } else {
                        _this.$router.push('/');
                    }
                }).catch(function (err) {
                    if (err) {
                        _this.$router.push('/');
                    }
                });
            } else {
                this.$router.push('/');
            }
        },
        addCnproParentCategory: function addCnproParentCategory() {
            var _this2 = this;

            service.addCnproParentCategory(this, this.category).then(function (data) {
                if (data.body.status == 201) {
                    _this2.getCnproParentCategories();
                }
                _this2.addRequest = false;
                _this2.category = {};
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        },
        addCnproSubCategory: function addCnproSubCategory() {
            var _this3 = this;

            this.sub_category.parent_id = this.category.cnpro_parent_category_id;
            console.log(this.sub_category.parent_id);
            service.addCnproSubCategory(this, this.sub_category).then(function (data) {
                if (data.body.status == 201) {
                    _this3.getCnproSubCategories();
                }
                _this3.addSubRequest = false;
                _this3.sub_category = {};
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        },
        getCnproParentCategories: function getCnproParentCategories() {
            var _this4 = this;

            service.getCnproParentCategories(this).then(function (data) {
                if (data.body.status == 200) {
                    _this4.categories = data.body.data;
                }
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        },
        getCnproSubCategories: function getCnproSubCategories() {
            var _this5 = this;

            service.getCnproSubCategories(this).then(function (data) {
                if (data.body.status == 200) {
                    _this5.sub_categories = data.body.data;
                }
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        },
        editCnproParentCategories: function editCnproParentCategories() {
            var _this6 = this;

            service.editCnproParentCategories(this, this.category.cnpro_parent_category_id, this.category).then(function (data) {
                if (data.body.status == 200) {
                    _this6.getCnproParentCategories();
                    _this6.category.editRequest = false;
                }
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        },
        editCnproSubCategories: function editCnproSubCategories() {
            var _this7 = this;

            service.editCnproSubCategories(this, this.sub_category.cnpro_category_id, this.sub_category).then(function (data) {
                if (data.body.status == 200) {
                    _this7.getCnproParentCategories();
                    _this7.sub_category.editRequest = false;
                }
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        }
    },
    created: function created() {
        this.preset();
        this.getCnproParentCategories();
        this.getCnproSubCategories();
    }
});

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Main_Header_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Main_Header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Main_Header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue__);




var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Users',
    data: function data() {
        return {
            admin: {},
            users: {},
            wallet_transactions: {},
            wallet_transaction: {},
            total_wallet_balance: 0,
            disable_btn: false
        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__Main_Header_index_vue___default.a,
        'component-sidebar': __WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue___default.a
    },
    methods: {
        isActive: function isActive(index) {
            if (index == 1) {
                return "active";
            }
        },
        preset: function preset() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("cityneeds_a_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.admin.admin_id = element.admin_id;
                        }, _this);
                    } else {
                        _this.$router.push('/');
                    }
                }).catch(function (err) {
                    if (err) {
                        _this.$router.push('/');
                    }
                });
            } else {
                this.$router.push('/');
            }
        },
        setWalletTransaction: function setWalletTransaction(txn) {
            this.wallet_transaction = txn;
        },
        getWalletTransactions: function getWalletTransactions() {
            var _this2 = this;

            service.getWalletTransactions(this).then(function (data) {
                if (data.body.status == 200) {
                    _this2.total_wallet_balance = data.body.total_wallet_balance;
                }
                _this2.wallet_transactions = data.body.data;
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        },
        formatCurrency: function formatCurrency(currency) {
            currency = Intl.NumberFormat('en-US', { style: 'currency', currency: 'NGN' }).format(currency);
            return currency.replace("NGN", "");
        }
    },
    created: function created() {
        this.preset();
        this.getWalletTransactions();
    }
});

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Main_Header_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Main_Header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Main_Header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue__);




var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Cnpros',
    data: function data() {
        return {
            admin: {},
            cnpros: {},
            cnpro: {},
            viewFlag: "",
            img_url: service.imageURL,
            deleteRequest: false,
            editRequest: false
        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__Main_Header_index_vue___default.a,
        'component-sidebar': __WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue___default.a
    },
    methods: {
        setPanel: function setPanel(attr, attr2) {
            this.panelFlag = true;
            if (attr == "view") {
                this.viewFlag = true;
                this.cnpro = attr2;
            }
        },
        requests: function requests(req) {
            if (req == "delete") {
                this.deleteRequest = true;
            }
            if (req == "edit") {
                this.editRequest = true;
            }
            if (req == "reset") {
                this.editRequest = false;this.deleteRequest = false;
            }
        },
        preset: function preset() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("cityneeds_a_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.admin.admin_id = element.admin_id;
                        }, _this);
                    } else {
                        _this.$router.push('/');
                    }
                }).catch(function (err) {
                    if (err) {
                        _this.$router.push('/');
                    }
                });
            } else {
                this.$router.push('/');
            }
        },
        getCnpros: function getCnpros() {
            var _this2 = this;

            service.getAllCnpros(this).then(function (data) {
                if (data.body.status == 200) {
                    _this2.cnpros = data.body.data;
                }
            });
        },
        approveCnpro: function approveCnpro(cnpro) {
            var _this3 = this;

            service.approveCnpro(this, cnpro, this.cnpro).then(function (data) {
                if (data.body.status == 200) {
                    toastr.success("Approved!", "Success!");
                    _this3.cnpro.cnpro_status_id = 13;
                    _this3.cnpro.cnpro_status = "Approved";
                } else {
                    toastr.error('Sorry, could not approve', 'Warning!');
                }
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        },
        editListing: function editListing() {
            var _this4 = this;

            service.adminEditCnpros(this, this.cnpro.cnpro_id, this.cnpro).then(function (data) {
                if (data.body.status == 200) {
                    toastr.success('Updated', 'Warning!');
                    _this4.editRequest = false;
                }
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        },
        deleteListing: function deleteListing() {
            service.adminDeleteCnpros(this, this.cnpro.cnpro_id).then(function (data) {
                if (data.body.status == 200) {
                    toastr.success('Removed', 'Warning!');
                    location.reload(true);
                }
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        },
        getMoney: function getMoney(id) {
            var _this5 = this;

            service.getMoney(this, id).then(function (data) {
                if (data.body.status == 200) {
                    _this5.money = data.body.data;
                }
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        },
        onFileChange: function onFileChange(e, data, type) {
            var _this6 = this;

            var files = e.target.files || e.dataTransfer.files;
            if (files.length) {
                var formData = new FormData();
                formData.append('photo', files[0]);
                formData.append('data_id', data);
                formData.append('data_type', type);
                service.uploadDataPhoto(this, formData).then(function (data) {
                    if (data.body.status == 200) {
                        if (type == 'cnpros') {
                            _this6.cnpro.cnpro_image = data.body.data;
                        }
                        if (type == 'cnpros_id_card') {
                            _this6.cnpro.cnpro_identity_card = data.body.data;
                        }
                    }
                }).catch(function (err) {
                    if (err) {}
                });
            }
        }
    },
    created: function created() {
        this.preset();
        this.getCnpros();
    }
});

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Main_Header_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Main_Header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Main_Header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue__);




var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Cnsurveys',
    data: function data() {
        return {
            admin: {},
            cnsurveys: {},
            cnsurvey: {},
            activation_fee: 0,
            viewFlag: "",
            setDeleteSurvey: false
        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__Main_Header_index_vue___default.a,
        'component-sidebar': __WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue___default.a
    },
    methods: {
        setPanel: function setPanel(attr, attr2) {
            this.panelFlag = true;
            if (attr == "view") {
                this.viewFlag = true;
                this.cnsurvey = attr2;
            }
            if (attr == "setDelete") {
                this.setDeleteSurvey = true;
            }
        },
        isActive: function isActive(index) {
            if (index == 1) {
                return "active";
            }
        },
        preset: function preset() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("cityneeds_a_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.admin.admin_id = element.admin_id;
                        }, _this);
                    } else {
                        _this.$router.push('/');
                    }
                }).catch(function (err) {
                    if (err) {
                        _this.$router.push('/');
                    }
                });
            } else {
                this.$router.push('/');
            }
        },
        getCnsurveys: function getCnsurveys() {
            var _this2 = this;

            service.getSurveys(this).then(function (data) {
                if (data.body.status == 200) {
                    _this2.cnsurveys = data.body.data;
                }
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        },
        approveSurvey: function approveSurvey(survey) {
            var _this3 = this;

            service.approveSurvey(this, survey, this.cnsurvey).then(function (data) {
                if (data.body.status == 200) {
                    toastr.success("Approved!", "Success!");
                    _this3.cnsurvey.cnsurvey_status = 13;
                    _this3.cnsurvey.cnsurvey_status_name = "Approved";
                } else {
                    toastr.error('Sorry, could not approve', 'Warning!');
                }
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        },
        setActivationFee: function setActivationFee() {
            this.cnsurvey.cnsurvey_activation_fee = this.activation_fee;
            service.setActivationFee(this, this.cnsurvey.cnsurvey_id, this.cnsurvey).then(function (data) {
                if (data.body.status == 200) {
                    toastr.success("Set!", "Success!");
                } else {
                    toastr.error('Sorry, could not approve', 'Warning!');
                }
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        },
        deleteSurvey: function deleteSurvey() {
            var _this4 = this;

            service.deleteSurvey(this, this.cnsurvey.cnsurvey_id).then(function (response) {
                if (response.body.status = 200) {
                    _this4.cnsurvey = [];_this4.viewFlag = false;
                    toastr.success("Survey Deleted", 'Successful');

                    _this4.$router.go('/cnsurveys');
                } else {
                    toastr.warning("Couldn't complete action, kindly try again", 'Warning!');
                }
            });
        }
    },
    created: function created() {
        this.preset();
        this.getCnsurveys();
    }
});

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Main_Header_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Main_Header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Main_Header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue__);




var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Contracts',
    data: function data() {
        return {
            admin: {},
            contracts: {},
            contract: {},
            panelFlag: false,
            viewFlag: false,
            viewDiscussion: false,
            viewComplaints: false
        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__Main_Header_index_vue___default.a,
        'component-sidebar': __WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue___default.a
    },
    methods: {
        setPanel: function setPanel(attr, attr2) {
            this.panelFlag = true;
            if (attr == "view") {
                this.viewFlag = true;
                this.viewDiscussion = false;
                this.viewComplaints = false;

                this.getContract(attr2);
            }
            if (attr == "viewDiscussion") {
                this.viewFlag = false;
                this.viewDiscussion = true;
                this.viewComplaints = false;
            }
            if (attr == "viewComplaints") {
                this.viewFlag = false;
                this.viewDiscussion = false;
                this.viewComplaints = true;
            }
        },
        isActive: function isActive(index) {
            if (index == 1) {
                return "active";
            }
        },
        preset: function preset() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("cityneeds_a_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.admin.admin_id = element.admin_id;
                        }, _this);
                    } else {
                        _this.$router.push('/');
                    }
                }).catch(function (err) {
                    if (err) {
                        _this.$router.push('/');
                    }
                });
            } else {
                this.$router.push('/');
            }
        },
        getContracts: function getContracts() {
            var _this2 = this;

            service.getContracts(this).then(function (data) {
                if (data.body.status == 200) {
                    _this2.contracts = data.body.data;
                }
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        },
        getContract: function getContract(id) {
            var _this3 = this;

            service.getContract(this, id).then(function (data) {
                if (data.body.status == 200) {
                    _this3.contract = data.body.data;
                }
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        },
        getMoney: function getMoney(id) {
            var _this4 = this;

            service.getMoney(this, id).then(function (data) {
                if (data.body.status == 200) {
                    _this4.money = data.body.data;
                }
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        },
        endContract: function endContract() {
            var navi = this.$router;
            service.endContract(this, this.contract.contract_id, this.contract).then(function (data) {
                if (data.body.status == 200) {
                    toastr.success("Contract Ended!", "Success!");
                    location.reload();
                } else {
                    toastr.error('Sorry, could not end contract', 'Warning!');
                }
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        }
    },
    created: function created() {
        this.preset();
        this.getContracts();
    }
});

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Main_Header_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Main_Header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Main_Header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Sidebar_index_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Sidebar_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Sidebar_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Main_Footer_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Main_Footer_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Main_Footer_index_vue__);





var service = new __WEBPACK_IMPORTED_MODULE_1__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Dashboard',
    data: function data() {
        return {
            activities: {},
            searches: {},
            search: {},
            users: {},
            cnpros: {},
            cnpro: {},
            businesses: [],
            cnsurvey: {},
            forums: {},
            reviews: {},
            img_url: service.imageURL
        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_2__Main_Header_index_vue___default.a,
        'component-sidebar': __WEBPACK_IMPORTED_MODULE_3__Sidebar_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_4__Main_Footer_index_vue___default.a
    },
    methods: {
        doSearch: function doSearch() {
            var credentials = {
                search_type: this.search.type,
                search_keywords: this.search.keywords,
                search_city: this.search.city
            };

            var navi = this.$router;

            if (credentials.search_type != null || credentials.search_keywords != null) {
                if (credentials.search_type == "businesses") {
                    localStorage.setItem("cityneeds_search_type", this.search.type);
                    localStorage.setItem("cityneeds_search_keywords", this.search.keywords);
                    localStorage.setItem("cityneeds_search_city", this.search.city);
                    navi.push("business-search");
                } else if (credentials.search_type == "cnpros") {
                    localStorage.setItem("cityneeds_search_type", this.search.type);
                    localStorage.setItem("cityneeds_search_keywords", this.search.keywords);
                    localStorage.setItem("cityneeds_search_city", this.search.city);
                    navi.push("cnpro-search");
                }
            } else {
                toastr.error('Kindly fill all fields', 'Warning!');
            }
        },
        doSearch2: function doSearch2(category) {
            var navi = this.$router;
            localStorage.setItem("cityneeds_search_type", 'cnpros');
            localStorage.setItem("cityneeds_search_keywords", category);
            localStorage.setItem("cityneeds_search_city", 'Abuja');
            navi.push("cnpro-search");
        },
        viewCnpro: function viewCnpro(cnpro) {
            if (cnpro) {
                localStorage.setItem("cityneeds_search_cnpro", cnpro.cnpro_data_item);
                this.$router.push("cnpro");
            }
        },
        getUsers: function getUsers() {
            var _this = this;

            service.getUsers(this).then(function (data) {
                if (data.body.status == 200) {
                    _this.users = data.body.data;
                }
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        },
        getCnpros: function getCnpros() {
            var _this2 = this;

            service.getAllCnpros(this).then(function (data) {
                if (data.body.status == 200) {
                    _this2.cnpros = data.body.data;
                }
            }).catch(function (err) {
                if (err) {}
            });
        },
        viewBusiness: function viewBusiness(business) {
            if (business) {
                localStorage.setItem("cityneeds_search_business", business.business_data_item);
                this.$router.push("businesses");
            }
        },
        getBusinesses: function getBusinesses() {
            var _this3 = this;

            service.getAllBusinesses(this).then(function (data) {
                if (data.body.status == 200) {
                    _this3.businesses = data.body.data;
                }
            }).catch(function (err) {
                if (err) {}
            });
        },
        getForums: function getForums() {
            var _this4 = this;

            service.getAllForums(this).then(function (data) {
                if (data.body.status == 200) {
                    _this4.forums = data.body.data;
                }
            }).catch(function (err) {
                if (err) {}
            });
        },
        getReviews: function getReviews() {
            var _this5 = this;

            service.getAllReviews(this).then(function (data) {
                if (data.body.status == 200) {
                    _this5.reviews = data.body.data;
                }
            }).catch(function (err) {
                if (err) {}
            });
        },
        getActivities: function getActivities() {
            var _this6 = this;

            service.getActivities(this).then(function (data) {
                if (data.body.status == 200) {
                    _this6.activities = data.body.data;
                }
            }).catch(function (err) {
                if (err) {}
            });
        },
        getPagaServicesRemoteXX: function getPagaServicesRemoteXX() {
            var _this7 = this;

            service.pagaGetMerchants(this).then(function (response) {
                service.postPagaMerchants(_this7, response.body.billers).then(function (response) {}).catch(function (err) {
                    _this7.loading = false;
                });
            }).catch(function (err) {
                _this7.loading = false;
            });

            service.pagaGetMobileOperators(this).then(function (response) {
                service.postPagaMobileOperators(_this7, response.body.operators).then(function (response) {}).catch(function (err) {
                    _this7.loading = false;
                });
            }).catch(function (err) {
                _this7.loading = false;
            });
        },
        getPagaServicesRemote: function getPagaServicesRemote() {
            var _this8 = this;

            var seek_url = service.paga_apiBaseUrl + 'getMerchants';
            var payload = {
                "referenceNumber": this.getDefaultRandomNumbers()
            };
            var hash = service.SHA512(payload.referenceNumber + service.paga_apiKey);
            service.getPagaRequest(this, payload, seek_url, hash).then(function (data) {
                if (data.body.responseCode == 0) {
                    var data_load = [];
                    var load = data.body.merchants;
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(load), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var item = _step.value;

                            data_load.push(item);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }
                        } finally {
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }

                    service.postPagaMerchants(_this8, data_load).then(function (response) {}).catch(function (err) {
                        _this8.loading = false;
                    });
                }
            }).catch(function (err) {
                _this8.loading = false;
            });

            var seek_url_2 = service.paga_apiBaseUrl + 'getMobileOperators';
            var payload = {
                "referenceNumber": this.getDefaultRandomNumbers()
            };
            var hash_2 = service.SHA512(payload.referenceNumber + service.paga_apiKey);
            service.getPagaRequest(this, payload, seek_url_2, hash_2).then(function (data) {
                if (data.body.responseCode == 0) {
                    var data_load = [];
                    var load = data.body.mobileOperator;
                    var _iteratorNormalCompletion2 = true;
                    var _didIteratorError2 = false;
                    var _iteratorError2 = undefined;

                    try {
                        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(load), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                            var item = _step2.value;

                            data_load.push(item);
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                _iterator2.return();
                            }
                        } finally {
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }

                    service.postPagaMobileOperators(_this8, data_load).then(function (response) {}).catch(function (err) {
                        _this8.loading = false;
                    });
                }
            }).catch(function (err) {
                _this8.loading = false;
            });
        },
        getDefaultRandomNumbers: function getDefaultRandomNumbers() {
            return Math.floor(100000000 + Math.random() * 900000000);
        }
    },
    created: function created() {
        this.getUsers();
        this.getCnpros();
        this.getBusinesses();
        this.getForums();
        this.getReviews();
        this.getActivities();
        this.getPagaServicesRemote();
    }
});

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Main_Header_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Main_Header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Main_Header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue__);




var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Forums',
    data: function data() {
        return {
            admin: {},
            forums: {},
            forum: {},
            viewFlag: "",
            setDeleteForum: false,
            setDeleteForumComment: false,
            img_url: service.imageURL
        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__Main_Header_index_vue___default.a,
        'component-sidebar': __WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue___default.a
    },
    methods: {
        setPanel: function setPanel(attr, attr2) {
            this.panelFlag = true;
            if (attr == "viewAll") {
                this.viewFlag = false;
            }
            if (attr == "view") {
                this.viewFlag = true;
                this.forum = attr2;
            }
            if (attr == "delete-forum") {
                this.setDeleteForum = true;
            }
            if (attr == "delete-forum-comment") {
                this.setDeleteForumComment = true;
            }
        },
        isActive: function isActive(index) {
            if (index == 1) {
                return "active";
            }
        },
        preset: function preset() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("cityneeds_a_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.admin.admin_id = element.admin_id;
                        }, _this);
                    } else {
                        _this.$router.push('/');
                    }
                }).catch(function (err) {
                    if (err) {
                        _this.$router.push('/');
                    }
                });
            } else {
                this.$router.push('/');
            }
        },
        getForums: function getForums() {
            var _this2 = this;

            service.getAllForums(this).then(function (data) {
                if (data.body.status == 200) {
                    _this2.forums = data.body.data;
                }
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        },
        deleteForum: function deleteForum() {
            var _this3 = this;

            service.deleteForum(this, this.forum.forum_id).then(function (response) {
                if (response.body.status = 200) {
                    _this3.forum = [];_this3.viewFlag = false;
                    toastr.success("Forum Deleted", 'Successful');
                    _this3.setDeleteForum = false;
                } else {
                    toastr.warning("Couldn't complete action, kindly try again", 'Warning!');
                }
            });
        },
        deleteForumComment: function deleteForumComment(forum_comment_id) {
            var _this4 = this;

            service.deleteForumComment(this, forum_comment_id).then(function (response) {
                if (response.body.status = 200) {
                    toastr.success("Discussion Deleted", 'Successful');
                    var index = _this4.forum.forum_comments.findIndex(function (fc) {
                        return fc.forum_comment_id === forum_comment_id;
                    });
                    _this4.forum.forum_comments.splice(index, 1);
                } else {
                    toastr.warning("Couldn't complete action, kindly try again", 'Warning!');
                }
            });
        }
    },
    created: function created() {
        this.preset();
        this.getForums();
    }
});

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Second_Header_index_vue__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Second_Header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Second_Header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Main_Footer_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Main_Footer_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Main_Footer_index_vue__);



var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Login',
    data: function data() {
        return {
            admin: {},
            setForgetPasswordPanel: false,
            setResetPasswordPanel: false,
            setActionPanel: false,
            loading: false,
            disable_btn: false,
            mod_message: "nill"
        };
    },

    components: {
        'second-header': __WEBPACK_IMPORTED_MODULE_1__Second_Header_index_vue___default.a,
        'main-footer': __WEBPACK_IMPORTED_MODULE_2__Main_Footer_index_vue___default.a
    },
    methods: {
        setComponent: function setComponent(attr1, attr2) {
            if (attr1 == "set_forgot") {
                this.setActionPanel = true;
                this.setForgetPasswordPanel = true;
            }
        },
        reset: function reset() {
            var _this = this;

            localStorage.removeItem("cityneeds_a_user");
            localStorage.removeItem("cityneeds_a_token");
            localStorage.removeItem("cityneeds_a_token_key");

            var navi = this.$router;
            if (this.$route.query.resetPassword) {
                service.verifyResetToken(this, this.$route.query.resetPassword).then(function (response) {
                    if (response.status == 200) {
                        _this.setActionPanel = true;
                        _this.setResetPasswordPanel = true;
                        _this.admin.user_id = response.body.data;
                        navi.push('login');
                    }
                }).catch(function (err) {
                    toastr.warning("Authentication Failed", 'Warning!');
                    if (err.status == 400) {
                        _this.mod_message = "Something went wrong with the process, please try again";
                    } else {
                        navi.push('login');
                    }
                });
            } else {
                navi.push('login');
            }
        },
        login: function login() {
            var _this2 = this;

            this.disable_btn = true;
            this.loading = true;
            var credentials = {
                admin_email: this.admin.email,
                admin_password: this.admin.password
            };
            var navi = this.$router;
            if (credentials.admin_email == null || credentials.admin_email == undefined || credentials.admin_email == '') {
                toastr.warning("Kindly enter email", 'Warning!');
            } else if (credentials.admin_password == null || credentials.admin_password == undefined || credentials.admin_password == '') {
                toastr.warning("Kindly enter password", 'Warning!');
            } else {
                service.loginAdmin(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            localStorage.setItem("cityneeds_a_user", element.admin_fullname);
                            localStorage.setItem("cityneeds_a_token", element.admin_session_key);
                            localStorage.setItem("cityneeds_a_token_key", element.admin_token_key);
                        }, _this2);
                        navi.push('dashboard');
                    } else {
                        toastr.warning("invalid login credentials", 'Warning!');
                        _this2.disable_btn = false;
                        _this2.loading = false;
                    }
                }).catch(function (err) {
                    if (err.status == 404) {
                        toastr.warning("invalid login credentials", 'Warning!');
                        _this2.disable_btn = false;
                    }
                });
            }
        },
        forgotPassword: function forgotPassword() {
            var _this3 = this;

            this.disable_btn = true;
            this.loading = true;
            var credentials = {
                email: this.admin.email
            };

            if (credentials.email == null || credentials.email == undefined || credentials.email == '') {
                toastr.warning("Kindly enter email", 'Warning!');
            } else {
                service.forgotPassword(this, credentials).then(function (response) {
                    if (response.status == 200) {
                        _this3.mod_message = "Request sent, please check your mail to reset password";
                        _this3.admin = {};
                        _this3.setForgetPasswordPanel = false;
                        _this3.disable_btn = false;
                        _this3.loading = false;
                    }
                }).catch(function (err) {
                    if (err.status == 404) {
                        toastr.warning("Email not valid", 'Warning!');
                    }
                    _this3.disable_btn = false;
                    _this3.loading = false;
                });
            }
        },
        resetPassword: function resetPassword() {
            var _this4 = this;

            var credentials = {
                new_password: this.admin.new_password,
                confirm_password: this.admin.confirm_password,
                user: this.admin.user_id
            };
            var navi = this.$router;
            if (credentials.new_password == '' || credentials.confirm_password == '') {
                toastr.warning("Kindly enter password", 'Warning!');
            } else if (credentials.new_password != credentials.confirm_password) {
                toastr.warning("Passwords does not match", 'Warning!');
            } else {
                service.resetForgotPassword(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        _this4.can_reset = false;
                        _this4.can_login = true;
                        toastr.success("Password has been Reset", 'Changed!');
                        navi.push('login');
                    }
                }).catch(function (err) {
                    if (err.status == 404) {
                        toastr.warning("invalid credentials", 'Warning!');
                    }
                });
            }
        }
    },
    created: function created() {
        this.reset();
    }
});

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);

var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: "MainFooter",
    data: function data() {
        return {
            user: {},
            user_slug: {}
        };
    }
});

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);

var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: "MainHeader",
    data: function data() {
        return {
            user: '',
            user_slug: {},
            hide: false
        };
    },

    methods: {
        getUser: function getUser() {
            var u = localStorage.getItem("cityneeds_user");
            if (u != null) {
                this.user = u;
                this.user_slug = u.replace(" ", "_");
            }
        },
        isActive: function isActive(page) {
            if (page == localStorage.getItem("cn_a_current_page")) {
                return "true";
            }
        },
        toggle_sidebar_mobile: function toggle_sidebar_mobile() {
            $('#sideToggle').toggle();
        },
        toggle_sidebar: function toggle_sidebar() {
            $('#sideToggle').toggle(function () {
                if (this.hide) {
                    $('#main-content').css('margin-left', '240px');
                    this.hide = false;
                } else {
                    $('#main-content').css('margin-left', '-10px');
                    this.hide = true;
                }
            });
        }
    },
    created: function created() {
        this.getUser();
        localStorage.setItem("cn_a_current_page", this.$route.path);
    }
});

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Main_Header_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Main_Header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Main_Header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lolex__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lolex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lolex__);





var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Messages',
    data: function data() {
        return {
            admin: {},
            messages: {},
            message: {},
            subscribers: {},
            notification: {},
            notifications: {},
            page_view: 'messages',
            panelFlag: false,
            viewFlag: false,
            disable_btn: false,
            data_message_error: "",
            file_info: {},
            imageForm: "",
            show_notification_form: false,
            setDelete: 0
        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__Main_Header_index_vue___default.a,
        'component-sidebar': __WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue___default.a
    },
    methods: {
        setPanel: function setPanel(attr, attr2) {
            this.panelFlag = true;
            if (attr == "view") {
                this.viewFlag = true;
                this.cnpayment = attr2;
            }
        },
        setPageView: function setPageView(view) {
            this.page_view = view;
        },
        isActive: function isActive(index) {
            if (index == 1) {
                return "active";
            }
        },
        preset: function preset() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("cityneeds_a_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.admin.admin_id = element.admin_id;
                        }, _this);
                    } else {
                        _this.$router.push('/');
                    }
                }).catch(function (err) {
                    if (err) {
                        _this.$router.push('/');
                    }
                });
            } else {
                this.$router.push('/');
            }
        },
        getMessages: function getMessages() {
            var _this2 = this;

            service.getMessages(this).then(function (data) {
                if (data.body.status == 200) {
                    _this2.messages = data.body.data;
                    _this2.readMessages();
                }
            }).catch(function (err) {
                if (err) {}
            });
        },
        readMessages: function readMessages() {
            service.readMessages(this).then(function (data) {}).catch(function (err) {});
        },
        getSubscribers: function getSubscribers() {
            var _this3 = this;

            service.getSubscribers(this).then(function (data) {
                if (data.body.status == 200) {
                    _this3.subscribers = data.body.data;
                }
            }).catch(function (err) {
                if (err) {}
            });
        },
        getNotifications: function getNotifications() {
            var _this4 = this;

            service.getAdminNotifications(this).then(function (data) {
                if (data.body.status == 200) {
                    _this4.notifications = data.body.data;
                }
            }).catch(function (err) {
                if (err) {}
            });
        },
        sendNotification: function sendNotification() {
            var _this5 = this;

            this.disable_btn = true;
            this.data_message_error = "";
            if (this.notification.notification_subject != '' && this.notification.notification_message != '' && this.notification.notification_subject != undefined && this.notification.notification_message != undefined) {
                service.postNotifications(this, this.notification).then(function (data) {
                    if (data.body.status == 201) {
                        var data_id = data.body.data_id;
                        _this5.imageForm.append("data_id", data_id);
                        _this5.imageForm.append("data_type", "notifications");
                        service.uploadDataPhoto(_this5, _this5.imageForm).then(function (xdata) {
                            if (xdata.body.status == 200) {
                                _this5.pushNotification(data_id);
                            }
                        }).catch(function (err) {});
                    }
                }).catch(function (err) {
                    if (err) {
                        _this5.disable_btn = false;
                    }
                });
            } else {
                this.data_message_error = "Please enter Subject and Message";
                this.disable_btn = false;
            }
        },
        onFileChange: function onFileChange(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (files.length) {
                this.file_info = files;
                var formData = new FormData();
                formData.append('photo', files[0]);
                this.imageForm = formData;
            }
        },
        pushNotification: function pushNotification(id) {
            var _this6 = this;

            service.pushNotifications(this, id).then(function (data) {
                if (data.body.status == 200) {
                    _this6.disable_btn = false;
                    _this6.data_message_error = "Notification Sent";
                    toastr.succes('Pushed Notification', 'Warning!');
                }
            }).catch(function (err) {
                if (err) {
                    _this6.disable_btn = false;
                }
            });
        },
        deleteNotification: function deleteNotification(id) {
            var _this7 = this;

            this.disable_btn = true;
            service.deleteNotifications(this, id).then(function (data) {
                if (data.body.status == 200) {
                    _this7.notifications = data.body.data;
                    _this7.disable_btn = false;
                    _this7.setDelete = 0;
                    toastr.succes('Notification Deleted', 'Warning!');
                }
            }).catch(function (err) {
                if (err) {
                    _this7.disable_btn = false;
                }
            });
        }
    },
    created: function created() {
        this.preset();
        this.getMessages();
        this.getSubscribers();
        this.getNotifications();
    }
});

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Main_Header_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Main_Header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Main_Header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue__);




var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Payments',
    data: function data() {
        return {
            admin: {},
            payments: {},
            payment: {},
            panelFlag: false,
            viewFlag: false
        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__Main_Header_index_vue___default.a,
        'component-sidebar': __WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue___default.a
    },
    methods: {
        setPanel: function setPanel(attr, attr2) {
            this.panelFlag = true;
            if (attr == "view") {
                this.viewFlag = true;
                this.payment = attr2;
            }
        },
        isActive: function isActive(index) {
            if (index == 1) {
                return "active";
            }
        },
        preset: function preset() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("cityneeds_a_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.admin.admin_id = element.admin_id;
                        }, _this);
                    } else {
                        _this.$router.push('/');
                    }
                }).catch(function (err) {
                    if (err) {
                        _this.$router.push('/');
                    }
                });
            } else {
                this.$router.push('/');
            }
        },
        getPayments: function getPayments() {
            var _this2 = this;

            service.getPayments(this).then(function (data) {
                if (data.body.status == 200) {
                    _this2.payments = data.body.data;
                }
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        },
        payMoney: function payMoney() {
            var navi = this.$router;
            service.updateMoniesPayOut(this, this.payment.contract_money_id, this.payment).then(function (data) {
                if (data.body.status == 200) {
                    toastr.success("Paid!", "Success!");
                    location.reload();
                } else {
                    toastr.error('Sorry, could not end contract', 'Warning!');
                }
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        }
    },
    created: function created() {
        this.preset();
        this.getPayments();
    }
});

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Main_Header_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Main_Header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Main_Header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue__);




var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Users',
    data: function data() {
        return {
            admin: {},
            users: {},
            referrals: {},
            total_referrals: 0,
            disable_btn: false
        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__Main_Header_index_vue___default.a,
        'component-sidebar': __WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue___default.a
    },
    methods: {
        isActive: function isActive(index) {
            if (index == 1) {
                return "active";
            }
        },
        preset: function preset() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("cityneeds_a_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.admin.admin_id = element.admin_id;
                        }, _this);
                    } else {
                        _this.$router.push('/');
                    }
                }).catch(function (err) {
                    if (err) {
                        _this.$router.push('/');
                    }
                });
            } else {
                this.$router.push('/');
            }
        },
        setreferralTransaction: function setreferralTransaction(txn) {
            this.referral_transaction = txn;
        },
        getReferralsTransactions: function getReferralsTransactions() {
            var _this2 = this;

            service.getReferralsTransactions(this).then(function (data) {
                _this2.referrals = data.body.data;
                _this2.total_referrals = data.body.total_referrals;
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        },
        formatCurrency: function formatCurrency(currency) {
            currency = Intl.NumberFormat('en-US', { style: 'currency', currency: 'NGN' }).format(currency);
            return currency.replace("NGN", "");
        }
    },
    created: function created() {
        this.preset();
        this.getReferralsTransactions();
    }
});

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Main_Header_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Main_Header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Main_Header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue__);




var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Users',
    data: function data() {
        return {
            admin: {},
            users: {},
            wallet_transactions: {},
            wallet_transaction: {},
            total_rewards_spent: 0,
            disable_btn: false
        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__Main_Header_index_vue___default.a,
        'component-sidebar': __WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue___default.a
    },
    methods: {
        isActive: function isActive(index) {
            if (index == 1) {
                return "active";
            }
        },
        preset: function preset() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("cityneeds_a_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.admin.admin_id = element.admin_id;
                        }, _this);
                    } else {
                        _this.$router.push('/');
                    }
                }).catch(function (err) {
                    if (err) {
                        _this.$router.push('/');
                    }
                });
            } else {
                this.$router.push('/');
            }
        },
        setWalletTransaction: function setWalletTransaction(txn) {
            this.wallet_transaction = txn;
        },
        getWalletRewardsTransactions: function getWalletRewardsTransactions() {
            var _this2 = this;

            service.getRewardsTransactions(this).then(function (data) {
                if (data.body.status == 200) {
                    _this2.total_rewards_spent = data.body.total_rewards_spent;
                }
                _this2.wallet_transactions = data.body.data;
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        },
        formatCurrency: function formatCurrency(currency) {
            currency = Intl.NumberFormat('en-US', { style: 'currency', currency: 'NGN' }).format(currency);
            return currency.replace("NGN", "");
        }
    },
    created: function created() {
        this.preset();
        this.getWalletRewardsTransactions();
    }
});

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);

var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: "SecondHeader",
    data: function data() {
        return {
            user: {},
            user_slug: {}
        };
    },

    methods: {
        getUser: function getUser() {
            var u = localStorage.getItem("cityneeds_user");
            if (u != null) {
                this.user = u;
                this.user_slug = u.replace(" ", "_");
            } else {
                this.user = null;
            }
        }
    },
    created: function created() {
        this.getUser();
    }
});

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Main_Header_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Main_Header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Main_Header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue__);




var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Users',
    data: function data() {
        return {
            admin: {},
            cnservices: {},
            cnpay_charges: {},
            cnpay_commissions: {},
            cnpay_charge: {},
            cnpay_commission: {},
            plans: {},
            plan: {},
            service_charges: {},
            service_charge: {},
            default_charges: {},
            default_charge: {},
            wallet_charges: {},
            wallet_charge: {},
            services_rewards: {},
            service_reward: {},
            panelFlag: "",
            disable_btn: false,
            loading: false,
            img_url: service.imageURL,
            resetPasswordPanel: false,
            resetEmailPanel: false,
            editCnpayCharge: false,
            editCnpayComm: false,
            editPlans: false,
            editServiceCharge: false,
            editDefaultCharge: false,
            mod_message: "",
            editWalletCharge: false,
            addWalletCharge: false,
            editServiceReward: false,
            addServiceReward: false,
            new_wallet_charge_entry_min: 0,
            min_wallet_topup_amount: 0,
            max_wallet_topup_amount: 0,
            wallet_entry_error: false,
            wallet_entry_amt_error: false,
            service_reward_type: "P",
            service_reward_activation_status: 1,
            paga_service_reward_type: "P",
            paga_service_reward_activation_status: 1,
            service_reward_error: "",
            paga_merchants: {},
            paga_mobile_operators: {},
            paga_service_groups: {},
            paga_service_group: {},
            paga_service_group_merchant: {},
            paga_service_error: "",
            paga_available_balance: 0,
            paga_merchant_dnds: {},
            commission_type: 'p',
            addPagaServiceGroup: false,
            addPagaServiceGroupMerchant: false,
            editPagaServiceGroup: false,
            deletePagaServiceGroup: false,
            editPagaServiceGroupMerchant: false,
            deletePagaServiceGroupMerchant: false,
            has_paga_service_group_for_mobile_operator: true,

            paga_test_dump1: {},
            paga_test_dump2: {},
            today: new Date(),

            component_view: {}
        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__Main_Header_index_vue___default.a,
        'component-sidebar': __WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue___default.a
    },
    computed: {
        var1: function var1() {
            return parseInt(this.cnpay_charge.cnpay_chg_range1_max) + 1;
        },
        var2: function var2() {
            return parseInt(this.cnpay_charge.cnpay_chg_range2_max) + 1;
        }
    },
    methods: {
        setComponentView: function setComponentView(view, attr1, attr2) {
            this.component_view = {};
            this.component_view[view] = true;
        },
        setComponent: function setComponent(attr, attr2) {
            this.panelFlag = true;
            if (attr == "reset-password") {
                this.resetPasswordPanel = true;
            }

            if (attr == "reset-email") {
                this.resetEmailPanel = true;
            }

            if (attr == "edit-cnpay-charge") {
                this.editCnpayCharge = true;
                this.cnpay_charge = attr2;
            }

            if (attr == "edit-cnpay-comm") {
                this.editCnpayComm = true;
                this.cnpay_commission = attr2;
            }

            if (attr == "edit-service-charge") {
                this.editServiceCharge = true;
                this.service_charge = attr2;
            }

            if (attr == "edit-default-charge") {
                this.editDefaultCharge = true;
                this.default_charge = attr2;
            }

            if (attr == "edit-plan") {
                this.editPlans = true;
                this.plan = attr2;
            }

            if (attr == "add-wallet-charge") {
                this.addWalletCharge = true;
                if (this.wallet_charges.length == undefined || this.wallet_charges.length == 0) {
                    this.new_wallet_charge_entry_min = this.min_wallet_topup_amount;
                } else {
                    this.new_wallet_charge_entry_min = this.wallet_charges[this.wallet_charges.length - 1].wallet_charge_max + 1;
                }
            }

            if (attr == "edit-wallet-charge") {
                this.wallet_charge.set_edit = false;
                this.editWalletCharge = true;
                this.wallet_charge = attr2;
                this.wallet_charge.set_edit = true;
            }

            if (attr == "delete-wallet-charge") {
                this.wallet_charge = attr2;
                this.deleteWalletProcessingCharge();
            }

            if (attr == "add-service-reward") {
                this.addServiceReward = true;
            }

            if (attr == "edit-service-reward") {
                this.service_reward = attr2;
                this.service_reward_type = this.service_reward.service_reward_type;
                this.service_reward_activation_status = this.service_reward.service_reward_activation_status;
                this.editServiceReward = true;
            }

            if (attr == "delete-service-reward") {
                this.service_reward = attr2;
                this.deleteServiceRewards();
            }

            if (attr == "add-paga-service-group") {
                this.addPagaServiceGroup = true;
            }

            if (attr == "edit-paga-service-group") {
                this.paga_service_group = attr2;
                this.editPagaServiceGroup = true;
            }

            if (attr == "delete-paga-service-group") {
                this.paga_service_group = attr2;
                this.deletePagaServiceGroup = true;
            }

            if (attr == 'add-paga-service-group-merchant') {
                this.paga_service_group = attr2;
                this.addPagaServiceGroupMerchant = true;
            }

            if (attr == "edit-paga-service-group-merchant") {
                this.paga_service_group_merchant = attr2;
                this.commission_type = this.paga_service_group_merchant.paga_service_group_merchant_commission_type;
                this.paga_service_reward_type = this.paga_service_group_merchant.paga_service_group_merchant_reward_type;
                this.paga_service_reward_activation_status = this.paga_service_group_merchant.paga_service_group_merchant_reward_activation_status;
                this.editPagaServiceGroupMerchant = true;
            }

            if (attr == "delete-paga-service-group-merchant") {
                this.paga_service_group_merchant = attr2;
                this.deletePagaServiceGroupMerchant = true;
            }

            if (attr == "reset-action") {
                this.resetPasswordPanel = false;
                this.resetEmailPanel = false;
                this.editCnpayComm = false;
                this.editCnpayCharge = false;
                this.editServiceCharge = false;
                this.editPlans = false;
                this.editWalletCharge = false;
                this.addWalletCharge = false;
                this.editDefaultCharge = false;
                this.addServiceReward = false;
                this.editServiceReward = false;
                this.addPagaServiceGroup = false;
                this.addPagaServiceGroupMerchant = false;
                this.editPagaServiceGroup = false;
                this.editPagaServiceGroupMerchant = false;
                this.deletePagaServiceGroupMerchant = false;
                this.paga_service_error = "";
            }
        },
        requests: function requests(req) {
            if (req == "delete") {
                this.deleteRequest = true;
            }
            if (req == "edit") {
                this.editRequest = true;
            }
            if (req == "reset") {
                this.editRequest = false;this.deleteRequest = false;
            }
        },
        isActive: function isActive(index) {
            if (index == 1) {
                return "active";
            }
        },
        preset: function preset() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("cityneeds_a_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.admin.user_id = element.user_id;
                        }, _this);
                    } else {
                        _this.$router.push('/');
                    }
                }).catch(function (err) {
                    if (err) {
                        _this.$router.push('/');
                    }
                });
            } else {
                this.$router.push('/');
            }
        },
        resetPassword: function resetPassword() {
            var _this2 = this;

            this.loading = true;
            var credentials = {
                user_current_password: this.admin.current_password,
                user_new_password: this.admin.new_password,
                user: this.admin.user_id
            };
            var navi = this.$router;
            if (credentials.user_current_password == '' || credentials.user_new_password == '') {
                toastr.warning("Kindly enter password", 'Warning!');
                this.loading = false;
            } else if (credentials.user_current_password == null || credentials.user_new_password == null) {
                toastr.warning("Kindly enter password", 'Warning!');
                this.loading = false;
            } else {
                service.resetPassword(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        navi.push('/login');
                    } else {
                        _this2.mod_message = response.body.message;
                    }
                    _this2.loading = false;
                }).catch(function (err) {
                    if (err.status == 404) {
                        toastr.warning("invalid credentials", 'Warning!');
                        _this2.mod_message = "invalid credentials";
                    }
                    _this2.loading = false;
                });
            }
        },
        resetEmail: function resetEmail() {
            var _this3 = this;

            this.loading = true;
            var credentials = {
                current_email: this.admin.current_email,
                new_email: this.admin.new_email,
                user: this.admin.user_id
            };
            var navi = this.$router;
            if (credentials.current_email == null || credentials.current_email == undefined || credentials.current_email == '') {
                toastr.warning("Kindly enter email", 'Warning!');
            } else if (credentials.new_email == null || credentials.new_email == undefined || credentials.new_email == '') {
                toastr.warning("Kindly enter email", 'Warning!');
            } else {
                service.resetEmail(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        navi.push('/login');
                    } else {
                        _this3.mod_message = response.body.message;
                    }
                    _this3.loading = false;
                }).catch(function (err) {
                    if (err.status == 404) {
                        toastr.warning("invalid credentials", 'Warning!');
                        _this3.mod_message = response.body.message;
                    }
                    _this3.mod_message = "invalid credentials";
                    _this3.loading = false;
                });
            }
        },
        getCNpayCharges: function getCNpayCharges() {
            var _this4 = this;

            service.getCNpayCharges(this).then(function (data) {
                if (data.body.status == 200) {
                    _this4.cnpay_charges = data.body.data;
                }
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        },
        getCNpayCommisions: function getCNpayCommisions() {
            var _this5 = this;

            service.getCNpayCommissions(this).then(function (data) {
                if (data.body.status == 200) {
                    _this5.cnpay_commissions = data.body.data;
                }
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        },
        getPaymentPlans: function getPaymentPlans() {
            var _this6 = this;

            service.getPaymentPlans(this).then(function (data) {
                if (data.body.status == 200) {
                    _this6.plans = data.body.data;
                }
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        },
        getServiceCharges: function getServiceCharges() {
            var _this7 = this;

            service.getServiceCharges(this).then(function (data) {
                if (data.body.status == 200) {
                    _this7.service_charges = data.body.data;
                }
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        },
        getDefaultCharges: function getDefaultCharges() {
            var _this8 = this;

            service.getDefaultCharges(this).then(function (data) {
                if (data.body.status == 200) {
                    _this8.default_charges = data.body.data;
                }
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        },
        editCnpayCharges: function editCnpayCharges() {
            var _this9 = this;

            service.editCnpayCharges(this, this.cnpay_charge.cnpay_chg_id, this.cnpay_charge).then(function (data) {
                if (data.body.status == 200) {
                    _this9.getCNpayCharges();
                    _this9.editCnpayCharge = false;
                }
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        },
        editCnpayCommissions: function editCnpayCommissions() {
            var _this10 = this;

            service.editCnpayCommissions(this, this.cnpay_commission.cnpay_comm_id, this.cnpay_commission).then(function (data) {
                if (data.body.status == 200) {
                    _this10.getCNpayCommisions();
                    _this10.editCnpayComm = false;
                }
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        },
        editServiceCharges: function editServiceCharges() {
            var _this11 = this;

            service.editServiceCharges(this, this.service_charge.service_id, this.service_charge).then(function (data) {
                if (data.body.status == 200) {
                    _this11.getServiceCharges();
                    _this11.editServiceCharge = false;
                }
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        },
        editDefaultCharges: function editDefaultCharges() {
            var _this12 = this;

            service.editDefaultCharges(this, this.default_charge.charge_id, this.default_charge).then(function (data) {
                if (data.body.status == 200) {
                    _this12.getDefaultCharges();
                    _this12.editDefaultCharge = false;
                }
                _this12.getWalletProcessingCharges();
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        },
        editPlansAndPricing: function editPlansAndPricing() {
            var _this13 = this;

            service.editPlansAndPricing(this, this.plan.plan_id, this.plan).then(function (data) {
                if (data.body.status == 200) {
                    _this13.getPaymentPlans();
                    _this13.editPlans = false;
                }
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        },
        getWalletProcessingCharges: function getWalletProcessingCharges() {
            var _this14 = this;

            service.getWalletProcessingCharges(this).then(function (data) {
                _this14.wallet_charges = data.body.data;

                if (data.body.status == 200) {
                    _this14.wallet_charges[_this14.wallet_charges.length - 1].can_delete_entry = true;
                }

                _this14.min_wallet_topup_amount = data.body.data_min_wallet_topup_amount;
                _this14.max_wallet_topup_amount = data.body.data_max_wallet_topup_amount;
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        },
        addProcessingCharge: function addProcessingCharge() {
            var _this15 = this;

            if (this.wallet_charges.length != 0) {
                var entry_max_value = parseInt(this.wallet_charge.wallet_charge_max);
                if (this.wallet_charges.some(function (element) {
                    return element.wallet_charge_max >= entry_max_value;
                })) {
                    this.wallet_entry_error = true;
                } else {
                    this.wallet_entry_error = false;
                }

                if (this.wallet_charges.some(function (element) {
                    return element.wallet_charge_charge >= parseInt(_this15.wallet_charge.wallet_charge_charge);
                })) {
                    this.wallet_entry_amt_error = true;
                } else {
                    this.wallet_entry_amt_error = false;
                }
            } else {
                if (this.min_wallet_topup_amount >= this.wallet_charge.wallet_charge_max) {
                    this.wallet_entry_error = true;
                } else {
                    this.wallet_entry_error = false;
                }
            }

            if (!this.wallet_entry_error && !this.wallet_entry_amt_error) {
                var payload = {
                    wallet_charge_min: this.new_wallet_charge_entry_min,
                    wallet_charge_max: this.wallet_charge.wallet_charge_max,
                    wallet_charge_charge: this.wallet_charge.wallet_charge_charge
                };
                service.addWalletProcessingCharge(this, payload).then(function (data) {
                    if (data.body.status == 201) {
                        _this15.wallet_charges = data.body.data;

                        _this15.wallet_charges[_this15.wallet_charges.length - 1].can_delete_entry = true;

                        _this15.addWalletCharge = false;
                    }
                }).catch(function (err) {
                    if (err) {
                        toastr.error('Sorry, could not process information', 'Warning!');
                    }
                });
            }
            this.wallet_charge = {};
        },
        editWalletProcessingCharge: function editWalletProcessingCharge() {
            var _this16 = this;

            var charge_index = this.wallet_charges.indexOf(this.wallet_charge);
            var edited_amount = parseInt(this.wallet_charge.wallet_charge_charge);
            var prev_amount = 0;
            var next_amount = 0;

            if (charge_index != 0) {
                prev_amount = this.wallet_charges[charge_index - 1].wallet_charge_charge;
            }
            if (this.wallet_charges.indexOf(this.wallet_charges[this.wallet_charges.length - 1]) != charge_index) {
                next_amount = this.wallet_charges[charge_index + 1].wallet_charge_charge;
            } else {
                next_amount = edited_amount + 1;
            }

            if (edited_amount < prev_amount || edited_amount > next_amount) {
                this.wallet_entry_amt_error = true;
            } else {
                this.wallet_entry_amt_error = false;
            }

            if (!this.wallet_entry_amt_error) {
                service.editWalletProcessingCharge(this, this.wallet_charge.wallet_charge_id, this.wallet_charge).then(function (data) {
                    if (data.body.status == 200) {
                        _this16.getWalletProcessingCharges();
                        _this16.editWalletCharge = false;
                    }
                }).catch(function (err) {
                    if (err) {
                        toastr.error('Sorry, could not process information', 'Warning!');
                    }
                });
            }
        },
        deleteWalletProcessingCharge: function deleteWalletProcessingCharge() {
            var _this17 = this;

            service.deleteWalletProcessingCharge(this, this.wallet_charge.wallet_charge_id).then(function (data) {
                if (data.body.status == 200) {
                    _this17.getWalletProcessingCharges();
                }
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        },
        getCNservices: function getCNservices() {
            var _this18 = this;

            service.getCNServices(this).then(function (data) {
                _this18.cnservices = data.body.data;
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        },
        getServiceRewards: function getServiceRewards() {
            var _this19 = this;

            service.getServiceRewards(this).then(function (data) {
                _this19.services_rewards = data.body.data;
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        },
        addServiceRewards: function addServiceRewards() {
            var _this20 = this;

            this.disable_btn = true;
            var payload = {
                service_service: this.service_reward.service | 0,
                service_reward: this.service_reward.reward,
                service_reward_type: this.service_reward_type || 'P',
                service_reward_status: 1 };
            if (payload.service_reward != '' || payload.service_service != 0) {
                service.addServiceRewards(this, payload).then(function (data) {
                    if (data.body.status == 201) {
                        _this20.services_rewards = data.body.data;
                        _this20.disable_btn = false;
                        _this20.service_reward = {};
                    }
                    _this20.addServiceReward = false;
                }).catch(function (err) {
                    if (err.status == 409) {
                        _this20.service_reward_error = "Service Reward already exists";
                    }
                    toastr.error('Sorry, could not process information', 'Warning!');
                });
            } else {
                toastr.error('Sorry, some fields are empty', 'Warning!');
            }
        },
        editServiceRewards: function editServiceRewards() {
            var _this21 = this;

            this.disable_btn = true;
            var payload = {
                service_reward: this.service_reward.service_reward_reward,
                service_reward_type: this.service_reward_type || 'P',
                service_reward_status: this.service_reward_activation_status || 1 };
            if (payload.service_reward != '' || payload.service_service != 0) {
                service.editServiceRewards(this, this.service_reward.service_reward_id, payload).then(function (data) {
                    if (data.body.status == 200) {
                        _this21.services_rewards = data.body.data;
                        _this21.disable_btn = false;
                        _this21.service_reward = {};
                    }
                    _this21.editServiceReward = false;
                }).catch(function (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                });
            } else {
                toastr.error('Sorry, some fields are empty', 'Warning!');
            }
        },
        deleteServiceRewards: function deleteServiceRewards() {
            var _this22 = this;

            service.deleteServiceRewards(this, this.service_reward.service_reward_id).then(function (data) {
                if (data.body.status == 200) {
                    _this22.getServiceRewards();
                }
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        },
        getPagaServicesRemoteXX: function getPagaServicesRemoteXX() {
            var _this23 = this;

            var payload = { "referenceNumber": "5618889345117897834344943344889",
                "locale": "", "receiverPhoneNumber": "08059079689", "amount": 100,
                "quantity": 1, "message": "", "identificationType": "",
                "identificationNumber": "", "operatorPublicId": "" };

            service.pagaGetMerchants(this).then(function (response) {

                _this23.paga_test_dump1 = response.body.billers;
            }).catch(function (err) {
                _this23.loading = false;
                console.log(4545 + "-error");
                console.log(err);
            });

            service.pagaGetMobileOperators(this).then(function (response) {

                _this23.paga_test_dump2 = response;
            }).catch(function (err) {
                _this23.loading = false;
                console.log(4545 + "-error");
                console.log(err);
            });
        },
        getPagaServicesRemote: function getPagaServicesRemote() {
            var _this24 = this;

            service.pagaGetMerchants(this).then(function (response) {
                service.postPagaMerchants(_this24, response.body.billers).then(function (response) {}).catch(function (err) {
                    _this24.loading = false;
                });
            }).catch(function (err) {
                _this24.loading = false;
            });

            service.pagaGetMobileOperators(this).then(function (response) {
                service.postPagaMobileOperators(_this24, response.body.operators).then(function (response) {}).catch(function (err) {
                    _this24.loading = false;
                });
            }).catch(function (err) {
                _this24.loading = false;
            });
        },
        getPagaMerchants: function getPagaMerchants() {
            var _this25 = this;

            service.getPagaMerchants(this).then(function (data) {
                _this25.paga_merchants = data.body.data;
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        },
        getPagaMobileOperators: function getPagaMobileOperators() {
            var _this26 = this;

            service.getPagaMobileOperators(this).then(function (data) {
                _this26.paga_mobile_operators = data.body.data;
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        },
        getPagaServiceGroups: function getPagaServiceGroups() {
            var _this27 = this;

            service.getPagaServiceGroups(this).then(function (data) {
                _this27.paga_service_groups = data.body.data;
                _this27.has_paga_service_group_for_mobile_operator = data.body.data_has_paga_service_group_for_mobile_operator;
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        },
        addPagaServiceGroupMobileOperator: function addPagaServiceGroupMobileOperator() {
            this.paga_service_group.group_for = "MOBILEOPS";
            this.addPagaServiceGroups();
            this.has_paga_service_group_for_mobile_operator = true;
        },
        addPagaServiceGroups: function addPagaServiceGroups() {
            var _this28 = this;

            this.disable_btn = true;
            var payload = {
                group_name: this.paga_service_group.group_name,
                group_title: this.paga_service_group.group_title || this.paga_service_group.group_name,
                group_for: this.paga_service_group.group_for || "MERCHANT"
            };
            if (payload.group_name != '' || payload.group_name == undefined) {
                service.addPagaServiceGroups(this, payload).then(function (data) {
                    if (data.body.status == 201) {
                        _this28.paga_service_groups = data.body.data;
                        _this28.disable_btn = false;
                        _this28.paga_service_group = {};
                        _this28.paga_service_error = "";
                    }
                    _this28.addPagaServiceGroup = false;
                }).catch(function (err) {
                    if (err.status == 409) {
                        _this28.paga_service_error = "Group already exists";
                        toastr.error(_this28.paga_service_error, 'Warning!');
                    } else {
                        toastr.error('Sorry, could not process information', 'Warning!');
                    }
                    _this28.paga_service_group = {};
                    _this28.disable_btn = false;
                });
            } else {
                toastr.error('Sorry, some fields are empty', 'Warning!');
            }
        },
        editPagaServiceGroups: function editPagaServiceGroups() {
            var _this29 = this;

            this.disable_btn = true;
            var payload = {
                group_name: this.paga_service_group.paga_service_group_name,
                group_title: this.paga_service_group.paga_service_group_title || this.paga_service_group.paga_service_group_name
            };
            if (payload.group_name != '') {
                service.editPagaServiceGroups(this, this.paga_service_group.paga_service_group_id, payload).then(function (data) {
                    if (data.body.status == 200) {
                        _this29.paga_service_groups = data.body.data;
                        _this29.disable_btn = false;
                        _this29.paga_service_group = {};
                    }
                    _this29.editPagaServiceGroup = false;
                }).catch(function (err) {
                    if (err.status == 409) {
                        _this29.paga_service_error = "Group already exists";
                        toastr.error(_this29.paga_service_error, 'Warning!');
                    } else {
                        toastr.error('Sorry, could not process information', 'Warning!');
                    }
                });
            } else {
                toastr.error('Sorry, some fields are empty', 'Warning!');
            }
        },
        deletePagaServiceGroups: function deletePagaServiceGroups() {
            var _this30 = this;

            service.deletePagaServiceGroups(this, this.paga_service_group.paga_service_group_id).then(function (data) {
                if (data.body.status == 200) {
                    _this30.getPagaServiceGroups();
                }
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        },
        addPagaServiceGroupMerchants: function addPagaServiceGroupMerchants() {
            var _this31 = this;

            this.disable_btn = true;
            var payload = {
                merchant: this.paga_service_group_merchant.merchant,
                merchant_service_group: this.paga_service_group.paga_service_group_id,
                merchant_service_group_type: this.paga_service_group.paga_service_group_for,
                merchant_commission_type: this.commission_type || 'P',
                merchant_commission: this.paga_service_group_merchant.commission || 0,
                merchant_reward_type: this.paga_service_reward_type || 'P',
                merchant_reward: this.paga_service_group_merchant.reward || 0,
                merchant_reward_activation_status: this.paga_service_reward_activation_status || 1,
                merchant_max_purchase_amount: this.paga_service_group_merchant.max_purchase_amount || 0
            };
            if (payload.merchant != '' || payload.merchant_service_group != 0) {
                service.addPagaServiceGroupMerchants(this, payload).then(function (data) {
                    if (data.body.status == 201) {
                        _this31.paga_service_group.paga_service_group_merchants = data.body.data;
                        _this31.disable_btn = false;
                        _this31.paga_service_group_merchant = {};
                    }
                    _this31.addPagaServiceGroupMerchant = false;
                }).catch(function (err) {
                    if (err.status == 409) {
                        _this31.paga_service_error = "Merchant already exists";
                        toastr.error(_this31.paga_service_error, 'Warning!');
                    } else {
                        toastr.error('Sorry, could not process information', 'Warning!');
                    }
                    _this31.paga_service_group_merchant = {};
                    _this31.disable_btn = false;
                });
            } else {
                toastr.error('Sorry, some fields are empty', 'Warning!');
            }
        },
        editPagaServiceGroupMerchants: function editPagaServiceGroupMerchants() {
            var _this32 = this;

            this.disable_btn = true;
            var payload = {
                merchant_commission_type: this.commission_type || 'P',
                merchant_commission: this.paga_service_group_merchant.paga_service_group_merchant_commission || 0,
                merchant_reward_type: this.paga_service_reward_type || 'P',
                merchant_reward: this.paga_service_group_merchant.paga_service_group_merchant_reward || 0,
                merchant_reward_activation_status: this.paga_service_reward_activation_status || 1,
                merchant_max_purchase_amount: this.paga_service_group_merchant.paga_service_group_merchant_max_purchase_amount || 0
            };
            if (payload.merchant_commission != undefined || payload.merchant_reward != undefined) {
                service.editPagaServiceGroupMerchants(this, this.paga_service_group_merchant.paga_service_group_merchant_id, payload).then(function (data) {
                    if (data.body.status == 200) {
                        _this32.paga_service_groups = data.body.data;
                        _this32.disable_btn = false;
                        _this32.paga_service_group_merchant = {};
                    }
                    _this32.editPagaServiceGroupMerchant = false;
                }).catch(function (err) {
                    _this32.disable_btn = false;
                    _this32.paga_service_group_merchant = {};
                    _this32.editPagaServiceGroupMerchant = false;
                });
            } else {
                toastr.error('Sorry, some fields are empty', 'Warning!');
            }
        },
        deletePagaServiceGroupMerchants: function deletePagaServiceGroupMerchants() {
            var _this33 = this;

            service.deletePagaServiceGroupMerchants(this, this.paga_service_group_merchant.paga_service_group_merchant_id).then(function (data) {
                if (data.body.status == 200) {
                    _this33.getPagaServiceGroups();
                }
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        },
        addPagaMerchantDoNotDisplayServices: function addPagaMerchantDoNotDisplayServices(merchant) {
            var _this34 = this;

            var payload = {
                service_merchant: merchant,
                service_name: this.paga_merchant_dnds.service_name
            };
            if (payload.service_merchant != '' || payload.service_name != 0) {
                service.postPagaMerchantDoNotDisplayServices(this, payload).then(function (data) {
                    if (data.body.status == 201) {
                        _this34.paga_service_group_merchant.paga_service_group_merchant_services_do_not_display = data.body.data;
                        _this34.paga_merchant_dnds = {};
                    }
                }).catch(function (err) {});
            } else {
                toastr.error('Sorry, some fields are empty', 'Warning!');
            }
        },
        deletePagaMerchantDoNotDisplayServices: function deletePagaMerchantDoNotDisplayServices(data) {
            var _this35 = this;

            service.deletePagaMerchantDoNotDisplayServices(this, data.service_id, data.service_merchant).then(function (data) {
                if (data.body.status == 200) {
                    _this35.paga_service_group_merchant.paga_service_group_merchant_services_do_not_display = data.body.data;
                }
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        },
        onFileChange: function onFileChange(e, data) {
            var files = e.target.files || e.dataTransfer.files;
            if (files.length) {
                var formData = new FormData();
                formData.append('photo', files[0]);
                formData.append('data_id', data);
                formData.append('data_type', "paga_merchants");
                service.uploadDataPhoto(this, formData).then(function (data) {
                    if (data.body.status == 200) {
                        location.reload = true;
                    }
                }).catch(function (err) {
                    if (err) {}
                });
            }
        },
        getPagaBalance: function getPagaBalance() {
            var _this36 = this;

            this.paga_available_balance = "...";

            var seek_url = service.paga_apiBaseUrl + 'accountBalance';
            var payload = {
                "referenceNumber": "CNpayPG-" + this.today.getTime(), "locale": ""
            };
            var hash = service.SHA512(payload.referenceNumber + service.paga_apiKey);
            service.getPagaRequest(this, payload, seek_url, hash).then(function (data) {
                if (data.body.responseCode == 0) {
                    _this36.paga_available_balance = data.body.availableBalance;
                }
            }).catch(function (err) {});
        }
    },
    created: function created() {
        this.preset();
        this.getCNpayCharges();
        this.getCNpayCommisions();
        this.getPaymentPlans();
        this.getServiceCharges();
        this.getDefaultCharges();
        this.getWalletProcessingCharges();
        this.getServiceRewards();
        this.getCNservices();

        this.getPagaMerchants();
        this.getPagaMobileOperators();
        this.getPagaServiceGroups();
        this.getPagaBalance();
    }
});

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);

var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: "Sidebar",
    data: function data() {
        return {
            notifications_contracts: 0,
            notifications_cnpros: 0,
            notifications_cnsurveys: 0
        };
    },

    methods: {
        isActive: function isActive(page) {
            if (page == localStorage.getItem("cn_a_current_page")) {
                return "true";
            }
        }
    },
    created: function created() {
        localStorage.setItem("cn_a_current_page", this.$route.path);
    }
});

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Main_Header_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Main_Header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Main_Header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue__);




var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Users',
    data: function data() {
        return {
            admin: {},
            users: {},
            user: {},
            user_analytics: {},
            viewFlag: false,
            img_url: service.imageURL,
            deleteRequest: false,
            editRequest: false,
            wallet_transactions: {},
            user_current_wallet_balance: 0,
            user_wallet_transactions: {},
            user_wallet_transaction: {},
            topup_user_wallet: false,
            wallet_topup_amt: 0,
            wallet_topup_descr: "Top-up By Admin",
            wallet_payment_message: "",
            user_referrals: {},
            user_referral_code: "-",
            user_referral_total: 0,
            disable_btn: false
        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__Main_Header_index_vue___default.a,
        'component-sidebar': __WEBPACK_IMPORTED_MODULE_2__Sidebar_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_3__Main_Footer_index_vue___default.a
    },
    methods: {
        setPanel: function setPanel(attr, attr2) {
            this.panelFlag = true;
            if (attr == "view") {
                this.viewFlag = true;
                this.user = attr2;
                this.getUserAnalytics();
                this.getUserWalletTransactions();
                this.getUserReferralTransactions();
            }
            if (attr == "topup") {
                this.topup_user_wallet = true;
            }
        },
        reset_view: function reset_view() {
            this.viewFlag = false;
            this.user = {};
        },
        reset: function reset() {
            this.topup_user_wallet = false;
        },
        togglePanel: function togglePanel(id) {
            var x = document.getElementById(id);
            if (x.style.display === "none") {
                x.style.display = "block";
            } else {
                x.style.display = "none";
            }
        },
        requests: function requests(req) {
            if (req == "delete") {
                this.deleteRequest = true;
            }
            if (req == "edit") {
                this.editRequest = true;
            }
            if (req == "reset") {
                this.editRequest = false;this.deleteRequest = false;
            }
        },
        isActive: function isActive(index) {
            if (index == 1) {
                return "active";
            }
        },
        preset: function preset() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("cityneeds_a_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.admin.admin_id = element.admin_id;
                        }, _this);
                    } else {
                        _this.$router.push('/');
                    }
                }).catch(function (err) {
                    if (err) {
                        _this.$router.push('/');
                    }
                });
            } else {
                this.$router.push('/');
            }
        },
        getUsers: function getUsers() {
            var _this2 = this;

            service.getUsers(this).then(function (data) {
                if (data.body.status == 200) {
                    _this2.users = data.body.data;
                }
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        },
        getUserAnalytics: function getUserAnalytics() {
            var _this3 = this;

            service.getUserAnalytics(this, this.user.user_id).then(function (data) {
                if (data.body.status == 200) {
                    _this3.user_analytics = data.body.data;
                }
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        },
        editUser: function editUser() {
            var _this4 = this;

            service.adminEditUsers(this, this.user.user_id, this.user).then(function (data) {
                if (data.body.status == 200) {
                    toastr.success('Updated', 'Warning!');
                    _this4.editRequest = false;
                }
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        },
        deleteUser: function deleteUser() {
            service.deleteUsers(this, this.user.user_id).then(function (data) {
                if (data.body.status == 200) {
                    toastr.success('Removed', 'Warning!');
                    location.reload(true);
                }
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        },
        onFileChange: function onFileChange(e, user) {
            var _this5 = this;

            var files = e.target.files || e.dataTransfer.files;
            if (files.length) {
                var formData = new FormData();
                formData.append('photo', files[0]);
                formData.append('data_id', user);
                formData.append('data_type', "users");
                service.uploadDataPhoto(this, formData).then(function (data) {
                    if (data.body.status == 200) {
                        _this5.user.user_image = data.body.data;
                    }
                }).catch(function (err) {
                    if (err) {}
                });
            }
        },
        setWalletTransaction: function setWalletTransaction(txn) {
            this.user_wallet_transaction = txn;
        },
        getUserWalletTransactions: function getUserWalletTransactions() {
            var _this6 = this;

            service.getUserWalletTransactions(this, this.user.user_ref_no).then(function (data) {
                if (data.body.status == 200) {
                    _this6.user_current_wallet_balance = data.body.data_current_wallet_balance;
                }
                _this6.user_wallet_transactions = data.body.data;
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        },
        getWalletTransactions: function getWalletTransactions() {
            var _this7 = this;

            service.getWalletTransactions(this).then(function (data) {
                _this7.wallet_transactions = data.body.data;
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        },
        formatCurrency: function formatCurrency(currency) {
            currency = Intl.NumberFormat('en-US', { style: 'currency', currency: 'NGN' }).format(currency);
            return currency.replace("NGN", "");
        },
        topupUserWallet: function topupUserWallet() {
            var _this8 = this;

            this.disable_btn = true;
            var txn_payload = {
                "pay": this.user.user_ref_no,
                "txn_amount": this.wallet_topup_amt,
                "processing_fee": 0,
                "topup_by_admin": 1,
                "topup_by_admin_descr": this.wallet_topup_descr,
                "total_amount": this.wallet_topup_amt + 0
            };

            service.postWalletTopup(this, txn_payload).then(function (response) {
                _this8.getUserWalletTransactions();

                _this8.wallet_payment_message = "You have successfully topped up  CNwallet with ₦" + _this8.wallet_topup_amt;

                _this8.disable_btn = false;
                _this8.topup_user_wallet = false;
            }).catch(function (err) {});
        },
        getUserReferralTransactions: function getUserReferralTransactions() {
            var _this9 = this;

            service.getUserReferralTransactions(this, this.user.user_ref_no).then(function (data) {
                _this9.user_referrals = data.body.data;
                _this9.user_referral_code = data.body.data_referral_code;
                _this9.user_referral_total = data.body.data_referral_total;
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        }
    },
    created: function created() {
        this.preset();
        this.getUsers();
        this.getWalletTransactions();
    }
});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__dirname) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_resource__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vee_validate__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vee_validate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vee_validate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_progressbar__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_progressbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_progressbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Dashboard_index_vue__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Dashboard_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Dashboard_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Login_index_vue__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Login_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Login_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Users_index_vue__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Users_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Users_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Cnpros_index_vue__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Cnpros_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Cnpros_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Contracts_index_vue__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Contracts_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_Contracts_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Cnsurveys_index_vue__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Cnsurveys_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_Cnsurveys_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Businesses_index_vue__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Businesses_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_Businesses_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Forums_index_vue__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Forums_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_Forums_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Payments_index_vue__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Payments_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_Payments_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_CNpayments_index_vue__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_CNpayments_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_CNpayments_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_CNpaymentsRemita_index_vue__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_CNpaymentsRemita_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_CNpaymentsRemita_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_CNpaymentsPaga_index_vue__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_CNpaymentsPaga_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_CNpaymentsPaga_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Settings_index_vue__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Settings_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_Settings_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_BusinessCategories_index_vue__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_BusinessCategories_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_BusinessCategories_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_CNproCategories_index_vue__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_CNproCategories_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_CNproCategories_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_CNwallets_index_vue__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_CNwallets_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_CNwallets_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_Rewards_index_vue__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_Rewards_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_Rewards_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_Referrals_index_vue__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_Referrals_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_Referrals_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_Messages_index_vue__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_Messages_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_Messages_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_CNdiscounts_index_vue__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_CNdiscounts_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_CNdiscounts_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_CNinsurance_index_vue__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_CNinsurance_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_CNinsurance_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_CNinsuranceForms_index_vue__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_CNinsuranceForms_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__components_CNinsuranceForms_index_vue__);































__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vee_validate___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_progressbar___default.a, {
  color: 'rgb(143, 255, 199)',
  failedColor: 'red',
  height: '5px'
});

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  base: __dirname,
  routes: [{ path: '/', name: 'Login', component: __WEBPACK_IMPORTED_MODULE_6__components_Login_index_vue___default.a }, { path: '/dashboard', name: 'Dashboard', component: __WEBPACK_IMPORTED_MODULE_5__components_Dashboard_index_vue___default.a }, { path: '/users', name: 'Users', component: __WEBPACK_IMPORTED_MODULE_7__components_Users_index_vue___default.a }, { path: '/cnpros', name: 'Cnpros', component: __WEBPACK_IMPORTED_MODULE_8__components_Cnpros_index_vue___default.a }, { path: '/contracts', name: 'Contracts', component: __WEBPACK_IMPORTED_MODULE_9__components_Contracts_index_vue___default.a }, { path: '/cnsurveys', name: 'Cnsurveys', component: __WEBPACK_IMPORTED_MODULE_10__components_Cnsurveys_index_vue___default.a }, { path: '/businesses', name: 'Businesses', component: __WEBPACK_IMPORTED_MODULE_11__components_Businesses_index_vue___default.a }, { path: '/forums', name: 'Forums', component: __WEBPACK_IMPORTED_MODULE_12__components_Forums_index_vue___default.a }, { path: '/payments', name: 'Payments', component: __WEBPACK_IMPORTED_MODULE_13__components_Payments_index_vue___default.a }, { path: '/settings', name: 'Settings', component: __WEBPACK_IMPORTED_MODULE_17__components_Settings_index_vue___default.a }, { path: '/cnpayments', name: 'CNpayments', component: __WEBPACK_IMPORTED_MODULE_14__components_CNpayments_index_vue___default.a }, { path: '/cnpaymentsremita', name: 'CNpaymentsRemita', component: __WEBPACK_IMPORTED_MODULE_15__components_CNpaymentsRemita_index_vue___default.a }, { path: '/cnpaymentspaga', name: 'CNpaymentsPaga', component: __WEBPACK_IMPORTED_MODULE_16__components_CNpaymentsPaga_index_vue___default.a }, { path: '/business_categories', name: 'BusinessCategories', component: __WEBPACK_IMPORTED_MODULE_18__components_BusinessCategories_index_vue___default.a }, { path: '/cnpro_categories', name: 'CNproCategories', component: __WEBPACK_IMPORTED_MODULE_19__components_CNproCategories_index_vue___default.a }, { path: '/cnwallets', name: 'CNwallets', component: __WEBPACK_IMPORTED_MODULE_20__components_CNwallets_index_vue___default.a }, { path: '/rewards', name: 'Rewards', component: __WEBPACK_IMPORTED_MODULE_21__components_Rewards_index_vue___default.a }, { path: '/referrals', name: 'Referrals', component: __WEBPACK_IMPORTED_MODULE_22__components_Referrals_index_vue___default.a }, { path: '/messages', name: 'Messages', component: __WEBPACK_IMPORTED_MODULE_23__components_Messages_index_vue___default.a }, { path: '/cndiscounts', name: 'CNdiscounts', component: __WEBPACK_IMPORTED_MODULE_24__components_CNdiscounts_index_vue___default.a }, { path: '/cninsurance', name: 'CNinsurance', component: __WEBPACK_IMPORTED_MODULE_25__components_CNinsurance_index_vue___default.a }, { path: '/cninsuranceforms', name: 'CNinsuranceForms', component: __WEBPACK_IMPORTED_MODULE_26__components_CNinsuranceForms_index_vue___default.a }, { path: '*', redirect: '/' }]
});

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  router: router,
  template: '\n    <div id="app">\n      <vue-progress-bar></vue-progress-bar>\n      <router-view></router-view>\n    </div>\n    '
}).$mount('#app');
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "/"))

/***/ }),
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 120 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 121 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 122 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 123 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 124 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 125 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 126 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 127 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 128 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 129 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 130 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 131 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 132 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 133 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 134 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 135 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 136 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 137 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 138 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 139 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 140 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 141 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 142 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 143 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 144 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 145 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 146 */,
/* 147 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(121)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(57),
  /* template */
  __webpack_require__(151),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(138)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(80),
  /* template */
  __webpack_require__(168),
  /* scopeId */
  "data-v-bb46dc78",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 149 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "container"
    }
  }, [_c('component-header'), _vm._v(" "), _c('section', {
    attrs: {
      "id": "main-content"
    }
  }, [(_vm.viewFlag) ? _c('section', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "agileits-w3layouts-stats"
  }, [_c('div', {
    staticClass: "col-md-4 stats-info widget"
  }, [_c('div', {
    staticClass: "stats-info-agileits"
  }, [_c('div', {
    staticClass: "stats-title"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.user.user_fullname))])]), _vm._v(" "), _c('div', {
    staticClass: "stats-body"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.img_url + _vm.user.user_image
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "stats-body"
  }, [_c('label', [_vm._v("Change Picture" + _vm._s(_vm.user.user_image))]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChange($event, _vm.user.user_ref_no)
      }
    }
  })])]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 stats-info stats-last widget-shadow"
  }, [_c('div', {
    staticClass: "notifications"
  }, [_c('header', {
    staticClass: "panel-heading"
  }, [_vm._v("\r\n                             Profile\r\n                             "), _c('a', {
    staticClass: "btn btn-success pull-right",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.reset_view()
      }
    }
  }, [_vm._v("Back")])]), _vm._v(" "), _c('div', {
    staticClass: "notify-w3ls"
  }, [_c('table', {
    staticClass: "table",
    attrs: {
      "ui-jq": "footable",
      "ui-options": "{\r\n                                \"paging\": {\r\n                                \"enabled\": true\r\n                                },\r\n                                \"filtering\": {\r\n                                \"enabled\": true\r\n                                },\r\n                                \"sorting\": {\r\n                                \"enabled\": true\r\n                                }}"
    }
  }, [(_vm.editRequest) ? _c('thead', [_c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_fullname),
      expression: "user.user_fullname"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.user_fullname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_fullname = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Email")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_email),
      expression: "user.user_email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.user_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_email = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Phone")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_phone),
      expression: "user.user_phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.user_phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_phone = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th'), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.editUser
    }
  }, [_vm._v("Save")]), _vm._v("  ")])]), _vm._v(" "), _c('tr', [_c('th'), _vm._v(" "), (_vm.deleteRequest) ? _c('td', [_c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Do you really want to do this?")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-xs",
    on: {
      "click": _vm.deleteUser
    }
  }, [_vm._v("Yes Delete")]), _vm._v("\r\n                                               \r\n                                            "), _c('button', {
    staticClass: "btn btn-primary btn-xs",
    on: {
      "click": function($event) {
        _vm.requests('reset')
      }
    }
  }, [_vm._v("Cancel")])]) : _vm._e()])]) : _c('thead', [_c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.user.user_fullname))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Email")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.user.user_email))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("City")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.user.user_city))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Phone")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.user.user_phone))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Referral Code")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.user.user_referral_code))])]), _vm._v(" "), _c('tr', [_c('th'), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.requests('edit')
      }
    }
  }, [_vm._v("Edit")]), _vm._v("  "), _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        _vm.requests('delete')
      }
    }
  }, [_vm._v("Delete")])])]), _vm._v(" "), _c('tr', [_c('th'), _vm._v(" "), (_vm.deleteRequest) ? _c('td', [_c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Do you really want to do this?")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-xs",
    on: {
      "click": _vm.deleteUser
    }
  }, [_vm._v("Yes Delete")]), _vm._v("\r\n                                           \r\n                                        "), _c('button', {
    staticClass: "btn btn-primary btn-xs",
    on: {
      "click": function($event) {
        _vm.requests('reset')
      }
    }
  }, [_vm._v("Cancel")])]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "stats-info-agileits"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "stats-body"
  }, [_c('ul', {
    staticClass: "list-unstyled"
  }, [_c('li', [_vm._v("Business Accounts "), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.user_analytics.businesses))])]), _vm._v(" "), _c('li', [_vm._v("CNpro Accounts "), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.user_analytics.cnpros))])]), _vm._v(" "), _c('li', [_vm._v("Forums Created"), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.user_analytics.forums_created))])]), _vm._v(" "), _c('li', [_vm._v("Surveys Created"), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.user_analytics.cnsurveys_created))])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "notifications"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "stats-info-agileits"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "stats-body col-md-4"
  }, [_c('p'), _vm._v(" "), (_vm.wallet_payment_message != '') ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.wallet_payment_message))]) : _vm._e(), _vm._v(" "), _c('p', [_c('b', [_vm._v("Available Balance: ")]), _vm._v("₦" + _vm._s(_vm.formatCurrency(_vm.user_current_wallet_balance)))]), _vm._v(" "), (_vm.topup_user_wallet) ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_vm._v("\r\n                                    Amount: "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.wallet_topup_amt),
      expression: "wallet_topup_amt"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "10em"
    },
    attrs: {
      "type": "number",
      "step": "0.01",
      "min": "100"
    },
    domProps: {
      "value": (_vm.wallet_topup_amt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.wallet_topup_amt = $event.target.value
      }
    }
  }), _vm._v("\r\n                                    Details/Description: "), _c('br'), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.wallet_topup_descr),
      expression: "wallet_topup_descr"
    }],
    attrs: {
      "placeholder": "Description"
    },
    domProps: {
      "value": (_vm.wallet_topup_descr)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.wallet_topup_descr = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.disable_btn) ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("...processing, please wait")]) : _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.topupUserWallet()
      }
    }
  }, [_vm._v("Topup")]), _vm._v(" "), (!_vm.disable_btn) ? _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        _vm.reset()
      }
    }
  }, [_vm._v("Cancel")]) : _vm._e()])]) : _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        _vm.setPanel('topup', '')
      }
    }
  }, [_vm._v("Topup Reward")])]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.user_wallet_transactions.length != 0) ? _c('div', {
    staticClass: "stats-body"
  }, [_c('button', {
    staticClass: "btn btn-warning pull-right",
    on: {
      "click": function($event) {
        _vm.togglePanel('wallet-transactions')
      }
    }
  }, [_vm._v("View Reward Transactions")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.user_wallet_transactions.length != 0) ? _c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "wallet-transactions"
    }
  }, [_c('div', {
    staticClass: " p20 mb30 hidden-sm hidden-xs"
  }, [_c('div', {
    staticClass: "p20 col-md-12",
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_vm._m(2), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_vm._m(3), _vm._v(" "), _vm._l((_vm.user_wallet_transactions), function(txn) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(txn.wallet_transaction_reg_date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(txn.wallet_transaction_ref))]), _vm._v(" "), _c('td', [_c('span', {
      staticStyle: {
        "padding": "5px",
        "color": "#ffffff"
      },
      style: ({
        backgroundColor: txn.wallet_transaction_type_color
      })
    }, [_vm._v(_vm._s(txn.wallet_transaction_type))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatCurrency(txn.wallet_transaction_amount)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatCurrency(txn.wallet_transaction_current_balance)))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-default btn-sm",
      attrs: {
        "type": "button",
        "data-toggle": "modal",
        "data-target": "#viewWalletTransaction"
      },
      on: {
        "click": function($event) {
          _vm.setWalletTransaction(txn)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-info-circle"
    }), _vm._v(" More Details")])])])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "background-white p20 mb30 hidden-md hidden-lg"
  }, [_vm._m(4), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, _vm._l((_vm.user_wallet_transactions), function(txn) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "padding": "1em"
      }
    }, [_c('p', [_c('b', [_vm._v("Date: ")]), _vm._v(_vm._s(txn.wallet_transaction_reg_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("REF: ")]), _vm._v(_vm._s(txn.wallet_transaction_ref))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Transaction: ")]), _c('span', {
      staticStyle: {
        "padding": "5px",
        "color": "#ffffff"
      },
      style: ({
        backgroundColor: txn.wallet_transaction_type_color
      })
    }, [_vm._v(_vm._s(txn.wallet_transaction_type))])]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Amount: ")]), _vm._v("₦" + _vm._s(_vm.formatCurrency(txn.wallet_transaction_amount)))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Current Balance: ")]), _vm._v("₦" + _vm._s(_vm.formatCurrency(txn.wallet_transaction_current_balance)))]), _vm._v(" "), _c('p', [_c('button', {
      staticClass: "pull-left btn btn-default btn-sm",
      attrs: {
        "type": "button",
        "data-toggle": "modal",
        "data-target": "#viewWalletTransaction"
      },
      on: {
        "click": function($event) {
          _vm.setWalletTransaction(txn)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-info-circle"
    }), _vm._v(" More Details")])])])])
  }))])]) : _c('div', [(!_vm.topup_user_wallet) ? _c('p', {
    staticStyle: {
      "color": "#ff0000",
      "padding-left": "1em"
    }
  }, [_vm._v("User does not have any Wallet Transactions yet")]) : _vm._e()])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "notifications"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "stats-info-agileits"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "stats-body col-md-4"
  }, [_c('p', [_c('b', [_vm._v("Referral Code: ")]), _vm._v(_vm._s(_vm.user.user_referral_code))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("No. of People Referred: " + _vm._s(_vm.user_referral_total))])])]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.user_referrals.length != 0) ? _c('div', {
    staticClass: "stats-body"
  }, [_c('button', {
    staticClass: "btn btn-warning pull-right",
    on: {
      "click": function($event) {
        _vm.togglePanel('referrals')
      }
    }
  }, [_vm._v("View Referrals")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.user_referrals.length != 0) ? _c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "referrals"
    }
  }, [_c('div', {
    staticClass: " p20 mb30 hidden-sm hidden-xs"
  }, [_c('div', {
    staticClass: "p20 col-md-12",
    staticStyle: {
      "overflow-x": "auto",
      "background": "#ffffff"
    }
  }, [_vm._m(6), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_vm._m(7), _vm._v(" "), _vm._l((_vm.user_referrals), function(ref) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(ref.referral_reg_date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ref.referral_referred))]), _vm._v(" "), _c('td', [_c('progress', {
      attrs: {
        "value": ref.referral_reward_obtained,
        "max": ref.referral_reward_to_obtain
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-info-circle",
      attrs: {
        "title": 'Your Referral has completed ' + ref.referral_reward_obtained + '/' + ref.referral_reward_to_obtain + ' transactions needed for you to earn reward'
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ref.referral_status))])])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "background-white p20 mb30 hidden-md hidden-lg"
  }, [_vm._m(8), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, _vm._l((_vm.user_referrals), function(ref) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "padding": "1em"
      }
    }, [_c('p', [_c('b', [_vm._v("Date: ")]), _vm._v(_vm._s(ref.referral_reg_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Referred: ")]), _vm._v(_vm._s(ref.referral_referred))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Reward Progress: ")]), _c('progress', {
      attrs: {
        "value": ref.referral_reward_obtained,
        "max": ref.referral_reward_to_obtain
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-info-circle",
      attrs: {
        "title": 'Your Referral has completed ' + ref.referral_reward_obtained + '/' + ref.referral_reward_to_obtain + ' transactions needed for you to earn reward'
      }
    })]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Status: ")]), _vm._v(_vm._s(ref.referral_status))])])])
  }))])]) : _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000",
      "padding-left": "1.5em"
    }
  }, [_vm._v("No Referrals yet")])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]) : _c('section', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "market-updates"
  }, [_c('div', {
    staticClass: "col-md-3 market-update-gd"
  }, [_c('div', {
    staticClass: "market-update-block clr-block-2"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 market-update-left"
  }, [_c('h4', [_vm._v("Users")]), _vm._v(" "), (_vm.users) ? _c('h3', [_vm._v(_vm._s(_vm.users.length))]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("@ count Today")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "table-agile-info"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("\r\n         Users Lists\r\n        ")]), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "table",
    attrs: {
      "ui-jq": "footable",
      "ui-options": "{\r\n            \"paging\": {\r\n              \"enabled\": true\r\n            },\r\n            \"filtering\": {\r\n              \"enabled\": true\r\n            },\r\n            \"sorting\": {\r\n              \"enabled\": true\r\n            }}"
    }
  }, [_vm._m(10), _vm._v(" "), _c('tbody', _vm._l((_vm.users), function(user, index) {
    return _c('tr', {
      attrs: {
        "data-expanded": "true"
      }
    }, [_c('td', [_vm._v(_vm._s(++index))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.user_fullname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.user_email))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.user_phone))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-success",
      on: {
        "click": function($event) {
          _vm.setPanel('view', user)
        }
      }
    }, [_vm._v("View")])])])
  }))])])])])]), _vm._v(" "), _c('component-footer')], 1), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    staticStyle: {
      "margin-top": "7em"
    },
    attrs: {
      "id": "viewWalletTransaction",
      "tabindex": "-10",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "border-radius": "3px"
    }
  }, [_c('button', {
    staticClass: "pull-right btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.closeModal('#viewWalletTransaction')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', [_c('h5', [_vm._v("Transaction Details")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Date: ")]), _vm._v(_vm._s(_vm.user_wallet_transaction.wallet_transaction_reg_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("REF: ")]), _vm._v(_vm._s(_vm.user_wallet_transaction.wallet_transaction_ref))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Transaction: ")]), _c('span', {
    staticStyle: {
      "padding": "5px",
      "color": "#ffffff"
    },
    style: ({
      backgroundColor: _vm.user_wallet_transaction.wallet_transaction_type_color
    })
  }, [_vm._v(_vm._s(_vm.user_wallet_transaction.wallet_transaction_type))])]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Amount: ")]), _vm._v("₦" + _vm._s(_vm.formatCurrency(_vm.user_wallet_transaction.wallet_transaction_amount)))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Current Balance: ")]), _vm._v("₦" + _vm._s(_vm.formatCurrency(_vm.user_wallet_transaction.wallet_transaction_current_balance)))]), _vm._v(" "), (_vm.user_wallet_transaction.wallet_transaction_service_ref != '') ? _c('div', [(_vm.user_wallet_transaction.wallet_transaction_service != 'error') ? _c('p', [_c('b', [_vm._v(_vm._s(_vm.user_wallet_transaction.wallet_transaction_type) + " Service: ")]), _vm._v(_vm._s(_vm.user_wallet_transaction.wallet_transaction_service))]) : _vm._e(), _vm._v(" "), (_vm.user_wallet_transaction.wallet_transaction_service != 'error') ? _c('p', [_c('b', [_vm._v(_vm._s(_vm.user_wallet_transaction.wallet_transaction_type) + " Service Details: ")]), _vm._v(_vm._s(_vm.user_wallet_transaction.wallet_transaction_service_transaction_name))]) : _vm._e(), _vm._v(" "), _c('p', [_c('b', [_vm._v("Service REF: ")]), _vm._v(_vm._s(_vm.user_wallet_transaction.wallet_transaction_service_ref))])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.user_wallet_transaction.wallet_transaction_action_by_admin == 1) ? _c('div', [_vm._m(11), _vm._v(" "), _c('p', [_c('b', [_vm._v("Details: ")]), _vm._v(_vm._s(_vm.user_wallet_transaction.wallet_transaction_action_by_admin_descr))])]) : _vm._e()])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stats-title"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("USER Statistics")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stats-title"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("USER'S Reward")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', [_c('u', [_vm._v("Transactions")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("~"), _c('span', {
    staticStyle: {
      "font-size": "11px"
    }
  }, [_vm._v("Date")])]), _vm._v(" "), _c('th', [_vm._v("REF")]), _vm._v(" "), _c('th', [_vm._v("Transaction")]), _vm._v(" "), _c('th', [_vm._v("Amount(₦)")]), _vm._v(" "), _c('th', [_vm._v("Current Balance(₦)")]), _vm._v(" "), _c('th', [_vm._v(" --- ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', [_c('u', [_vm._v("Transactions")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stats-title"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("USER'S Referrals")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', [_c('u', [_vm._v("Referrals")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("~"), _c('span', {
    staticStyle: {
      "font-size": "11px"
    }
  }, [_vm._v("Date")])]), _vm._v(" "), _c('th', [_vm._v("Referred")]), _vm._v(" "), _c('th', [_vm._v("Reward Progress")]), _vm._v(" "), _c('th', [_vm._v("Status")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', [_c('u', [_vm._v("Your Referrals")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4 market-update-right"
  }, [_c('i', {
    staticClass: "fa fa-users"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "data-breakpoints": "xs"
    }
  }, [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("First Name")]), _vm._v(" "), _c('th', [_vm._v("Email")]), _vm._v(" "), _c('th', {
    attrs: {
      "data-breakpoints": "xs sm md",
      "data-title": "DOB"
    }
  }, [_vm._v("Phone")]), _vm._v(" "), _c('th', [_vm._v("~")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Topup By Admin: ")]), _vm._v("Yes")])
}]}

/***/ }),
/* 150 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-wrapper"
  }, [_c('div', {
    staticClass: "log-w3"
  }, [_c('div', {
    staticClass: "w3layouts-main",
    staticStyle: {
      "background": "rgba(0,0,0,0.6)"
    }
  }, [_c('h2', [_vm._v("Cityneeds Admin")]), _vm._v(" "), (_vm.mod_message != 'nill') ? _c('p', {
    staticClass: "col-md-12"
  }, [_c('u', [_vm._v(_vm._s(_vm.mod_message))])]) : _vm._e(), _vm._v(" "), (_vm.setActionPanel) ? _c('div', [(_vm.setResetPasswordPanel) ? _c('form', [_c('h4', [_vm._v("Reset Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.admin.new_password),
      expression: "admin.new_password"
    }],
    staticClass: "ggg",
    attrs: {
      "type": "password",
      "placeholder": "Enter new Password",
      "required": ""
    },
    domProps: {
      "value": (_vm.admin.new_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.admin.new_password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.admin.confirm_password),
      expression: "admin.confirm_password"
    }],
    staticClass: "ggg",
    attrs: {
      "type": "password",
      "placeholder": "Confirm Password",
      "required": ""
    },
    domProps: {
      "value": (_vm.admin.confirm_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.admin.confirm_password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.loading) ? _c('p', {
    staticClass: "col-md-12"
  }, [_vm._v("processing...please wait")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.resetPassword
    }
  }, [_vm._v("Reset")]), _vm._v(" "), (_vm.loading) ? _c('p', {
    staticClass: "col-md-12"
  }, [_vm._v("processing...please wait")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.setForgetPasswordPanel) ? _c('form', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.admin.email),
      expression: "admin.email"
    }],
    staticClass: "ggg",
    attrs: {
      "type": "email",
      "placeholder": "Enter E-MAIL",
      "required": ""
    },
    domProps: {
      "value": (_vm.admin.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.admin.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.loading) ? _c('p', {
    staticClass: "col-md-12"
  }, [_vm._v("processing...please wait")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.forgotPassword
    }
  }, [_vm._v("Continue")])]) : _vm._e()]) : _c('div', [_c('form', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.admin.email),
      expression: "admin.email"
    }],
    staticClass: "ggg",
    attrs: {
      "type": "email",
      "placeholder": "E-mail",
      "required": ""
    },
    domProps: {
      "value": (_vm.admin.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.admin.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.admin.password),
      expression: "admin.password"
    }],
    staticClass: "ggg",
    attrs: {
      "type": "password",
      "placeholder": "Password",
      "required": ""
    },
    domProps: {
      "value": (_vm.admin.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.admin.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('h6', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('set_forgot', '')
      }
    }
  }, [_vm._v("Forgot Password?")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.loading) ? _c('p', {
    staticClass: "col-md-12"
  }, [_vm._v("processing...please wait")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("Login")])])])])])])
},staticRenderFns: []}

/***/ }),
/* 151 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "__cov-progress",
    style: (_vm.style)
  })
},staticRenderFns: []}

/***/ }),
/* 152 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "container"
    }
  }, [_c('component-header'), _vm._v(" "), _c('section', {
    attrs: {
      "id": "main-content"
    }
  }, [_c('section', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "table-agile-info"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("\r\n                 CNpro Parent Categories\r\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('add', '')
      }
    }
  }, [_vm._v("Add New Category")])]), _vm._v(" "), (_vm.addRequest) ? _c('div', [_c('label', [_vm._v("Add New Category")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.category.cnpro_parent_category_name),
      expression: "category.cnpro_parent_category_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.category.cnpro_parent_category_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.category.cnpro_parent_category_name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addCnproParentCategory
    }
  }, [_vm._v("Add")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-action', '')
      }
    }
  }, [_vm._v("Cancel")])]) : _vm._e(), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "table",
    attrs: {
      "ui-jq": "footable",
      "ui-options": "{\r\n                    \"paging\": {\r\n                      \"enabled\": true\r\n                    },\r\n                    \"filtering\": {\r\n                      \"enabled\": true\r\n                    },\r\n                    \"sorting\": {\r\n                      \"enabled\": true\r\n                    }}"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.categories), function(cc, index) {
    return _c('tr', {
      attrs: {
        "data-expanded": "true"
      }
    }, [_c('td', [_vm._v(_vm._s(++index))]), _vm._v(" "), _c('td', [((_vm.category.editRequest && (cc.cnpro_parent_category_id == _vm.category.cnpro_parent_category_id))) ? _c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (cc.cnpro_parent_category_name),
        expression: "cc.cnpro_parent_category_name"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (cc.cnpro_parent_category_name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          cc.cnpro_parent_category_name = $event.target.value
        }
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "btn btn-info",
      attrs: {
        "type": "button"
      },
      on: {
        "click": _vm.editCnproParentCategories
      }
    }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('reset-action', '')
        }
      }
    }, [_vm._v("Cancel")])]) : _c('span', [_vm._v("\r\n                                " + _vm._s(cc.cnpro_parent_category_name)), _c('br'), _vm._v(" "), (!(_vm.addSubRequest && (cc.cnpro_parent_category_id == _vm.category.cnpro_parent_category_id))) ? _c('div', {
      staticClass: "pull-left"
    }, [_c('button', {
      staticClass: "btn btn-xs btn-success",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('add_sub', cc)
        }
      }
    }, [_vm._v("Add Sub Category")])]) : _vm._e(), _vm._v(" "), ((_vm.addSubRequest && (cc.cnpro_parent_category_id == _vm.category.cnpro_parent_category_id))) ? _c('div', [_c('label', [_vm._v("Enter Category Name")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.sub_category.cnpro_category_name),
        expression: "sub_category.cnpro_category_name"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.sub_category.cnpro_category_name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.sub_category.cnpro_category_name = $event.target.value
        }
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "btn btn-info",
      attrs: {
        "type": "button"
      },
      on: {
        "click": _vm.addCnproSubCategory
      }
    }, [_vm._v("Add")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('reset-action', '')
        }
      }
    }, [_vm._v("Cancel")])]) : _vm._e()])]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-primary",
      on: {
        "click": function($event) {
          _vm.setComponent('edit', cc)
        }
      }
    }, [_vm._v("Edit")])])])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("\r\n                     CNpro Sub Categories\r\n                    ")]), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "table",
    attrs: {
      "ui-jq": "footable",
      "ui-options": "{\r\n                        \"paging\": {\r\n                          \"enabled\": true\r\n                        },\r\n                        \"filtering\": {\r\n                          \"enabled\": true\r\n                        },\r\n                        \"sorting\": {\r\n                          \"enabled\": true\r\n                        }}"
    }
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.sub_categories), function(cc, index) {
    return _c('tr', {
      attrs: {
        "data-expanded": "true"
      }
    }, [_c('td', [_vm._v(_vm._s(++index))]), _vm._v(" "), _c('td', [((_vm.sub_category.editRequest && (cc.cnpro_category_id == _vm.sub_category.cnpro_category_id))) ? _c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (cc.cnpro_category_name),
        expression: "cc.cnpro_category_name"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (cc.cnpro_category_name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          cc.cnpro_category_name = $event.target.value
        }
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "btn btn-info",
      attrs: {
        "type": "button"
      },
      on: {
        "click": _vm.editCnproSubCategories
      }
    }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('reset-action', '')
        }
      }
    }, [_vm._v("Cancel")])]) : _c('span', [_vm._v("\r\n                                    " + _vm._s(cc.cnpro_category_name) + "\r\n                                ")])]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-primary",
      on: {
        "click": function($event) {
          _vm.setComponent('edit_sub', cc)
        }
      }
    }, [_vm._v("Edit")])])])
  }))])])])])]), _vm._v(" "), _c('component-footer')], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "data-breakpoints": "xs"
    }
  }, [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("CNpro Parent Categories")]), _vm._v(" "), _c('th', [_vm._v("~")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "data-breakpoints": "xs"
    }
  }, [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("CNpro Sub Categories")]), _vm._v(" "), _c('th', [_vm._v("~")])])])
}]}

/***/ }),
/* 153 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "container"
    }
  }, [_c('component-header'), _vm._v(" "), _c('section', {
    attrs: {
      "id": "main-content"
    }
  }, [(_vm.viewFlag) ? _c('section', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "agileits-w3layouts-stats"
  }, [_c('div', {
    staticClass: "col-md-4 stats-info widget"
  }, [_c('div', {
    staticClass: "stats-info-agileits"
  }, [_c('div', {
    staticClass: "stats-title"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.cnpro.cnpro_name))])]), _vm._v(" "), _c('div', {
    staticClass: "stats-body"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.img_url + _vm.cnpro.cnpro_image
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "stats-body"
  }, [_c('label', [_vm._v("Change Picture")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChange($event, _vm.cnpro.cnpro_id, 'cnpros')
      }
    }
  })]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "stats-body"
  }, [_c('label', [_vm._v("CNpro Total Job Done: " + _vm._s(_vm.cnpro.cnpro_jobs_done))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 stats-info stats-last widget-shadow"
  }, [_c('div', {
    staticClass: "notifications"
  }, [_c('header', {
    staticClass: "panel-heading"
  }, [_vm._v("\r\n                             Profile\r\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "notify-w3ls"
  }, [_c('table', {
    staticClass: "table",
    attrs: {
      "ui-jq": "footable",
      "ui-options": "{\r\n                                \"paging\": {\r\n                                \"enabled\": true\r\n                                },\r\n                                \"filtering\": {\r\n                                \"enabled\": true\r\n                                },\r\n                                \"sorting\": {\r\n                                \"enabled\": true\r\n                                }}"
    }
  }, [(_vm.editRequest) ? _c('thead', [_c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cnpro.cnpro_name),
      expression: "cnpro.cnpro_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.cnpro.cnpro_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cnpro.cnpro_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Email")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cnpro.cnpro_email),
      expression: "cnpro.cnpro_email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email"
    },
    domProps: {
      "value": (_vm.cnpro.cnpro_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cnpro.cnpro_email = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Phone")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cnpro.cnpro_phone),
      expression: "cnpro.cnpro_phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.cnpro.cnpro_phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cnpro.cnpro_phone = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Address")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cnpro.cnpro_address),
      expression: "cnpro.cnpro_address"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.cnpro.cnpro_address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cnpro.cnpro_address = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Service Description")]), _vm._v(" "), _c('td', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cnpro.cnpro_description),
      expression: "cnpro.cnpro_description"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.cnpro.cnpro_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cnpro.cnpro_description = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Facebook")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cnpro.cnpro_facebook),
      expression: "cnpro.cnpro_facebook"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.cnpro.cnpro_facebook)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cnpro.cnpro_facebook = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Twitter")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cnpro.cnpro_twitter),
      expression: "cnpro.cnpro_twitter"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.cnpro.cnpro_twitter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cnpro.cnpro_twitter = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Instagram")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cnpro.cnpro_instagram),
      expression: "cnpro.cnpro_instagram"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.cnpro.cnpro_instagram)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cnpro.cnpro_instagram = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th'), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.editListing
    }
  }, [_vm._v("Save")])])])]) : _c('thead', [_c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpro.cnpro_name))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Email")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpro.cnpro_email))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("City")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpro.cnpro_city_name))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Phone")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpro.cnpro_phone))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Address")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpro.cnpro_address))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Service Description")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpro.cnpro_description))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Facebook")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpro.cnpro_facebook))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Twitter")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpro.cnpro_twitter))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Instagram")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpro.cnpro_instagram))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Status")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpro.cnpro_status) + " \r\n                                        "), (_vm.cnpro.cnpro_status_id == 2) ? _c('span', [_c('button', {
    staticClass: "btn btn-info",
    on: {
      "click": function($event) {
        _vm.approveCnpro(_vm.cnpro.cnpro_id)
      }
    }
  }, [_vm._v("Approve")])]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('th'), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.requests('edit')
      }
    }
  }, [_vm._v("Edit")]), _vm._v("  "), _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        _vm.requests('delete')
      }
    }
  }, [_vm._v("Delete")])])]), _vm._v(" "), _c('tr', [_c('th'), _vm._v(" "), (_vm.deleteRequest) ? _c('td', [_c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Do you really want to do this?")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-xs",
    on: {
      "click": _vm.deleteListing
    }
  }, [_vm._v("Yes Delete")]), _vm._v("\r\n                                           \r\n                                        "), _c('button', {
    staticClass: "btn btn-primary btn-xs",
    on: {
      "click": function($event) {
        _vm.requests('reset')
      }
    }
  }, [_vm._v("Cancel")])]) : _vm._e()])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "agileits-w3layouts-stats"
  }, [_c('div', {
    staticClass: "col-md-12 stats-info widget"
  }, [_c('center', [_c('div', {
    staticClass: "stats-info-agileits"
  }, [_c('div', {
    staticClass: "stats-title"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("CNpro Identity Card")])]), _vm._v(" "), _c('div', {
    staticClass: "stats-body"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.img_url + _vm.cnpro.cnpro_identity_card
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "stats-body"
  }, [_c('label', [_vm._v("Change Identity Card")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChange($event, _vm.cnpro.cnpro_id, 'cnpros_id_card')
      }
    }
  })])])])], 1)])]) : _c('section', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "market-updates"
  }, [_c('div', {
    staticClass: "col-md-3 market-update-gd"
  }, [_c('div', {
    staticClass: "market-update-block clr-block-2"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 market-update-left"
  }, [_c('h4', [_vm._v("CNpros")]), _vm._v(" "), (_vm.cnpros) ? _c('h3', [_vm._v(_vm._s(_vm.cnpros.length))]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("@ count Today")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "table-agile-info"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("\r\n         cnpros Lists\r\n        ")]), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "table",
    attrs: {
      "ui-jq": "footable",
      "ui-options": "{\r\n            \"paging\": {\r\n              \"enabled\": true\r\n            },\r\n            \"filtering\": {\r\n              \"enabled\": true\r\n            },\r\n            \"sorting\": {\r\n              \"enabled\": true\r\n            }}"
    }
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.cnpros), function(cnpro, index) {
    return _c('tr', {
      attrs: {
        "data-expanded": "true"
      }
    }, [_c('td', [_vm._v(_vm._s(++index))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(cnpro.cnpro_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(cnpro.cnpro_email))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(cnpro.cnpro_city_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(cnpro.cnpro_phone))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(cnpro.cnpro_status))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-success",
      on: {
        "click": function($event) {
          _vm.setPanel('view', cnpro)
        }
      }
    }, [_vm._v("View")])])])
  }))])])])])]), _vm._v(" "), _c('component-footer')], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4 market-update-right"
  }, [_c('i', {
    staticClass: "fa fa-users"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "data-breakpoints": "xs"
    }
  }, [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("First Name")]), _vm._v(" "), _c('th', [_vm._v("Email")]), _vm._v(" "), _c('th', {
    attrs: {
      "data-breakpoints": "xs"
    }
  }, [_vm._v("City")]), _vm._v(" "), _c('th', {
    attrs: {
      "data-breakpoints": "xs sm md",
      "data-title": "DOB"
    }
  }, [_vm._v("Phone")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("~")])])])
}]}

/***/ }),
/* 154 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "container"
    }
  }, [_c('component-header'), _vm._v(" "), _c('section', {
    attrs: {
      "id": "main-content"
    }
  }, [(_vm.panelFlag) ? _c('section', {
    staticClass: "wrapper"
  }, [(_vm.viewFlag) ? _c('div', [_c('div', {
    staticClass: "agileits-w3layouts-stats"
  }, [_c('div', {
    staticClass: "notifications",
    staticStyle: {
      "margin-bottom": "3em"
    }
  }, [_c('header', {
    staticClass: "panel-heading"
  }, [_vm._v("\r\n                        " + _vm._s(_vm.cninsurance.cninsurance_name) + "\r\n                        "), _c('a', {
    staticClass: "btn btn-success pull-right",
    attrs: {
      "href": "cninsurance"
    }
  }, [_vm._v("Back")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "margin-top": "1em"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.setComponentView('editCNinsurance')
      }
    }
  }, [_vm._v("Edit CNinsurance")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        _vm.setGetComponentView('viewSubmittedForms')
      }
    }
  }, [_vm._v("View Submitted Forms")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), (_vm.component_view.viewFiledComplaints) ? _c('div', [_c('h4', [_vm._v("viewFiledComplaints")])]) : (_vm.component_view.viewFiledClaims) ? _c('div', [_c('h4', [_vm._v("viewFiledClaims")])]) : (_vm.component_view.viewSubmittedForms) ? _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "wn-card"
  }, [(_vm.load_processes) ? _c('div', {
    staticClass: "cx-loading-sm center"
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.cninsurance_forms), function(form_acc, index) {
    return _c('div', {
      staticClass: "wn-card"
    }, [_c('h4', [_c('b', [_vm._v("Submitted by: ")]), _vm._v(_vm._s(form_acc.cninsurance_account_name))]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-default",
      staticStyle: {
        "float": "right"
      },
      on: {
        "click": function($event) {
          _vm.togglePanView('FAC' + index)
        }
      }
    }, [_vm._v("collaspe "), _c('i', {
      staticClass: "fa fa-angle-down"
    })]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    }), _vm._v(" "), _c('table', {
      staticClass: "table",
      staticStyle: {
        "display": "block"
      },
      attrs: {
        "id": 'FAC' + index
      }
    }, [_vm._m(1, true), _vm._v(" "), _c('tbody', _vm._l((form_acc.cninsurance_account_forms), function(form, fndex) {
      return _c('tr', {
        attrs: {
          "data-expanded": "true"
        }
      }, [_c('td', [_vm._v(_vm._s(++fndex))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(form.cninsurance_form_reg_date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(form.cninsurance_form_ref))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(form.cninsurance_form_policy_id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(form.cninsurance_form_sent_status_name))]), _vm._v(" "), _c('td', [(form.cninsurance_form_pay_status == 1) ? _c('span', {
        staticStyle: {
          "line-height": "0.8"
        }
      }, [_vm._v("Paid")]) : _c('span', {
        staticStyle: {
          "color": "#ff0000"
        }
      }, [_vm._v("Not Paid")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Object.keys(form.cninsurance_filed_claims).length))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Object.keys(form.cninsurance_filed_complaints).length))]), _vm._v(" "), _c('td', [_c('button', {
        staticClass: "btn btn-success",
        on: {
          "click": function($event) {
            _vm.setGetComponentView('viewForm', form);
            _vm.storeActiveToggleIndex('form', 'FAC' + index);
          }
        }
      }, [_vm._v("View")])])])
    }))])])
  })], 2)]) : (_vm.component_view.viewForm) ? _c('div', [_c('div', [_c('div', {
    staticClass: "agileits-w3layouts-stats"
  }, [_c('div', {
    staticClass: "col-md-8 col-md-offset-2 stats-info stats-last widget-shadow"
  }, [_c('div', {
    staticClass: "notifications"
  }, [_c('header', {
    staticClass: "panel-heading"
  }, [_vm._v("\r\n                                  Form  Details\r\n                                "), _c('a', {
    staticClass: "btn btn-success pull-right",
    on: {
      "click": function($event) {
        _vm.setGetComponentView('viewSubmittedForms');
        _vm.togglePanView(_vm.toggle_indexes.form)
      }
    }
  }, [_vm._v("Back")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "2em 0"
    }
  }, [_c('h3', {
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_vm._v("Form Details"), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("Policy Id: "), _c('b', [_vm._v(_vm._s(_vm.cninsurance_form.cninsurance_form_policy_id))])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("Policy Number: "), _c('b', [_vm._v(_vm._s(_vm.cninsurance_form.cninsurance_form_policy_number))])])]), _vm._v(" "), (_vm.cninsurance_form.cninsurance_form_certificate_url != 'nil') ? _c('div', {
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('a', {
    staticClass: "btn btn-danger btn-xs",
    attrs: {
      "href": _vm.cninsurance_form.cninsurance_form_certificate_url,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v(" Download Certificate")])]) : _vm._e(), _vm._v(" "), _c('div', {}, [_c('h5', [_vm._v("Form entries")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "border": "#22baae solid 2px",
      "padding": "3em",
      "width": "inherit"
    }
  }, _vm._l((_vm.cninsurance_form.cninsurance_form_entries), function(cform, cfndex) {
    return _c('div', {
      staticClass: "row"
    }, [((cform.cninsurance_form_entry_type % 2) != 0) ? _c('div', {
      staticClass: "wn-fleft wn-h-list"
    }, [_c('h6', {
      staticStyle: {
        "font-size": "16px !important"
      }
    }, [_c('b', [_vm._v(_vm._s(cform.cninsurance_form_entry_type_name))]), _c('br'), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "#413f3f !important"
      }
    }, [_vm._v(_vm._s(cform.cninsurance_form_entry_value))])]), _c('br')]) : _vm._e(), _vm._v(" "), ((cform.cninsurance_form_entry_type % 2) == 0) ? _c('div', {
      staticClass: "wn-fright wn-h-list"
    }, [_c('h6', {
      staticStyle: {
        "font-size": "16px !important"
      }
    }, [_c('b', [_vm._v(_vm._s(cform.cninsurance_form_entry_type_name))]), _c('br'), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "#413f3f !important"
      }
    }, [_vm._v(_vm._s(cform.cninsurance_form_entry_value))])]), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "2em 0"
    }
  }, [_c('div', {}, [_c('h4', [_vm._v("CLAIMS")]), _vm._v(" "), _vm._l((_vm.cninsurance_form.cninsurance_filed_claims), function(cclaim, cclndex) {
    return _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-8 col-md-offset-3 col-xs-12"
    }, [_c('div', {
      staticClass: "wn-h-list"
    }, [_c('h5', [_c('i', {
      staticClass: "fa fa-table",
      staticStyle: {
        "font-size": "1.3em",
        "color": "#22baae",
        "font-weight": "bold"
      }
    }), _vm._v(" " + _vm._s(cclaim.cninsurance_claim_title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(cclaim.cninsurance_claim_reg_date))]), _vm._v(" "), _c('button', {
      staticClass: "pull-right btn btn-default",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setContentView('claim_content', cclaim, '')
        }
      }
    }, [_vm._v("view details")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "2em 0"
    }
  }, [_c('div', {}, [_c('h4', [_vm._v("COMPLAINTS")]), _vm._v(" "), _vm._l((_vm.cninsurance_form.cninsurance_filed_complaints), function(ccomp, ccondex) {
    return _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-8 col-md-offset-3 col-xs-12"
    }, [_c('div', {
      staticClass: "wn-h-list"
    }, [_c('h5', [_c('i', {
      staticClass: "fa fa-table",
      staticStyle: {
        "font-size": "1.3em",
        "color": "#22baae",
        "font-weight": "bold"
      }
    }), _vm._v(" " + _vm._s(ccomp.cninsurance_complaint_title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(ccomp.cninsurance_complaint_reg_date))]), _vm._v(" "), _c('button', {
      staticClass: "pull-right btn btn-default",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setContentView('complaint_content', ccomp, '')
        }
      }
    }, [_vm._v("view details")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])
  })], 2)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]) : (_vm.component_view.editCNinsurance) ? _c('div', [_c('div', {
    staticClass: "notifications"
  }, [_vm._m(2), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "background-white p20"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(3), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cninsurance.cninsurance_name),
      expression: "cninsurance.cninsurance_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.cninsurance.cninsurance_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cninsurance.cninsurance_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(4), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cninsurance.cninsurance_description),
      expression: "cninsurance.cninsurance_description"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.cninsurance.cninsurance_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cninsurance.cninsurance_description = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(5), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cninsurance.cninsurance_tagline),
      expression: "cninsurance.cninsurance_tagline"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.cninsurance.cninsurance_tagline)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cninsurance.cninsurance_tagline = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(6), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cninsurance.cninsurance_tagline),
      expression: "cninsurance.cninsurance_tagline"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.cninsurance.cninsurance_tagline)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cninsurance.cninsurance_tagline = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(7), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cninsurance.cninsurance_commission),
      expression: "cninsurance.cninsurance_commission"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.cninsurance.cninsurance_commission)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cninsurance.cninsurance_commission = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(8), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cninsurance.cninsurance_commission_type),
      expression: "cninsurance.cninsurance_commission_type"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.cninsurance.cninsurance_commission_type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "C"
    }
  }, [_vm._v("Cash")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "P"
    }
  }, [_vm._v("%")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(9), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cninsurance.cninsurance_logo),
      expression: "cninsurance.cninsurance_logo"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.cninsurance.cninsurance_logo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cninsurance.cninsurance_logo = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(10), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cninsurance.cninsurance_banner_image),
      expression: "cninsurance.cninsurance_banner_image"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.cninsurance.cninsurance_banner_image)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cninsurance.cninsurance_banner_image = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "center",
    staticStyle: {
      "margin-top": "2em"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), (_vm.process_loading) ? _c('div', {
    staticClass: "cx-loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.editCNinsuranceDetails
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        _vm.setComponentView('')
      }
    }
  }, [_vm._v("Cancel")])])])])]) : _c('div', [_vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-md-offset-2 stats-info stats-last widget-shadow"
  }, [_c('div', {
    staticClass: "notifications"
  }, [_c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "notify-w3ls col-md-offset-2"
  }, [_c('table', {
    staticClass: "table",
    attrs: {
      "ui-jq": "footable",
      "ui-options": "{\r\n                                      \"paging\": {\r\n                                      \"enabled\": true\r\n                                      },\r\n                                      \"filtering\": {\r\n                                      \"enabled\": true\r\n                                      },\r\n                                      \"sorting\": {\r\n                                      \"enabled\": true\r\n                                      }}"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Date Created")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cninsurance.cninsurance_reg_date))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cninsurance.cninsurance_name))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Tagline")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cninsurance.cninsurance_tagline))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Description")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cninsurance.cninsurance_description))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("CNinsurance Commission")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cninsurance.cninsurance_commission))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("CNinsurance Commission Type")]), _vm._v(" "), _c('td', [(_vm.cninsurance.cninsurance_commission_type == 'C') ? _c('span', [_vm._v("CASH")]) : _vm._e(), _vm._v(" "), (_vm.cninsurance.cninsurance_commission_type == 'P') ? _c('span', [_vm._v("%")]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Logo")]), _vm._v(" "), _c('td', [_c('img', {
    attrs: {
      "src": _vm.cninsurance.cninsurance_logo,
      "width": "200",
      "height": "160"
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Banner Image")]), _vm._v(" "), _c('td', [_c('img', {
    attrs: {
      "src": _vm.cninsurance.cninsurance_banner_image,
      "width": "200",
      "height": "160"
    }
  })])])])]), _vm._v(" "), _vm._m(12), _c('br'), _vm._v(" "), _c('table', _vm._l((_vm.cninsurance.cninsurance_payment_settings), function(fv, index) {
    return _c('tr', [_c('div', [_c('tr', [_c('td', {
      staticStyle: {
        "padding": "3px"
      }
    }, [_vm._v(_vm._s((index + 1)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "3px"
      }
    }, [_vm._v("\r\n                                            " + _vm._s(fv.cninsurance_form_variable_1_name)), _c('br'), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v("(" + _vm._s(fv.cninsurance_form_variable_2_name) + ")")])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "3px"
      }
    }, [_c('b', [_vm._v("NGN" + _vm._s(fv.cninsurance_form_price))]), _c('br'), _vm._v(" "), (_vm.component_attr_view['fva_p' + index]) ? _c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (fv.cninsurance_form_price),
        expression: "fv.cninsurance_form_price"
      }],
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (fv.cninsurance_form_price)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          fv.cninsurance_form_price = $event.target.value
        }
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          _vm.setCNinsuraceFormPrice(_vm.cninsurance, fv)
        }
      }
    }, [_vm._v("OK\r\n                                                "), (_vm.process_loading) ? _c('span', [_c('img', {
      attrs: {
        "src": "/static/assets/images/loader.gif",
        "height": "20px"
      }
    })]) : _vm._e()]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          _vm.setComponentAttributeView('')
        }
      }
    }, [_vm._v("CANCEL")])]) : _vm._e()]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-success",
      on: {
        "click": function($event) {
          _vm.setComponentAttributeView('fva_p' + index)
        }
      }
    }, [_vm._v("edit price")])])])])])
  })), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(13), _c('br'), _vm._v(" "), _c('table', _vm._l((_vm.cninsurance.cninsurance_discounts), function(cd, index) {
    return _c('tr', [_c('div', [_c('th', {
      staticStyle: {
        "padding": "3px"
      }
    }), _vm._v(" "), _c('th', {
      staticStyle: {
        "padding": "3px"
      }
    }, [_vm._v("Code")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "padding": "3px"
      }
    }, [_vm._v("Amount")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "padding": "3px"
      }
    }, [_vm._v("Start")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "padding": "3px"
      }
    }, [_vm._v("End")]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "padding": "3px"
      }
    }, [_vm._v(_vm._s((index + 1)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "3px"
      }
    }, [_vm._v(_vm._s(cd.cninsurance_discount_code))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "3px"
      }
    }, [(cd.cninsurance_discount_type == 'C') ? _c('span', [_vm._v("NGN" + _vm._s(cd.cninsurance_discount_value))]) : (cd.cninsurance_discount_type == 'P') ? _c('span', [_vm._v(_vm._s(cd.cninsurance_discount_value) + "%")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "3px"
      }
    }, [_vm._v(_vm._s(cd.cninsurance_discount_start_date))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "3px"
      }
    }, [_vm._v(_vm._s(cd.cninsurance_discount_expiry_date))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "3px"
      }
    }, [(cd.cninsurance_discount_status == 0) ? _c('span', {
      staticStyle: {
        "padding": "3px",
        "font-size": "13px",
        "border-radius": "5px",
        "background-color": "#ff0000",
        "color": "#ffffff"
      }
    }, [_vm._v("OFF")]) : _vm._e(), _vm._v(" "), (cd.cninsurance_discount_status == 1) ? _c('span', {
      staticStyle: {
        "padding": "3px",
        "font-size": "13px",
        "border-radius": "5px",
        "background-color": "#3da315",
        "color": "#ffffff"
      }
    }, [_vm._v("ON")]) : _vm._e()]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-info",
      on: {
        "click": function($event) {
          _vm.setComponentAttributeView('cndis' + index)
        }
      }
    }, [_vm._v("edit")])])])]), _vm._v(" "), (_vm.component_attr_view['cndis' + index]) ? _c('div', [_c('div', [_c('p', {
      staticStyle: {
        "padding": "3px"
      }
    }, [_c('b', [_vm._v("Discount Code: ")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (cd.cninsurance_discount_code),
        expression: "cd.cninsurance_discount_code"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (cd.cninsurance_discount_code)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          cd.cninsurance_discount_code = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('p', {
      staticStyle: {
        "padding": "3px"
      }
    }, [_c('b', [_vm._v("Discount Type: ")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (cd.cninsurance_discount_type),
        expression: "cd.cninsurance_discount_type"
      }],
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          cd.cninsurance_discount_type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }
      }
    }, [_c('option', {
      attrs: {
        "value": "C"
      }
    }, [_vm._v("Cash")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "P"
      }
    }, [_vm._v("%")])])]), _vm._v(" "), _c('p', {
      staticStyle: {
        "padding": "3px"
      }
    }, [_c('b', [_vm._v("Discount Amount: ")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (cd.cninsurance_discount_value),
        expression: "cd.cninsurance_discount_value"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (cd.cninsurance_discount_value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          cd.cninsurance_discount_value = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('p', {
      staticStyle: {
        "padding": "3px"
      }
    }, [_c('b', [_vm._v("Discount Start Date: ")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (cd.cninsurance_discount_start_date),
        expression: "cd.cninsurance_discount_start_date"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "date"
      },
      domProps: {
        "value": (cd.cninsurance_discount_start_date)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          cd.cninsurance_discount_start_date = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('p', {
      staticStyle: {
        "padding": "3px"
      }
    }, [_c('b', [_vm._v("Discount Expiry Date: ")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (cd.cninsurance_discount_expiry_date),
        expression: "cd.cninsurance_discount_expiry_date"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "date"
      },
      domProps: {
        "value": (cd.cninsurance_discount_expiry_date)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          cd.cninsurance_discount_expiry_date = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('p', {
      staticStyle: {
        "padding": "3px"
      }
    }, [_c('b', [_vm._v("Activate/Deactivate: ")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (cd.cninsurance_discount_status),
        expression: "cd.cninsurance_discount_status"
      }],
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          cd.cninsurance_discount_status = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }
      }
    }, [_c('option', {
      attrs: {
        "value": "1"
      }
    }, [_vm._v("ON")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "0"
      }
    }, [_vm._v("OFF")])])]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          _vm.updateDiscount(cd)
        }
      }
    }, [_vm._v("OK\r\n                                            "), (_vm.process_loading) ? _c('span', [_c('img', {
      attrs: {
        "src": "/static/assets/images/loader.gif",
        "height": "20px"
      }
    })]) : _vm._e()]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          _vm.setComponentAttributeView('')
        }
      }
    }, [_vm._v("CANCEL")])])]) : _vm._e()])
  })), _vm._v(" "), _c('hr'), _vm._v(" "), (!_vm.component_view.add_new_discount) ? _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.setComponentView('add_new_discount')
      }
    }
  }, [_vm._v("Add new CNinsurance Discounts")]) : _vm._e(), _vm._v(" "), (_vm.component_view.add_new_discount) ? _c('div', [_vm._m(14), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "background-white p20"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(15), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cninsurance_discount.discount_code),
      expression: "cninsurance_discount.discount_code"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter Unique Discount Code"
    },
    domProps: {
      "value": (_vm.cninsurance_discount.discount_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cninsurance_discount.discount_code = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(16), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cninsurance_discount.discount_start_date),
      expression: "cninsurance_discount.discount_start_date"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.cninsurance_discount.discount_start_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cninsurance_discount.discount_start_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(17), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cninsurance_discount.discount_expiry_date),
      expression: "cninsurance_discount.discount_expiry_date"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.cninsurance_discount.discount_expiry_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cninsurance_discount.discount_expiry_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Discount Type: ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cninsurance_discount.discount_type),
      expression: "cninsurance_discount.discount_type"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.cninsurance_discount.discount_type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "C"
    }
  }, [_vm._v("Cash")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "P"
    }
  }, [_vm._v("%")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Discount Amount")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cninsurance_discount.discount_value),
      expression: "cninsurance_discount.discount_value"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.cninsurance_discount.discount_value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cninsurance_discount.discount_value = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "center",
    staticStyle: {
      "margin-top": "2em"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), (_vm.process_loading) ? _c('div', {
    staticClass: "cx-loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.addNewDiscount
    }
  }, [_vm._v("Add discount")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        _vm.setComponentView('')
      }
    }
  }, [_vm._v("Cancel")])])])]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _vm._e()]) : _c('section', {
    staticClass: "wrapper"
  }, [(_vm.load_processes) ? _c('div', {
    staticClass: "cx-loading-sm center"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "table-agile-info",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("\r\n                  CNinsurance Listings\r\n                ")]), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "table",
    attrs: {
      "ui-jq": "footable",
      "ui-options": "{\r\n                    \"paging\": {\r\n                      \"enabled\": true\r\n                    },\r\n                    \"filtering\": {\r\n                      \"enabled\": true\r\n                    },\r\n                    \"sorting\": {\r\n                      \"enabled\": true\r\n                    }}"
    }
  }, [_vm._m(18), _vm._v(" "), _c('tbody', _vm._l((_vm.cninsurance_listings), function(cninsurance, index) {
    return _c('tr', {
      attrs: {
        "data-expanded": "true"
      }
    }, [_c('td', [_vm._v(_vm._s(++index))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(cninsurance.cninsurance_reg_date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(cninsurance.cninsurance_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(cninsurance.cninsurance_cost))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(cninsurance.cninsurance_total_forms))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(cninsurance.cninsurance_total_amount_sold))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-success",
      on: {
        "click": function($event) {
          _vm.setPanel('view', cninsurance)
        }
      }
    }, [_vm._v("View")])])])
  }))])])])])]), _vm._v(" "), _c('component-footer')], 1), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    staticStyle: {
      "margin-top": "7em"
    },
    attrs: {
      "id": "form_content",
      "tabindex": "-10",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "border-radius": "3px"
    }
  }, [_c('button', {
    staticClass: "pull-right btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.closeModal('paywith')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _vm._m(19)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    staticStyle: {
      "margin-top": "7em"
    },
    attrs: {
      "id": "claim_content",
      "tabindex": "-10",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "border-radius": "3px"
    }
  }, [_c('button', {
    staticClass: "pull-right btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.closeModal('paywith')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "clear": "both",
      "word-wrap": "break-word"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "width": "inherit"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "inherit"
    }
  }, [_c('h3', {
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_vm._v("Claim Details"), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("Form Policy Id: "), _c('b', [_vm._v(_vm._s(_vm.cninsurance_claim.cninsurance_claim_form_policy_id))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticStyle: {
      "border": "#22baae solid 2px",
      "padding": "3em",
      "width": "inherit"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "wn-fleft"
  }, [_c('h6', [_c('b', [_vm._v("Claim Title ")]), _c('br'), _c('br'), _vm._v("\r\n                                            " + _vm._s(_vm.cninsurance_claim.cninsurance_claim_title) + "\r\n                                        ")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Complaint Details")]), _c('br'), _vm._v("\r\n                                            " + _vm._s(_vm.cninsurance_claim.cninsurance_claim_details) + "\r\n                                        ")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Date Submitted")]), _c('br'), _vm._v("\r\n                                            " + _vm._s(_vm.cninsurance_claim.cninsurance_claim_reg_date) + "\r\n                                        ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    staticStyle: {
      "margin-top": "7em"
    },
    attrs: {
      "id": "complaint_content",
      "tabindex": "-10",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "border-radius": "3px"
    }
  }, [_c('button', {
    staticClass: "pull-right btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.closeModal('paywith')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "clear": "both",
      "word-wrap": "break-word"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "width": "inherit"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "inherit"
    }
  }, [_c('h3', {
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_vm._v("Complaint Details"), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("Form Policy Id: "), _c('b', [_vm._v(_vm._s(_vm.cninsurance_complaint.cninsurance_complaint_form_policy_id))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticStyle: {
      "border": "#22baae solid 2px",
      "padding": "3em",
      "width": "inherit"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "wn-fleft"
  }, [_c('h6', [_c('b', [_vm._v("Complaint Title ")]), _c('br'), _c('br'), _vm._v("\r\n                                            " + _vm._s(_vm.cninsurance_complaint.cninsurance_complaint_title) + "\r\n                                        ")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Complaint Details")]), _c('br'), _vm._v("\r\n                                            " + _vm._s(_vm.cninsurance_complaint.cninsurance_complaint_details) + "\r\n                                        ")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Date Submitted")]), _c('br'), _vm._v("\r\n                                            " + _vm._s(_vm.cninsurance_complaint.cninsurance_complaint_reg_date) + "\r\n                                        ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])])])])])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wn-card"
  }, [_c('h4', [_vm._v("View Submitted Forms")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "data-breakpoints": "xs"
    }
  }, [_vm._v("S/N")]), _vm._v(" "), _c('th', [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v("Form Ref")]), _vm._v(" "), _c('th', [_vm._v("Policy Id")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Paid")]), _vm._v(" "), _c('th', [_vm._v("Claims")]), _vm._v(" "), _c('th', [_vm._v("Complaints")]), _vm._v(" "), _c('th', [_vm._v("~")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('u', [_vm._v("Edit CNinsurance Details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("CNinsurance Name"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("CNinsurance Description"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("CNinsurance Tagline"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("CNinsurance Admin Email"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*(for mailing forms)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("CNinsurance Commission"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("CNinsurance Commission Type"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("CNinsurance Logo Link"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("CNinsurance Banner Image Link"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-8 col-md-offset-2 stats-info stats-last widget-shadow",
    staticStyle: {
      "clear": "both",
      "margin-bottom": "3em",
      "display": "none"
    }
  }, [_c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('u', [_vm._v("CNinsurance Form Pricing")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('u', [_vm._v("CNinsurance Discounts")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('u', [_vm._v("Add new CNinsurance Discount")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Discount Code"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Start Date"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Expiry Date"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "data-breakpoints": "xs"
    }
  }, [_vm._v("S/N")]), _vm._v(" "), _c('th', [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Service Cost")]), _vm._v(" "), _c('th', [_vm._v("Total Forms")]), _vm._v(" "), _c('th', [_vm._v("Total Amount")]), _vm._v(" "), _c('th', [_vm._v("~")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "clear": "both",
      "word-wrap": "break-word"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._v("\r\n                    form_content\r\n                    ")])])
}]}

/***/ }),
/* 155 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "container"
    }
  }, [_c('component-header'), _vm._v(" "), _c('section', {
    attrs: {
      "id": "main-content"
    }
  }, [(_vm.panelFlag) ? _c('section', {
    staticClass: "wrapper"
  }, [(_vm.viewFlag) ? _c('div', [_c('div', {
    staticClass: "agileits-w3layouts-stats"
  }, [_c('div', {
    staticClass: "col-md-8 col-md-offset-2 stats-info stats-last widget-shadow"
  }, [_c('div', {
    staticClass: "notifications"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "notify-w3ls col-md-offset-2"
  }, [_c('table', {
    staticClass: "table",
    attrs: {
      "ui-jq": "footable",
      "ui-options": "{\r\n                                    \"paging\": {\r\n                                    \"enabled\": true\r\n                                    },\r\n                                    \"filtering\": {\r\n                                    \"enabled\": true\r\n                                    },\r\n                                    \"sorting\": {\r\n                                    \"enabled\": true\r\n                                    }}"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Date Paid")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpayment.cnpay_paga_reg_date))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Payment Ref")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpayment.cnpay_paga_txn_ref))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("PAGA Merchant")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpayment.cnpay_paga_merchant_name))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Paga Service")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpayment.cnpay_paga_merchant_service_name))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Paga Service Code")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpayment.cnpay_paga_payercodeAtBiller))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Paga Service Amount")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpayment.cnpay_paga_merchant_service_price))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Paga Service Charges")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpayment.cnpay_paga_merchant_service_commission))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Paga Total Paid")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpayment.cnpay_paga_total_paid_amt))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Paga Transaction Message")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpayment.cnpay_paga_transaction_message))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Paga Transaction Id")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpayment.cnpay_paga_transaction_transactionId))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Paga Available Balance")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpayment.cnpay_paga_transaction_availableBalance))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Paga Agent Commission")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpayment.cnpay_paga_transaction_agentCommission))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Paga Transaction Confrirmation Code")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpayment.cnpay_paga_transaction_confirmationCode))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Payer Name")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpayment.cnpay_paga_payerfirstname) + " " + _vm._s(_vm.cnpayment.cnpay_paga_payerlastname))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Payer Email")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpayment.cnpay_paga_payeremail))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Payer Phone No.")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpayment.cnpay_paga_payerphonenumber))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Transaction Status")]), _vm._v(" "), (_vm.cnpayment.cnpay_paga_transaction_status == 1) ? _c('td', [_vm._v("Payment Made, Awaiting Service Delivery")]) : _vm._e(), _vm._v(" "), (_vm.cnpayment.cnpay_paga_transaction_status == 2) ? _c('td', [_vm._v("Successful")]) : _vm._e()])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _vm._e()]) : _c('section', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "market-updates"
  }, [_c('div', {
    staticClass: "col-md-3 market-update-gd"
  }, [_c('div', {
    staticClass: "market-update-block clr-block-2"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 market-update-left"
  }, [_c('h4', [_vm._v(" CNpay (Paga) ")]), _vm._v(" "), (_vm.cnpayments) ? _c('h3', [_vm._v(_vm._s(_vm.cnpayments.length))]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("@ count Today")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "table-agile-info"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("\r\n         CNpay (Paga) Transactions \r\n        ")]), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "table",
    attrs: {
      "ui-jq": "footable",
      "ui-options": "{\r\n            \"paging\": {\r\n              \"enabled\": true\r\n            },\r\n            \"filtering\": {\r\n              \"enabled\": true\r\n            },\r\n            \"sorting\": {\r\n              \"enabled\": true\r\n            }}"
    }
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.cnpayments), function(cnpayment, index) {
    return _c('tr', {
      attrs: {
        "data-expanded": "true"
      }
    }, [_c('td', [_vm._v(_vm._s(++index))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(cnpayment.cnpay_paga_reg_date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(cnpayment.cnpay_paga_txn_ref))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(cnpayment.cnpay_paga_merchant_service_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(cnpayment.cnpay_paga_payercodeAtBiller))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(cnpayment.cnpay_paga_merchant_service_price))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(cnpayment.cnpay_paga_merchant_service_commission))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(cnpayment.cnpay_paga_payerfirstname) + " " + _vm._s(cnpayment.cnpay_paga_payerlastname))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-success",
      on: {
        "click": function($event) {
          _vm.setPanel('view', cnpayment)
        }
      }
    }, [_vm._v("View")])])])
  }))])])])])]), _vm._v(" "), _c('component-footer')], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "panel-heading"
  }, [_vm._v("\r\n                                    Payment Details Paga\r\n                                    "), _c('a', {
    staticClass: "btn btn-success pull-right",
    attrs: {
      "href": "cnpaymentspaga"
    }
  }, [_vm._v("Back")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4 market-update-right"
  }, [_c('i', {
    staticClass: "fa fa-money-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "data-breakpoints": "xs"
    }
  }, [_vm._v("S/N")]), _vm._v(" "), _c('th', [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v("REF.")]), _vm._v(" "), _c('th', [_vm._v("Service")]), _vm._v(" "), _c('th', [_vm._v("Service Code")]), _vm._v(" "), _c('th', [_vm._v("Service Amount")]), _vm._v(" "), _c('th', [_vm._v("Service Charge")]), _vm._v(" "), _c('th', [_vm._v("Payer")]), _vm._v(" "), _c('th', [_vm._v("~")])])])
}]}

/***/ }),
/* 156 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "container"
    }
  }, [_c('component-header'), _vm._v(" "), _c('section', {
    attrs: {
      "id": "main-content"
    }
  }, [_c('section', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "market-updates"
  }, [_c('div', {
    staticClass: "col-md-3 market-update-gd"
  }, [_c('div', {
    staticClass: "market-update-block clr-block-2"
  }, [_c('div', {
    staticClass: "col-md-12 market-update-left"
  }, [_c('h4', [_vm._v("Total Referrals")]), _vm._v(" "), (_vm.users) ? _c('h3', [_vm._v(_vm._s(_vm.total_referrals))]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("@ count Today")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "table-agile-info"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("\r\n       Referral Transactions\r\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "notifications"
  }, [_c('table', {
    staticClass: "table hidden-sm hidden-xs"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.referrals), function(ref) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(ref.referral_reg_date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ref.referral_referrer))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ref.referral_referred))]), _vm._v(" "), _c('td', [_c('progress', {
      attrs: {
        "value": ref.referral_reward_obtained,
        "max": ref.referral_reward_to_obtain
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-info-circle",
      attrs: {
        "title": 'Completed ' + ref.referral_reward_obtained + '/' + ref.referral_reward_to_obtain + ' transactions needed to earn reward'
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ref.referral_status))])])
  })], 2), _vm._v(" "), _c('table', {
    staticClass: "table hidden-md hidden-lg"
  }, _vm._l((_vm.referrals), function(ref) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "padding": "1em"
      }
    }, [_c('p', [_c('b', [_vm._v("Date: ")]), _vm._v(_vm._s(ref.referral_reg_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Referrer: ")]), _vm._v(_vm._s(ref.referral_referrer))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Referred: ")]), _vm._v(_vm._s(ref.referral_referred))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Reward Progress: ")]), _c('progress', {
      attrs: {
        "value": ref.referral_reward_obtained,
        "max": ref.referral_reward_to_obtain
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-info-circle",
      attrs: {
        "title": 'Completed ' + ref.referral_reward_obtained + '/' + ref.referral_reward_to_obtain + ' transactions needed to earn reward'
      }
    })]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Status: ")]), _vm._v(_vm._s(ref.referral_status))])])])
  }))])])])]), _vm._v(" "), _c('component-footer')], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("~"), _c('span', {
    staticStyle: {
      "font-size": "11px"
    }
  }, [_vm._v("Date")])]), _vm._v(" "), _c('th', [_vm._v("Referrer")]), _vm._v(" "), _c('th', [_vm._v("Referred")]), _vm._v(" "), _c('th', [_vm._v("Reward Progress")]), _vm._v(" "), _c('th', [_vm._v("Status")])])
}]}

/***/ }),
/* 157 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "container"
    }
  }, [_c('component-header'), _vm._v(" "), _c('section', {
    attrs: {
      "id": "main-content"
    }
  }, [(_vm.panelFlag) ? _c('section', {
    staticClass: "wrapper"
  }, [(_vm.viewFlag) ? _c('div', [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _c('section', {
    staticClass: "wrapper"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "table-agile-info"
  }, [_c('div', {
    staticClass: "col-xs-3",
    staticStyle: {
      "margin-right": "1em"
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.setPageView('messages')
      }
    }
  }, [_vm._v("Messages")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3",
    staticStyle: {
      "margin-right": "1em"
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.setPageView('subscribers')
      }
    }
  }, [_vm._v("Subscribers")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3",
    staticStyle: {
      "margin-right": "1em"
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.setPageView('notifications')
      }
    }
  }, [_vm._v("Notifications")])])]), _vm._v(" "), (_vm.page_view == 'messages') ? _c('div', {
    staticClass: "table-agile-info"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("\r\n              Messages \r\n              ")]), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "table",
    attrs: {
      "ui-jq": "footable",
      "ui-options": "{\r\n                  \"paging\": {\r\n                    \"enabled\": true\r\n                  },\r\n                  \"filtering\": {\r\n                    \"enabled\": true\r\n                  },\r\n                  \"sorting\": {\r\n                    \"enabled\": true\r\n                  }}"
    }
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.messages), function(message, index) {
    return _c('tr', {
      attrs: {
        "data-expanded": "true"
      }
    }, [(message.message_read == 0) ? [_c('td', {
      staticClass: "bold-row"
    }, [_vm._v(_vm._s(++index))]), _vm._v(" "), _c('td', {
      staticClass: "bold-row"
    }, [_vm._v(_vm._s(message.message_date))]), _vm._v(" "), _c('td', {
      staticClass: "bold-row"
    }, [_vm._v(_vm._s(message.message_from))]), _vm._v(" "), _c('td', {
      staticClass: "bold-row"
    }, [_vm._v(_vm._s(message.message_body))])] : [_c('td', [_vm._v(_vm._s(++index))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(message.message_date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(message.message_from))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(message.message_body))])]], 2)
  }))])])])]) : _vm._e(), _vm._v(" "), (_vm.page_view == 'subscribers') ? _c('div', {
    staticClass: "table-agile-info"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("\r\n              Subcribers List\r\n              ")]), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "table",
    attrs: {
      "ui-jq": "footable",
      "ui-options": "{\r\n                  \"paging\": {\r\n                    \"enabled\": true\r\n                  },\r\n                  \"filtering\": {\r\n                    \"enabled\": true\r\n                  },\r\n                  \"sorting\": {\r\n                    \"enabled\": true\r\n                  }}"
    }
  }, [_vm._m(3), _vm._v(" "), _c('tbody', _vm._l((_vm.subscribers), function(sub, index) {
    return _c('tr', {
      attrs: {
        "data-expanded": "true"
      }
    }, [_c('td', [_vm._v(_vm._s(++index))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(sub.subscription_date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(sub.subscription_email))])])
  }))])])])]) : _vm._e(), _vm._v(" "), (_vm.page_view == 'notifications') ? _c('div', {
    staticClass: "table-agile-info col-xs-12",
    staticStyle: {
      "margin-top": "-0.15em"
    }
  }, [_c('div', {
    staticClass: "panel panel-default col-xs-12"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("Notifications")]), _vm._v(" "), (_vm.show_notification_form) ? _c('div', {
    staticClass: "stats-body",
    staticStyle: {
      "margin": "1em"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "float": "right",
      "margin-right": "1em",
      "margin-top": "1em"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.show_notification_form = false
      }
    }
  }, [_vm._v("Back")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "1em"
    }
  }, [_vm._m(4), _vm._v(" "), (_vm.data_message_error != '') ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_message_error))]) : _vm._e()]), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', [_vm._v("Subject:")]), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.notification.notification_subject),
      expression: "notification.notification_subject"
    }],
    staticClass: "form_control col-md-8 col-xs-12",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.notification.notification_subject)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.notification.notification_subject = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('b', [_vm._v("Message:")]), _c('br'), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.notification.notification_message),
      expression: "notification.notification_message"
    }],
    staticClass: "form_control col-md-8 col-xs-12",
    staticStyle: {
      "height": "150px"
    },
    domProps: {
      "value": (_vm.notification.notification_message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.notification.notification_message = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('hr'), _vm._v(" "), _c('p', [_vm._v("Select Action or Enter a URL (Link)")]), _vm._v(" "), _c('label', [_vm._v("Action (Which part of the App this is notification is directed to):")]), _c('br'), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.notification.notification_action),
      expression: "notification.notification_action"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.notification.notification_action = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "insurance"
    }
  }, [_vm._v("InsureMoto")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "discounts"
    }
  }, [_vm._v("Discounts")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "rewards"
    }
  }, [_vm._v("Rewards")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "account"
    }
  }, [_vm._v("Referral")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "plans"
    }
  }, [_vm._v("CNpro Plans")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', [_vm._v("Link (URL):")]), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.notification.notification_url),
      expression: "notification.notification_url"
    }],
    staticClass: "form_control col-md-8 col-xs-12",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.notification.notification_url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.notification.notification_url = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', [_vm._v("Upload Image (?)")]), _c('br'), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChange($event)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12"
  }, [(_vm.data_message_error != '') ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_message_error))]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.sendNotification
    }
  }, [_vm._v("Send")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.show_notification_form = false;
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('br'), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "float": "right",
      "margin-right": "1em",
      "margin-top": "1em"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.show_notification_form = false
      }
    }
  }, [_vm._v("Back")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('hr')]) : _c('div', {
    staticClass: "stats-body"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "float": "right",
      "margin-right": "1em",
      "margin-top": "1em"
    }
  }, [_c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        _vm.show_notification_form = true
      }
    }
  }, [_vm._v("Send Notification")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('table', {
    staticClass: "table",
    attrs: {
      "ui-jq": "footable",
      "ui-options": "{\r\n                  \"paging\": {\r\n                    \"enabled\": true\r\n                  },\r\n                  \"filtering\": {\r\n                    \"enabled\": true\r\n                  },\r\n                  \"sorting\": {\r\n                    \"enabled\": true\r\n                  }}"
    }
  }, [_vm._m(5), _vm._v(" "), _c('tbody', _vm._l((_vm.notifications), function(noti, index) {
    return _c('tr', {
      attrs: {
        "data-expanded": "true"
      }
    }, [_c('td', [_vm._v(_vm._s(++index))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(noti.notification_date)), _c('br'), _vm._v(_vm._s(noti.notification_time_ago))]), _vm._v(" "), _c('td', [_c('h6', [_vm._v("Subject")]), _vm._v("\r\n                        " + _vm._s(noti.notification_subject) + "\r\n                        "), _c('h6', [_vm._v("Message")]), _vm._v("\r\n                        " + _vm._s(noti.notification_message) + "\r\n                      ")]), _vm._v(" "), _c('td', [_c('img', {
      staticStyle: {
        "min-height": "220px",
        "max-height": "380px"
      },
      attrs: {
        "src": noti.notification_image
      }
    })]), _vm._v(" "), _c('td', [(_vm.setDelete == index) ? _c('div', [_c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v("Delete notification?")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-success",
      on: {
        "click": function($event) {
          _vm.deleteNotification(noti.notification_id)
        }
      }
    }, [(_vm.disable_btn) ? _c('span', [_c('i', {
      staticClass: "fa fa-circle-o-notch fa-spin"
    })]) : _c('span', [_vm._v("Yes, Delete")])])]) : _c('button', {
      staticClass: "btn btn-success",
      on: {
        "click": function($event) {
          _vm.setDelete = index;
        }
      }
    }, [_vm._v("Delete")])])])
  }))])])])]) : _vm._e()]), _vm._v(" "), _c('component-footer')], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "agileits-w3layouts-stats"
  }, [_c('div', {
    staticClass: "col-md-8 col-md-offset-2 stats-info stats-last widget-shadow"
  }, [_c('div', {
    staticClass: "notifications"
  }, [_c('header', {
    staticClass: "panel-heading"
  }, [_vm._v("\r\n                                    Message Details \r\n                                    "), _c('a', {
    staticClass: "btn btn-success pull-right",
    attrs: {
      "href": "messages"
    }
  }, [_vm._v("Back")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "market-updates"
  }, [_c('div', {
    staticClass: "clearfix"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "data-breakpoints": "xs"
    }
  }, [_vm._v("S/N")]), _vm._v(" "), _c('th', [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v("From")]), _vm._v(" "), _c('th', [_vm._v("Message")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "data-breakpoints": "xs"
    }
  }, [_vm._v("S/N")]), _vm._v(" "), _c('th', [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v("Email")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_c('u', [_vm._v("Send Notification")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "data-breakpoints": "xs"
    }
  }, [_vm._v("S/N")]), _vm._v(" "), _c('th', [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v("Details")])])])
}]}

/***/ }),
/* 158 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "container"
    }
  }, [_c('component-header'), _vm._v(" "), _c('section', {
    attrs: {
      "id": "main-content"
    }
  }, [(_vm.panelFlag) ? _c('section', {
    staticClass: "wrapper"
  }, [(_vm.viewFlag) ? _c('div', [_c('div', {
    staticClass: "agileits-w3layouts-stats"
  }, [_c('div', {
    staticClass: "col-md-8 col-md-offset-2 stats-info stats-last widget-shadow"
  }, [_c('div', {
    staticClass: "notifications"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "notify-w3ls col-md-offset-2"
  }, [_c('table', {
    staticClass: "table",
    attrs: {
      "ui-jq": "footable",
      "ui-options": "{\r\n                                    \"paging\": {\r\n                                    \"enabled\": true\r\n                                    },\r\n                                    \"filtering\": {\r\n                                    \"enabled\": true\r\n                                    },\r\n                                    \"sorting\": {\r\n                                    \"enabled\": true\r\n                                    }}"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Date Paid")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpayment.cnpay_paga_reg_date))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Payment Ref")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpayment.cnpay_paga_txn_ref))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("PAGA Merchant")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpayment.cnpay_paga_merchant_name))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Paga Service")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpayment.cnpay_paga_merchant_service_name))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Paga Service Code")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpayment.cnpay_paga_payercodeAtBiller))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Paga Service Amount")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpayment.cnpay_paga_merchant_service_price))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Paga Service Charges")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpayment.cnpay_paga_merchant_service_commission))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Paga Total Paid")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpayment.cnpay_paga_total_paid_amt))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Paga Transaction Message")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpayment.cnpay_paga_transaction_message))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Paga Transaction Id")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpayment.cnpay_paga_transaction_transactionId))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Paga Available Balance")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpayment.cnpay_paga_transaction_availableBalance))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Paga Agent Commission")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpayment.cnpay_paga_transaction_agentCommission))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Paga Transaction Confrirmation Code")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpayment.cnpay_paga_transaction_confirmationCode))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Payer Name")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpayment.cnpay_paga_payerfirstname) + " " + _vm._s(_vm.cnpayment.cnpay_paga_payerlastname))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Payer Email")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpayment.cnpay_paga_payeremail))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Payer Phone No.")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpayment.cnpay_paga_payerphonenumber))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Transaction Status")]), _vm._v(" "), (_vm.cnpayment.cnpay_paga_transaction_status == 1) ? _c('td', [_vm._v("Payment Made, Awaiting Service Delivery")]) : _vm._e(), _vm._v(" "), (_vm.cnpayment.cnpay_paga_transaction_status == 2) ? _c('td', [_vm._v("Successful")]) : _vm._e()])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _vm._e()]) : _c('section', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "market-updates"
  }, [_c('div', {
    staticClass: "col-md-3 market-update-gd"
  }, [_c('div', {
    staticClass: "market-update-block clr-block-2"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 market-update-left"
  }, [_c('h4', [_vm._v(" CNpay (Paga) ")]), _vm._v(" "), (_vm.cnpayments) ? _c('h3', [_vm._v(_vm._s(_vm.cnpayments.length))]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("@ count Today")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "table-agile-info"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("\r\n         CNpay (Paga) Transactions \r\n        ")]), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "table",
    attrs: {
      "ui-jq": "footable",
      "ui-options": "{\r\n            \"paging\": {\r\n              \"enabled\": true\r\n            },\r\n            \"filtering\": {\r\n              \"enabled\": true\r\n            },\r\n            \"sorting\": {\r\n              \"enabled\": true\r\n            }}"
    }
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.cnpayments), function(cnpayment, index) {
    return _c('tr', {
      attrs: {
        "data-expanded": "true"
      }
    }, [_c('td', [_vm._v(_vm._s(++index))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(cnpayment.cnpay_paga_reg_date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(cnpayment.cnpay_paga_txn_ref))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(cnpayment.cnpay_paga_merchant_service_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(cnpayment.cnpay_paga_payercodeAtBiller))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(cnpayment.cnpay_paga_merchant_service_price))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(cnpayment.cnpay_paga_merchant_service_commission))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(cnpayment.cnpay_paga_payerfirstname) + " " + _vm._s(cnpayment.cnpay_paga_payerlastname))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-success",
      on: {
        "click": function($event) {
          _vm.setPanel('view', cnpayment)
        }
      }
    }, [_vm._v("View")])])])
  }))])])])])]), _vm._v(" "), _c('component-footer')], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "panel-heading"
  }, [_vm._v("\r\n                                    Payment Details Paga\r\n                                    "), _c('a', {
    staticClass: "btn btn-success pull-right",
    attrs: {
      "href": "cnpaymentspaga"
    }
  }, [_vm._v("Back")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4 market-update-right"
  }, [_c('i', {
    staticClass: "fa fa-money-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "data-breakpoints": "xs"
    }
  }, [_vm._v("S/N")]), _vm._v(" "), _c('th', [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v("REF.")]), _vm._v(" "), _c('th', [_vm._v("Service")]), _vm._v(" "), _c('th', [_vm._v("Service Code")]), _vm._v(" "), _c('th', [_vm._v("Service Amount")]), _vm._v(" "), _c('th', [_vm._v("Service Charge")]), _vm._v(" "), _c('th', [_vm._v("Payer")]), _vm._v(" "), _c('th', [_vm._v("~")])])])
}]}

/***/ }),
/* 159 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "container"
    }
  }, [_c('component-header'), _vm._v(" "), _c('section', {
    attrs: {
      "id": "main-content"
    }
  }, [(_vm.panelFlag) ? _c('section', {
    staticClass: "wrapper"
  }, [(_vm.viewFlag) ? _c('div', [_c('div', {
    staticClass: "agileits-w3layouts-stats"
  }, [_c('div', {
    staticClass: "col-md-8 col-md-offset-2 stats-info stats-last widget-shadow"
  }, [_c('div', {
    staticClass: "notifications"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "notify-w3ls col-md-offset-2"
  }, [_c('table', {
    staticClass: "table",
    attrs: {
      "ui-jq": "footable",
      "ui-options": "{\r\n                                    \"paging\": {\r\n                                    \"enabled\": true\r\n                                    },\r\n                                    \"filtering\": {\r\n                                    \"enabled\": true\r\n                                    },\r\n                                    \"sorting\": {\r\n                                    \"enabled\": true\r\n                                    }}"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Date Paid")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpayment.cnpay_reg_date))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Payment Ref")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpayment.cnpay_txn_ref))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("RRR")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpayment.cnpay_rrr))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Payer Name")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpayment.cnpay_payername))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Payer Email")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpayment.cnpay_payeremail))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("CNpay RRR Amount")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpayment.cnpay_rrr_amount))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("CNpay RRR Charges")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpayment.cnpay_rrr_charges))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("CNpay Charges")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpayment.cnpay_cnpay_charges))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Total Paid")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpayment.cnpay_total_paid_amt))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Remita Notify Response Code")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpayment.cnpay_rrr_notify_responseCode))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Remita Notify Response Id")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpayment.cnpay_rrr_notify_responseId))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Remita Notify Response Message")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpayment.cnpay_rrr_notify_responseMessage))])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _vm._e()]) : _c('section', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "market-updates"
  }, [_c('div', {
    staticClass: "col-md-3 market-update-gd"
  }, [_c('div', {
    staticClass: "market-update-block clr-block-2"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 market-update-left"
  }, [_c('h4', [_vm._v(" CNpay (Remita) ")]), _vm._v(" "), (_vm.cnpayments) ? _c('h3', [_vm._v(_vm._s(_vm.cnpayments.length))]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("@ count Today")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "table-agile-info"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("\r\n         CNpay (Remita) Transactions \r\n        ")]), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "table",
    attrs: {
      "ui-jq": "footable",
      "ui-options": "{\r\n            \"paging\": {\r\n              \"enabled\": true\r\n            },\r\n            \"filtering\": {\r\n              \"enabled\": true\r\n            },\r\n            \"sorting\": {\r\n              \"enabled\": true\r\n            }}"
    }
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.cnpayments), function(cnpayment, index) {
    return _c('tr', {
      attrs: {
        "data-expanded": "true"
      }
    }, [_c('td', [_vm._v(_vm._s(++index))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(cnpayment.cnpay_reg_date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(cnpayment.cnpay_txn_ref))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(cnpayment.cnpay_rrr))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(cnpayment.cnpay_rrr_amount))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(cnpayment.cnpay_total_paid_amt))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(cnpayment.cnpay_payername))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-success",
      on: {
        "click": function($event) {
          _vm.setPanel('view', cnpayment)
        }
      }
    }, [_vm._v("View")])])])
  }))])])])])]), _vm._v(" "), _c('component-footer')], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "panel-heading"
  }, [_vm._v("\r\n                                    Payment Details\r\n                                    "), _c('a', {
    staticClass: "btn btn-success pull-right",
    attrs: {
      "href": "cnpaymentsremita"
    }
  }, [_vm._v("Back")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4 market-update-right"
  }, [_c('i', {
    staticClass: "fa fa-money-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "data-breakpoints": "xs"
    }
  }, [_vm._v("S/N")]), _vm._v(" "), _c('th', [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v("REF.")]), _vm._v(" "), _c('th', [_vm._v("RRR")]), _vm._v(" "), _c('th', [_vm._v("RRR Amount")]), _vm._v(" "), _c('th', [_vm._v("Total RRR Amount")]), _vm._v(" "), _c('th', [_vm._v("Payer")]), _vm._v(" "), _c('th', [_vm._v("~")])])])
}]}

/***/ }),
/* 160 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "container"
    }
  }, [_c('component-header'), _vm._v(" "), _c('section', {
    attrs: {
      "id": "main-content"
    }
  }, [_c('section', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "agileits-w3layouts-stats"
  }, [_c('div', {
    staticClass: "col-md-4 stats-info widget"
  }, [_c('div', {
    staticClass: "stats-info-agileits"
  }, [_vm._m(0), _vm._v(" "), (_vm.resetPasswordPanel) ? _c('div', {
    staticClass: "stats-body"
  }, [_c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.mod_message))]), _vm._v(" "), _c('label', [_vm._v("Enter Current password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.admin.current_password),
      expression: "admin.current_password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.admin.current_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.admin.current_password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Enter New password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.admin.new_password),
      expression: "admin.new_password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.admin.new_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.admin.new_password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.loading) ? _c('span', [_vm._v("..processing...")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.resetPassword
    }
  }, [_vm._v("Reset")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-action')
      }
    }
  }, [_vm._v("Cancel")])]) : _c('div', {
    staticClass: "stats-body"
  }, [_c('center', [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-password', '')
      }
    }
  }, [_vm._v("Click to Reset")])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 stats-info widget"
  }, [_c('div', {
    staticClass: "stats-info-agileits"
  }, [_vm._m(1), _vm._v(" "), (_vm.resetEmailPanel) ? _c('div', {
    staticClass: "stats-body"
  }, [_c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.mod_message))]), _vm._v(" "), _c('label', [_vm._v("Enter Current Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.admin.current_email),
      expression: "admin.current_email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email"
    },
    domProps: {
      "value": (_vm.admin.current_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.admin.current_email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Enter New Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.admin.new_email),
      expression: "admin.new_email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email"
    },
    domProps: {
      "value": (_vm.admin.new_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.admin.new_email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.loading) ? _c('span', [_vm._v("..processing...")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.resetEmail
    }
  }, [_vm._v("Reset")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-action', '')
      }
    }
  }, [_vm._v("Cancel")])]) : _c('div', {
    staticClass: "stats-body"
  }, [_c('center', [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-email', '')
      }
    }
  }, [_vm._v("Click to Reset")])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 stats-info widget"
  }, [_c('div', {
    staticClass: "stats-info-agileits"
  }, [_vm._m(2), _vm._v(" "), _c('center', [_c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "href": "cnpro_categories"
    }
  }, [_vm._v("Manage CNpro Categories")])]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('center', [_c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "href": "business_categories"
    }
  }, [_vm._v("Manage Business Categories")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 stats-info widget"
  }, [_c('div', {
    staticClass: "stats-info-agileits"
  }, [_vm._m(3), _vm._v(" "), (_vm.editPlans) ? _c('div', {
    staticClass: "stats-body"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plan.plan_name),
      expression: "plan.plan_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.plan.plan_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.plan.plan_name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plan.plan_amount),
      expression: "plan.plan_amount"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.plan.plan_amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.plan.plan_amount = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.editPlansAndPricing
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-action', '')
      }
    }
  }, [_vm._v("Cancel")])]) : _c('div', {
    staticClass: "stats-body"
  }, _vm._l((_vm.plans), function(plan) {
    return _c('div', [_c('p', [_vm._v(_vm._s(plan.plan_name) + " - ₦" + _vm._s(plan.plan_amount) + "\r\n                                "), _c('button', {
      staticClass: "btn btn-xs btn-danger",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('edit-plan', plan)
        }
      }
    }, [_vm._v("Edit")])])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 stats-info widget"
  }, [_c('div', {
    staticClass: "stats-info-agileits"
  }, [_vm._m(4), _vm._v(" "), (_vm.editServiceCharge) ? _c('div', [_c('label', [_vm._v("Edit Service Charge")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.service_charge.service_charge),
      expression: "service_charge.service_charge"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.service_charge.service_charge)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.service_charge.service_charge = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.editServiceCharges
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-action', '')
      }
    }
  }, [_vm._v("Cancel")])]) : _c('div', {
    staticClass: "stats-body"
  }, _vm._l((_vm.service_charges), function(service_charge) {
    return _c('div', [_c('p', [_vm._v("Service Charge = " + _vm._s(service_charge.service_charge) + "%\r\n                                "), _c('button', {
      staticClass: "btn btn-xs btn-danger",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('edit-service-charge', service_charge)
        }
      }
    }, [_vm._v("Edit")])])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 stats-info widget"
  }, [_c('div', {
    staticClass: "stats-info-agileits"
  }, [_vm._m(5), _vm._v(" "), (_vm.editCnpayCharge) ? _c('div', {
    staticClass: "stats-body"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(6), _vm._v(" "), _c('tr', [_c('td', [_c('label', [_vm._v(_vm._s(_vm.cnpay_charge.cnpay_chg_range1_min))])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "50%"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cnpay_charge.cnpay_chg_range1_max),
      expression: "cnpay_charge.cnpay_chg_range1_max"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.cnpay_charge.cnpay_chg_range1_max)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cnpay_charge.cnpay_chg_range1_max = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "40%"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cnpay_charge.cnpay_chg_range1_pay),
      expression: "cnpay_charge.cnpay_chg_range1_pay"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.cnpay_charge.cnpay_chg_range1_pay)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cnpay_charge.cnpay_chg_range1_pay = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('label', [_vm._v(_vm._s(_vm.var1))])]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cnpay_charge.cnpay_chg_range2_max),
      expression: "cnpay_charge.cnpay_chg_range2_max"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.cnpay_charge.cnpay_chg_range2_max)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cnpay_charge.cnpay_chg_range2_max = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cnpay_charge.cnpay_chg_range2_pay),
      expression: "cnpay_charge.cnpay_chg_range2_pay"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.cnpay_charge.cnpay_chg_range2_pay)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cnpay_charge.cnpay_chg_range2_pay = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('label', [_vm._v(_vm._s(_vm.var2))])]), _vm._v(" "), _c('td', [_c('label', [_vm._v(_vm._s(_vm.cnpay_charge.cnpay_chg_range3_max))])]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cnpay_charge.cnpay_chg_range3_pay),
      expression: "cnpay_charge.cnpay_chg_range3_pay"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.cnpay_charge.cnpay_chg_range3_pay)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cnpay_charge.cnpay_chg_range3_pay = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.editCnpayCharges
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-action', '')
      }
    }
  }, [_vm._v("Cancel")])]) : _c('div', {
    staticClass: "stats-body"
  }, _vm._l((_vm.cnpay_charges), function(cnpay_charge) {
    return _c('div', [(cnpay_charge.cnpay_chg_id == 1) ? _c('h4', {
      staticStyle: {
        "margin-bottom": "5px"
      }
    }, [_vm._v("CNpay - Remita Charges")]) : _vm._e(), _vm._v(" "), (cnpay_charge.cnpay_chg_id == 2) ? _c('h4', {
      staticStyle: {
        "margin-bottom": "5px"
      }
    }, [_vm._v("Wallet Processing Fees")]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("1. ₦" + _vm._s(cnpay_charge.cnpay_chg_range1_min) + " - ₦" + _vm._s(cnpay_charge.cnpay_chg_range1_max) + " - ₦" + _vm._s(cnpay_charge.cnpay_chg_range1_pay))]), _vm._v(" "), _c('p', [_vm._v("2. ₦" + _vm._s(cnpay_charge.cnpay_chg_range2_min) + " - ₦" + _vm._s(cnpay_charge.cnpay_chg_range2_max) + " - ₦" + _vm._s(cnpay_charge.cnpay_chg_range2_pay))]), _vm._v(" "), _c('p', [_vm._v("3. ₦" + _vm._s(cnpay_charge.cnpay_chg_range3_min) + " - "), (cnpay_charge.cnpay_chg_id == 2) ? _c('span', [_vm._v("₦" + _vm._s(_vm.max_wallet_topup_amount))]) : _c('span', [_vm._v("₦" + _vm._s(cnpay_charge.cnpay_chg_range3_max))]), _vm._v(" - ₦" + _vm._s(cnpay_charge.cnpay_chg_range3_pay))]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-xs btn-danger",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('edit-cnpay-charge', cnpay_charge)
        }
      }
    }, [_vm._v("Edit")]), _vm._v(" "), _c('br'), _c('br')])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 stats-info widget"
  }, [_c('div', {
    staticClass: "stats-info-agileits"
  }, [_vm._m(7), _vm._v(" "), (_vm.editCnpayComm) ? _c('div', {
    staticClass: "stats-body"
  }, [_c('label', [_vm._v("Edit " + _vm._s(_vm.cnpay_commission.cnpay_partner) + " - " + _vm._s(_vm.cnpay_commission.cnpay_comm) + "%")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cnpay_commission.cnpay_comm),
      expression: "cnpay_commission.cnpay_comm"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.cnpay_commission.cnpay_comm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cnpay_commission.cnpay_comm = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.editCnpayCommissions
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-action', '')
      }
    }
  }, [_vm._v("Cancel")])]) : _c('div', {
    staticClass: "stats-body"
  }, _vm._l((_vm.cnpay_commissions), function(cnpay_commission) {
    return _c('div', [_c('p', [_vm._v(_vm._s(cnpay_commission.cnpay_partner) + " - " + _vm._s(cnpay_commission.cnpay_comm) + "%\r\n                                    "), _c('button', {
      staticClass: "btn btn-xs btn-danger",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('edit-cnpay-comm', cnpay_commission)
        }
      }
    }, [_vm._v("Edit")])])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 stats-info widget"
  }, [_c('div', {
    staticClass: "stats-info-agileits"
  }, [_vm._m(8), _vm._v(" "), (_vm.editDefaultCharge) ? _c('div', [_c('label', [_vm._v("Edit Charge")]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.default_charge.charge_name) + "\r\n                                "), _c('p', {
    staticStyle: {
      "font-size": "11px",
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.default_charge.charge_notes))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.default_charge.charge_amount),
      expression: "default_charge.charge_amount"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.default_charge.charge_amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.default_charge.charge_amount = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.default_charge.charge_has_ranges == 1) ? _c('div', {
    staticStyle: {
      "padding": "1em",
      "border": "#f3d3d3 1px dashed"
    }
  }, [_c('p', [_vm._v("\r\n                                    Range 1: "), _c('b', [_vm._v(_vm._s(_vm.default_charge.charge_min_range1))]), _vm._v(" - "), _c('b', [_vm._v(_vm._s(_vm.default_charge.charge_max_range1))]), _c('br'), _vm._v("\r\n                                    From:"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.default_charge.charge_min_range1),
      expression: "default_charge.charge_min_range1"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.default_charge.charge_min_range1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.default_charge.charge_min_range1 = $event.target.value
      }
    }
  }), _c('br'), _vm._v("\r\n                                    To:"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.default_charge.charge_max_range1),
      expression: "default_charge.charge_max_range1"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.default_charge.charge_max_range1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.default_charge.charge_max_range1 = $event.target.value
      }
    }
  }), _c('br'), _vm._v("\r\n                                    Amount:"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.default_charge.charge_amt_range1),
      expression: "default_charge.charge_amt_range1"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.default_charge.charge_amt_range1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.default_charge.charge_amt_range1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_vm._v("\r\n                                    Range 2: "), _c('b', [_vm._v(_vm._s(_vm.default_charge.charge_min_range2))]), _vm._v(" - "), _c('b', [_vm._v(_vm._s(_vm.default_charge.charge_max_range2))]), _c('br'), _vm._v("\r\n                                    From:"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.default_charge.charge_min_range2),
      expression: "default_charge.charge_min_range2"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.default_charge.charge_min_range2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.default_charge.charge_min_range2 = $event.target.value
      }
    }
  }), _c('br'), _vm._v("\r\n                                    To:"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.default_charge.charge_max_range2),
      expression: "default_charge.charge_max_range2"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.default_charge.charge_max_range2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.default_charge.charge_max_range2 = $event.target.value
      }
    }
  }), _c('br'), _vm._v("\r\n                                    Amount:"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.default_charge.charge_amt_range2),
      expression: "default_charge.charge_amt_range2"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.default_charge.charge_amt_range2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.default_charge.charge_amt_range2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_vm._v("\r\n                                    Range: "), _c('b', [_vm._v(_vm._s(_vm.default_charge.charge_min_range3))]), _vm._v(" - "), _c('b', [_vm._v("above")]), _c('br'), _vm._v("\r\n                                    From:"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.default_charge.charge_min_range3),
      expression: "default_charge.charge_min_range3"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.default_charge.charge_min_range3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.default_charge.charge_min_range3 = $event.target.value
      }
    }
  }), _c('br'), _vm._v("\r\n                                    To:"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.default_charge.charge_max_range3),
      expression: "default_charge.charge_max_range3"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.default_charge.charge_max_range3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.default_charge.charge_max_range3 = $event.target.value
      }
    }
  }), _c('br'), _vm._v("\r\n                                    Amount:"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.default_charge.charge_amt_range3),
      expression: "default_charge.charge_amt_range3"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.default_charge.charge_amt_range3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.default_charge.charge_amt_range3 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('hr')]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.editDefaultCharges
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-action', '')
      }
    }
  }, [_vm._v("Cancel")])]) : _c('div', {
    staticClass: "stats-body"
  }, _vm._l((_vm.default_charges), function(default_charge) {
    return _c('div', [_c('p', [_vm._v(_vm._s(default_charge.charge_name) + " = " + _vm._s(default_charge.charge_amount) + "(" + _vm._s(default_charge.charge_unit) + ")\r\n                                "), (default_charge.charge_id != 1) ? _c('button', {
      staticClass: "btn btn-xs btn-danger",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('edit-default-charge', default_charge)
        }
      }
    }, [_vm._v("Edit")]) : _vm._e()]), _vm._v(" "), (default_charge.charge_has_ranges == 1) ? _c('div', {
      staticStyle: {
        "padding": "1em",
        "border": "#f3d3d3 1px dashed"
      }
    }, [_c('h6', {
      staticStyle: {
        "font-size": "13px"
      }
    }, [_vm._v(_vm._s(default_charge.charge_name) + " Charge Range")]), _vm._v(" "), _c('p', [_c('b', [_vm._v(_vm._s(default_charge.charge_min_range1))]), _vm._v(" - "), _c('b', [_vm._v(_vm._s(default_charge.charge_max_range1))]), _vm._v(" - " + _vm._s(default_charge.charge_amt_range1) + "(" + _vm._s(default_charge.charge_unit) + ")")]), _vm._v(" "), (default_charge.charge_min_range2 > 0) ? _c('p', [_c('b', [_vm._v(_vm._s(default_charge.charge_min_range2))]), _vm._v(" - "), _c('b', [_vm._v(_vm._s(default_charge.charge_max_range2))]), _vm._v(" - " + _vm._s(default_charge.charge_amt_range2) + "(" + _vm._s(default_charge.charge_unit) + ")")]) : _vm._e(), _vm._v(" "), (default_charge.charge_min_range3 > 0) ? _c('p', [_c('b', [_vm._v(_vm._s(default_charge.charge_min_range3))]), _vm._v(" - "), _c('b', [_vm._v("above")]), _vm._v(" - " + _vm._s(default_charge.charge_amt_range3) + "(" + _vm._s(default_charge.charge_unit) + ")")]) : _vm._e()]) : _vm._e()])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 stats-info widget"
  }, [_c('div', {
    staticClass: "stats-info-agileits"
  }, [_vm._m(9), _vm._v(" "), (_vm.editServiceReward) ? _c('div', {
    staticClass: "stats-body"
  }, [(_vm.service_reward_error != '') ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.service_reward_error))]) : _vm._e(), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Service: " + _vm._s(_vm.service_reward.service_reward_service))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('b', [_vm._v("Reward Type:")]), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.service_reward_type),
      expression: "service_reward_type"
    }],
    staticClass: "form_control",
    attrs: {
      "type": "radio",
      "id": "P",
      "value": "P"
    },
    domProps: {
      "checked": _vm._q(_vm.service_reward_type, "P")
    },
    on: {
      "__c": function($event) {
        _vm.service_reward_type = "P"
      }
    }
  }), _vm._v("Percentage | \r\n                                        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.service_reward_type),
      expression: "service_reward_type"
    }],
    staticClass: "form_control",
    attrs: {
      "type": "radio",
      "id": "C",
      "value": "C"
    },
    domProps: {
      "checked": _vm._q(_vm.service_reward_type, "C")
    },
    on: {
      "__c": function($event) {
        _vm.service_reward_type = "C"
      }
    }
  }), _vm._v("Cash\r\n                                    ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('b', [_vm._v("Reward:")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.service_reward.service_reward_reward),
      expression: "service_reward.service_reward_reward"
    }],
    staticClass: "form_control",
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.service_reward.service_reward_reward)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.service_reward.service_reward_reward = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('b', [_vm._v("Reward Type:")]), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.service_reward_activation_status),
      expression: "service_reward_activation_status"
    }],
    staticClass: "form_control",
    attrs: {
      "type": "radio",
      "id": "1",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.service_reward_activation_status, "1")
    },
    on: {
      "__c": function($event) {
        _vm.service_reward_activation_status = "1"
      }
    }
  }), _vm._v("Active | \r\n                                        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.service_reward_activation_status),
      expression: "service_reward_activation_status"
    }],
    staticClass: "form_control",
    attrs: {
      "type": "radio",
      "id": "0",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.service_reward_activation_status, "0")
    },
    on: {
      "__c": function($event) {
        _vm.service_reward_activation_status = "0"
      }
    }
  }), _vm._v("Not-Active\r\n                                    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.editServiceRewards
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-action', '')
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('br'), _c('br')])]) : _c('div', {
    staticClass: "stats-body"
  }, [(_vm.addServiceReward) ? _c('div', {
    staticClass: "stats-body"
  }, [_c('h4', [_vm._v("Add Reward to a Service")]), _c('br'), _vm._v(" "), (_vm.service_reward_error != '') ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.service_reward_error))]) : _vm._e(), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Service:\r\n                                                "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.service_reward.service),
      expression: "service_reward.service"
    }],
    staticClass: "form_control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.service_reward.service = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.cnservices), function(s) {
    return _c('option', {
      domProps: {
        "value": s.service_id
      }
    }, [_vm._v(_vm._s(s.service_name))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('b', [_vm._v("Reward Type:")]), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.service_reward_type),
      expression: "service_reward_type"
    }],
    staticClass: "form_control",
    attrs: {
      "type": "radio",
      "id": "P",
      "value": "P"
    },
    domProps: {
      "checked": _vm._q(_vm.service_reward_type, "P")
    },
    on: {
      "__c": function($event) {
        _vm.service_reward_type = "P"
      }
    }
  }), _vm._v("Percentage | \r\n                                            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.service_reward_type),
      expression: "service_reward_type"
    }],
    staticClass: "form_control",
    attrs: {
      "type": "radio",
      "id": "C",
      "value": "C"
    },
    domProps: {
      "checked": _vm._q(_vm.service_reward_type, "C")
    },
    on: {
      "__c": function($event) {
        _vm.service_reward_type = "C"
      }
    }
  }), _vm._v("Cash\r\n                                        ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('b', [_vm._v("Reward:")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.service_reward.reward),
      expression: "service_reward.reward"
    }],
    staticClass: "form_control",
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.service_reward.reward)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.service_reward.reward = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.addServiceRewards
    }
  }, [_vm._v("Add")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-action', '')
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('br'), _c('br')])]) : _c('div', {
    staticClass: "stats-body",
    staticStyle: {
      "margin-bottom": "2em",
      "border-bottom": "#aaacad solid 1px",
      "font-size": "13px"
    }
  }, [_vm._m(10), _vm._v(" "), _c('table', _vm._l((_vm.services_rewards), function(sr) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "width": "60%",
        "padding": "3px"
      }
    }, [_vm._v(_vm._s(sr.service_reward_service))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "20%",
        "padding": "3px"
      }
    }, [(sr.service_reward_type == 'C') ? _c('span', [_vm._v("₦")]) : _vm._e(), _vm._v(_vm._s(sr.service_reward_reward)), (sr.service_reward_type == 'P') ? _c('span', [_vm._v("%")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "20%",
        "padding": "3px",
        "font-size": "12px"
      }
    }, [(sr.service_reward_activation_status == 1) ? _c('span', [_vm._v("Active")]) : _c('span', [_vm._v("Not-Active")])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "5%",
        "padding": "3px"
      }
    }, [_c('button', {
      staticClass: "btn btn-primary btn-xs",
      attrs: {
        "type": "button",
        "title": "Edit"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('edit-service-reward', sr)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    })])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%",
        "padding": "3px"
      }
    }, [_c('button', {
      staticClass: "btn btn-danger btn-xs",
      attrs: {
        "type": "button",
        "title": "Delete?"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('delete-service-reward', sr)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])])
  })), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs btn-success pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('add-service-reward', '')
      }
    }
  }, [_vm._v("Add New Reward")]), _vm._v(" "), _c('br'), _c('br')])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 stats-info widget",
    staticStyle: {
      "height": "auto",
      "background": "#eef9f0"
    }
  }, [_c('div', {
    staticClass: "stats-info-agileits"
  }, [_vm._m(11), _vm._v(" "), (_vm.component_view.editPagaServiceGroup || _vm.editPagaServiceGroup) ? _c('div', {
    staticClass: "stats-body"
  }, [(_vm.paga_service_error != '') ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.paga_service_error))]) : _vm._e(), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Group: " + _vm._s(_vm.paga_service_group.paga_service_group_name))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('b', [_vm._v("Group Name:")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paga_service_group.paga_service_group_name),
      expression: "paga_service_group.paga_service_group_name"
    }],
    staticClass: "form_control",
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.paga_service_group.paga_service_group_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.paga_service_group.paga_service_group_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('b', [_vm._v("Title:")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paga_service_group.paga_service_group_title),
      expression: "paga_service_group.paga_service_group_title"
    }],
    staticClass: "form_control",
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "type": "text",
      "placeholder": "Pay your Electricty Bills...."
    },
    domProps: {
      "value": (_vm.paga_service_group.paga_service_group_title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.paga_service_group.paga_service_group_title = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.editPagaServiceGroups
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-action', '');
        _vm.setComponentView('');
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('br'), _c('br')])]) : (_vm.component_view.editPagaServiceGroupMerchant || _vm.editPagaServiceGroupMerchant) ? _c('div', {
    staticClass: "stats-body"
  }, [(_vm.paga_service_error != '') ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.paga_service_error))]) : _vm._e(), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Edit Merchant:\r\n                                            "), (_vm.paga_service_group_merchant.paga_service_group_merchant_service_group_type == 'MOBILEOPS') ? _c('span', [_vm._v("\r\n                                                    " + _vm._s(_vm.paga_service_group_merchant.paga_service_group_mobile_operatorName))]) : _vm._e(), _vm._v(" "), (_vm.paga_service_group_merchant.paga_service_group_merchant_service_group_type == 'MERCHANT') ? _c('span', [_vm._v("\r\n                                                    " + _vm._s(_vm.paga_service_group_merchant.paga_service_group_merchant_displayName))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('b', [_vm._v("Commision Type:")]), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.commission_type),
      expression: "commission_type"
    }],
    staticClass: "form_control",
    attrs: {
      "type": "radio",
      "id": "P",
      "value": "P"
    },
    domProps: {
      "checked": _vm._q(_vm.commission_type, "P")
    },
    on: {
      "__c": function($event) {
        _vm.commission_type = "P"
      }
    }
  }), _vm._v("Percentage | \r\n                                        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.commission_type),
      expression: "commission_type"
    }],
    staticClass: "form_control",
    attrs: {
      "type": "radio",
      "id": "C",
      "value": "C"
    },
    domProps: {
      "checked": _vm._q(_vm.commission_type, "C")
    },
    on: {
      "__c": function($event) {
        _vm.commission_type = "C"
      }
    }
  }), _vm._v("Cash\r\n                                    ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('b', [_vm._v("Commision:")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paga_service_group_merchant.paga_service_group_merchant_commission),
      expression: "paga_service_group_merchant.paga_service_group_merchant_commission"
    }],
    staticClass: "form_control",
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.paga_service_group_merchant.paga_service_group_merchant_commission)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.paga_service_group_merchant.paga_service_group_merchant_commission = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('b', [_vm._v("Reward Type:")]), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paga_service_reward_type),
      expression: "paga_service_reward_type"
    }],
    staticClass: "form_control",
    attrs: {
      "type": "radio",
      "id": "P",
      "value": "P"
    },
    domProps: {
      "checked": _vm._q(_vm.paga_service_reward_type, "P")
    },
    on: {
      "__c": function($event) {
        _vm.paga_service_reward_type = "P"
      }
    }
  }), _vm._v("Percentage | \r\n                                        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paga_service_reward_type),
      expression: "paga_service_reward_type"
    }],
    staticClass: "form_control",
    attrs: {
      "type": "radio",
      "id": "C",
      "value": "C"
    },
    domProps: {
      "checked": _vm._q(_vm.paga_service_reward_type, "C")
    },
    on: {
      "__c": function($event) {
        _vm.paga_service_reward_type = "C"
      }
    }
  }), _vm._v("Cash\r\n                                    ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('b', [_vm._v("Reward:")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paga_service_group_merchant.paga_service_group_merchant_reward),
      expression: "paga_service_group_merchant.paga_service_group_merchant_reward"
    }],
    staticClass: "form_control",
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.paga_service_group_merchant.paga_service_group_merchant_reward)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.paga_service_group_merchant.paga_service_group_merchant_reward = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('b', [_vm._v("Reward Type:")]), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paga_service_reward_activation_status),
      expression: "paga_service_reward_activation_status"
    }],
    staticClass: "form_control",
    attrs: {
      "type": "radio",
      "id": "1",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.paga_service_reward_activation_status, "1")
    },
    on: {
      "__c": function($event) {
        _vm.paga_service_reward_activation_status = "1"
      }
    }
  }), _vm._v("Active | \r\n                                        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paga_service_reward_activation_status),
      expression: "paga_service_reward_activation_status"
    }],
    staticClass: "form_control",
    attrs: {
      "type": "radio",
      "id": "0",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.paga_service_reward_activation_status, "0")
    },
    on: {
      "__c": function($event) {
        _vm.paga_service_reward_activation_status = "0"
      }
    }
  }), _vm._v("Not-Active\r\n                                    ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('b', [_vm._v("Maximum Purchase Amount:")]), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paga_service_group_merchant.paga_service_group_merchant_max_purchase_amount),
      expression: "paga_service_group_merchant.paga_service_group_merchant_max_purchase_amount"
    }],
    staticClass: "form_control",
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "type": "number",
      "id": "0",
      "value": "0"
    },
    domProps: {
      "value": (_vm.paga_service_group_merchant.paga_service_group_merchant_max_purchase_amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.paga_service_group_merchant.paga_service_group_merchant_max_purchase_amount = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('b', [_vm._v("Merchant - Do not display services")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000",
      "font-size": "13px"
    }
  }, [_vm._v("Please copy and paste the exact service you would not want to be displayed")]), _vm._v(" "), ((Object.keys(_vm.paga_service_group_merchant.paga_service_group_merchant_services_do_not_display).length > 0)) ? _c('div', _vm._l((_vm.paga_service_group_merchant.paga_service_group_merchant_services_do_not_display), function(dnd_service, dndex) {
    return _c('li', {
      staticStyle: {
        "display": "inline-block",
        "list-style": "none"
      }
    }, [_c('button', {
      staticClass: "btn btn-sm btn-default",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.deletePagaMerchantDoNotDisplayServices(dnd_service)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "border-radius": "50%",
        "background-color": "#cc0000",
        "padding": "0px 5px",
        "color": "#ffffff"
      }
    }, [_vm._v("x")]), _vm._v("\r\n                                                    " + _vm._s(dnd_service.service_name) + "\r\n                                                ")])])
  })) : _c('p', {
    staticStyle: {
      "color": "#05630a"
    }
  }, [_vm._v("No service listed")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paga_merchant_dnds.service_name),
      expression: "paga_merchant_dnds.service_name"
    }],
    staticClass: "form_control",
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "type": "text",
      "id": "0",
      "value": "0"
    },
    domProps: {
      "value": (_vm.paga_merchant_dnds.service_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.paga_merchant_dnds.service_name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.addPagaMerchantDoNotDisplayServices(_vm.paga_service_group_merchant.paga_service_group_merchant_id)
      }
    }
  }, [_vm._v("Add")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('b', [_vm._v("Merchant Image")]), _vm._v(" "), (_vm.paga_service_group_merchant.paga_service_group_merchant_attached_image != '') ? _c('span', [_c('img', {
    staticClass: "img-responsive",
    staticStyle: {
      "height": "8.5em"
    },
    attrs: {
      "src": _vm.img_url + _vm.paga_service_group_merchant.paga_service_group_merchant_attached_image
    }
  })]) : _vm._e(), _vm._v(" "), _c('label', [_vm._v("Change Image\r\n                                            "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChange($event, _vm.paga_service_group_merchant.paga_service_group_merchant_id)
      }
    }
  })])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.editPagaServiceGroupMerchants
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-action', '');
        _vm.setComponentView('');
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('br'), _c('br')])]) : (_vm.component_view.addPagaServiceGroup || _vm.addPagaServiceGroup) ? _c('div', {
    staticClass: "stats-body"
  }, [_c('h4', [_vm._v("Add New PAGA Service Group")]), _c('br'), _vm._v(" "), (_vm.service_reward_error != '') ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.paga_service_error))]) : _vm._e(), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "form-group"
  }, [_c('b', [_vm._v("Group Name:")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paga_service_group.group_name),
      expression: "paga_service_group.group_name"
    }],
    staticClass: "form_control",
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.paga_service_group.group_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.paga_service_group.group_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('b', [_vm._v("Title:")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paga_service_group.group_title),
      expression: "paga_service_group.group_title"
    }],
    staticClass: "form_control",
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "type": "text",
      "placeholder": "Pay your Electricty Bills...."
    },
    domProps: {
      "value": (_vm.paga_service_group.group_title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.paga_service_group.group_title = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.addPagaServiceGroups
    }
  }, [_vm._v("Add")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-action', '');
        _vm.setComponentView('');
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('br'), _c('br')])]) : _c('div', {
    staticClass: "stats-body",
    staticStyle: {
      "margin-bottom": "2em",
      "border-bottom": "#aaacad solid 1px",
      "font-size": "13px"
    }
  }, [_vm._l((_vm.paga_service_groups), function(service_group) {
    return _c('div', {
      staticClass: "col-md-12",
      staticStyle: {
        "margin-bottom": "1em",
        "border-bottom": "#aaacad solid 1px",
        "font-size": "13px"
      }
    }, [_c('div', {
      staticClass: "col-md-3"
    }, [_c('h6', [_c('u', [_vm._v(_vm._s(service_group.paga_service_group_name))])]), _vm._v(" "), _c('P', [_vm._v(_vm._s(service_group.paga_service_group_title))]), _vm._v(" "), _c('div', [_c('button', {
      staticClass: "btn btn-primary btn-xs",
      attrs: {
        "type": "button",
        "title": "Edit"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('edit-paga-service-group', service_group);
          _vm.setComponentView('editPagaServiceGroup')
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    })]), _vm._v(" "), (_vm.deletePagaServiceGroup && (service_group.paga_service_group_id == _vm.paga_service_group.paga_service_group_id)) ? _c('div', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v("Do you really want to delete?\r\n                                            "), _c('button', {
      staticClass: "btn btn-danger btn-xs",
      attrs: {
        "type": "button",
        "title": "Delete?"
      },
      on: {
        "click": function($event) {
          _vm.deletePagaServiceGroups()
        }
      }
    }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-default btn-xs",
      attrs: {
        "type": "button",
        "title": "Delete?"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('reset-action', '')
        }
      }
    }, [_vm._v("No")])]) : _c('button', {
      staticClass: "btn btn-danger btn-xs",
      attrs: {
        "type": "button",
        "title": "Delete?"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('delete-paga-service-group', service_group);
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-9"
    }, [(_vm.addPagaServiceGroupMerchant && (service_group.paga_service_group_id == _vm.paga_service_group.paga_service_group_id)) ? _c('div', {
      staticClass: "stats-body"
    }, [_c('h4', [_vm._v("Add New Merchant")]), _c('br'), _vm._v(" "), (_vm.paga_service_error != '') ? _c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v(_vm._s(_vm.paga_service_error))]) : _vm._e(), _vm._v(" "), _c('form', [(service_group.paga_service_group_for == 'MERCHANT') ? _c('div', {
      staticClass: "form-group"
    }, [_c('label', [_vm._v("Merchant:\r\n                                                        "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.paga_service_group_merchant.merchant),
        expression: "paga_service_group_merchant.merchant"
      }],
      staticClass: "form_control",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.paga_service_group_merchant.merchant = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }
      }
    }, [_c('option', {
      domProps: {
        "value": undefined
      }
    }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.paga_merchants), function(s, index) {
      return _c('option', {
        domProps: {
          "value": s.paga_merchant_id
        }
      }, [_vm._v(_vm._s(s.paga_merchant_displayName))])
    })], 2)])]) : _vm._e(), _vm._v(" "), (service_group.paga_service_group_for == 'MOBILEOPS') ? _c('div', {
      staticClass: "form-group"
    }, [_c('label', [_vm._v("Mobile Operator:\r\n                                                        "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.paga_service_group_merchant.merchant),
        expression: "paga_service_group_merchant.merchant"
      }],
      staticClass: "form_control",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.paga_service_group_merchant.merchant = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }
      }
    }, [_c('option', {
      domProps: {
        "value": undefined
      }
    }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.paga_mobile_operators), function(s, index) {
      return _c('option', {
        domProps: {
          "value": s.paga_mobile_operator_id
        }
      }, [_vm._v(_vm._s(s.paga_mobile_operator_name))])
    })], 2)])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('b', [_vm._v("Commision Type:")]), _c('br'), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.commission_type),
        expression: "commission_type"
      }],
      staticClass: "form_control",
      attrs: {
        "type": "radio",
        "id": "P",
        "value": "P"
      },
      domProps: {
        "checked": _vm._q(_vm.commission_type, "P")
      },
      on: {
        "__c": function($event) {
          _vm.commission_type = "P"
        }
      }
    }), _vm._v("Percentage | \r\n                                                    "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.commission_type),
        expression: "commission_type"
      }],
      staticClass: "form_control",
      attrs: {
        "type": "radio",
        "id": "C",
        "value": "C"
      },
      domProps: {
        "checked": _vm._q(_vm.commission_type, "C")
      },
      on: {
        "__c": function($event) {
          _vm.commission_type = "C"
        }
      }
    }), _vm._v("Cash\r\n                                                ")]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('b', [_vm._v("Commision:")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.paga_service_group_merchant.commission),
        expression: "paga_service_group_merchant.commission"
      }],
      staticClass: "form_control",
      staticStyle: {
        "width": "30%"
      },
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (_vm.paga_service_group_merchant.commission)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.paga_service_group_merchant.commission = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('b', [_vm._v("Reward Type:")]), _c('br'), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.paga_service_reward_type),
        expression: "paga_service_reward_type"
      }],
      staticClass: "form_control",
      attrs: {
        "type": "radio",
        "id": "P",
        "value": "P"
      },
      domProps: {
        "checked": _vm._q(_vm.paga_service_reward_type, "P")
      },
      on: {
        "__c": function($event) {
          _vm.paga_service_reward_type = "P"
        }
      }
    }), _vm._v("Percentage | \r\n                                                    "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.paga_service_reward_type),
        expression: "paga_service_reward_type"
      }],
      staticClass: "form_control",
      attrs: {
        "type": "radio",
        "id": "C",
        "value": "C"
      },
      domProps: {
        "checked": _vm._q(_vm.paga_service_reward_type, "C")
      },
      on: {
        "__c": function($event) {
          _vm.paga_service_reward_type = "C"
        }
      }
    }), _vm._v("Cash\r\n                                                ")]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('b', [_vm._v("Reward:")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.paga_service_group_merchant.reward),
        expression: "paga_service_group_merchant.reward"
      }],
      staticClass: "form_control",
      staticStyle: {
        "width": "30%"
      },
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (_vm.paga_service_group_merchant.reward)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.paga_service_group_merchant.reward = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('b', [_vm._v("Reward Type:")]), _c('br'), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.paga_service_reward_activation_status),
        expression: "paga_service_reward_activation_status"
      }],
      staticClass: "form_control",
      attrs: {
        "type": "radio",
        "id": "1",
        "value": "1"
      },
      domProps: {
        "checked": _vm._q(_vm.paga_service_reward_activation_status, "1")
      },
      on: {
        "__c": function($event) {
          _vm.paga_service_reward_activation_status = "1"
        }
      }
    }), _vm._v("Active | \r\n                                                    "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.paga_service_reward_activation_status),
        expression: "paga_service_reward_activation_status"
      }],
      staticClass: "form_control",
      attrs: {
        "type": "radio",
        "id": "0",
        "value": "0"
      },
      domProps: {
        "checked": _vm._q(_vm.paga_service_reward_activation_status, "0")
      },
      on: {
        "__c": function($event) {
          _vm.paga_service_reward_activation_status = "0"
        }
      }
    }), _vm._v("Not-Active\r\n                                                ")]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('b', [_vm._v("Maximum Purchase Amount:")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.paga_service_group_merchant.max_purchase_amount),
        expression: "paga_service_group_merchant.max_purchase_amount"
      }],
      staticClass: "form_control",
      staticStyle: {
        "width": "30%"
      },
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (_vm.paga_service_group_merchant.max_purchase_amount)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.paga_service_group_merchant.max_purchase_amount = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-info",
      attrs: {
        "disabled": _vm.disable_btn,
        "type": "button"
      },
      on: {
        "click": _vm.addPagaServiceGroupMerchants
      }
    }, [_vm._v("Add")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('reset-action', '')
        }
      }
    }, [_vm._v("Cancel")]), _vm._v(" "), _c('br'), _c('br')])]) : _vm._e(), _vm._v(" "), _c('table', [_vm._m(12, true), _vm._v(" "), _vm._l((service_group.paga_service_group_merchants), function(m) {
      return _c('tr', [(m.paga_service_group_merchant_service_group_type == 'MERCHANT') ? _c('td', {
        staticStyle: {
          "width": "60%",
          "padding": "3px"
        }
      }, [_vm._v("\r\n                                                    " + _vm._s(m.paga_service_group_merchant_displayName) + "\r\n                                                ")]) : _vm._e(), _vm._v(" "), (m.paga_service_group_merchant_service_group_type == 'MOBILEOPS') ? _c('td', {
        staticStyle: {
          "width": "60%",
          "padding": "3px"
        }
      }, [_vm._v("\r\n                                                    " + _vm._s(m.paga_service_group_mobile_operatorName) + "\r\n                                                ")]) : _vm._e(), _vm._v(" "), _c('td', {
        staticStyle: {
          "width": "20%",
          "padding": "3px"
        }
      }, [(m.paga_service_group_merchant_attached_image != '') ? _c('span', [_c('img', {
        staticClass: "img-responsive",
        staticStyle: {
          "height": "3.5em"
        },
        attrs: {
          "src": _vm.img_url + m.paga_service_group_merchant_attached_image
        }
      })]) : _c('span', [_c('input', {
        attrs: {
          "type": "file",
          "id": "input-file",
          "accept": "image/*"
        },
        on: {
          "change": function($event) {
            _vm.onFileChange($event, m.paga_service_group_merchant_id)
          }
        }
      })])]), _vm._v(" "), _c('td', {
        staticStyle: {
          "width": "20%",
          "padding": "3px"
        }
      }, [_vm._v(_vm._s(m.paga_service_group_merchant_max_purchase_amount))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "width": "20%",
          "padding": "3px"
        }
      }, [(m.paga_service_group_merchant_commission_type == 'C') ? _c('span', [_vm._v("₦")]) : _vm._e(), _vm._v(_vm._s(m.paga_service_group_merchant_commission)), (m.paga_service_group_merchant_commission_type == 'P') ? _c('span', [_vm._v("%")]) : _vm._e()]), _vm._v(" "), _c('td', {
        staticStyle: {
          "width": "20%",
          "padding": "3px"
        }
      }, [(m.paga_service_group_merchant_reward_type == 'C') ? _c('span', [_vm._v("₦")]) : _vm._e(), _vm._v(_vm._s(m.paga_service_group_merchant_reward)), (m.paga_service_group_merchant_reward_type == 'P') ? _c('span', [_vm._v("%")]) : _vm._e()]), _vm._v(" "), _c('td', {
        staticStyle: {
          "width": "20%",
          "padding": "3px",
          "font-size": "12px"
        }
      }, [(m.paga_service_group_merchant_reward_activation_status == 1) ? _c('span', [_vm._v("Active")]) : _c('span', [_vm._v("Not-Active")])]), _vm._v(" "), _c('td', {
        staticStyle: {
          "width": "10%",
          "padding": "3px"
        }
      }, [_c('button', {
        staticClass: "btn btn-primary btn-xs",
        attrs: {
          "type": "button",
          "title": "Edit"
        },
        on: {
          "click": function($event) {
            _vm.setComponent('edit-paga-service-group-merchant', m);
            _vm.setComponentView('edit-paga-service-group-merchant')
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-pencil"
      })])]), _vm._v(" "), _c('td', {
        staticStyle: {
          "width": "10%",
          "padding": "3px"
        }
      }, [(_vm.deletePagaServiceGroupMerchant && (_vm.paga_service_group_merchant.paga_service_group_merchant_id == m.paga_service_group_merchant_id)) ? _c('p', {
        staticStyle: {
          "color": "#ff0000"
        }
      }, [_vm._v("Do you really want to delete?\r\n                                                        "), _c('button', {
        staticClass: "btn btn-danger btn-xs",
        attrs: {
          "type": "button",
          "title": "Delete?"
        },
        on: {
          "click": function($event) {
            _vm.deletePagaServiceGroupMerchants()
          }
        }
      }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
        staticClass: "btn btn-default btn-xs",
        attrs: {
          "type": "button",
          "title": "Delete?"
        },
        on: {
          "click": function($event) {
            _vm.setComponent('reset-action', '')
          }
        }
      }, [_vm._v("No")])]) : _c('button', {
        staticClass: "btn btn-danger btn-xs",
        attrs: {
          "type": "button",
          "title": "Delete?"
        },
        on: {
          "click": function($event) {
            _vm.setComponent('delete-paga-service-group-merchant', m)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-trash"
      })])])])
    })], 2), _vm._v(" "), _c('button', {
      staticClass: "btn btn-xs btn-success pull-right",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('add-paga-service-group-merchant', service_group);
          _vm.setComponentView('addPagaServiceGroupMerchant');
        }
      }
    }, [_vm._v("Add New PAGA Service Group Member")]), _vm._v(" "), _c('br'), _c('br')]), _vm._v(" "), _c('br')])
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "2em"
    }
  }, [_c('br'), _c('br'), _vm._v(" "), (!_vm.has_paga_service_group_for_mobile_operator) ? _c('div', {
    staticClass: "pull-left"
  }, [_vm._m(13), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "form-group"
  }, [_c('b', [_vm._v("Group Name:")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paga_service_group.group_name),
      expression: "paga_service_group.group_name"
    }],
    staticClass: "form_control",
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.paga_service_group.group_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.paga_service_group.group_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('b', [_vm._v("Title:")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paga_service_group.group_title),
      expression: "paga_service_group.group_title"
    }],
    staticClass: "form_control",
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "type": "text",
      "placeholder": "Pay your Electricty Bills...."
    },
    domProps: {
      "value": (_vm.paga_service_group.group_title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.paga_service_group.group_title = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.addPagaServiceGroupMobileOperator
    }
  }, [_vm._v("Add")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-action', '')
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('br'), _c('br')])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-xs btn-success pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('add-paga-service-group', '')
      }
    }
  }, [_vm._v("Add New PAGA Service Group")]), _vm._v(" "), _c('br'), _c('br')])])], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 stats-info widget"
  }, [_c('div', {
    staticClass: "stats-info-agileits"
  }, [_vm._m(14), _vm._v(" "), _c('div', [_c('p', [_vm._v("Available Balance at PAGA")]), _vm._v(" "), _c('label', [_vm._v("₦" + _vm._s(_vm.paga_available_balance))])])])])]), _vm._v(" "), _c('component-footer'), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    staticStyle: {
      "margin-top": "24em"
    },
    attrs: {
      "id": "delete",
      "tabindex": "-10",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "border-radius": "3px"
    }
  }, [_c('button', {
    staticClass: "pull-right btn btn-default",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.closeModal('#topup')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._v("\r\n                    delete\r\n                ")])])])])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stats-title"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("Change Password")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stats-title"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("Change Email")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stats-title"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("Manage Categories")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stats-title"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("Users Plans and Pricing")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stats-title"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("CNpro Service Charge")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stats-title"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("Processing Fees /  Charges")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("From")]), _vm._v(" "), _c('th', [_vm._v("To")]), _vm._v(" "), _c('th', [_vm._v("Amount")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stats-title"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("CNpay Commissions")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stats-title"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("Default Charges")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stats-title"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("Rewards For Services")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h6', [_c('u', [_vm._v("Rewards")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stats-title"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("PAGA Services")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Merchant")]), _vm._v(" "), _c('th', [_vm._v("Image")]), _vm._v(" "), _c('th', [_vm._v("max")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%",
      "padding": "3px"
    }
  }, [_vm._v("commission")]), _vm._v(" "), _c('th', [_vm._v("reward")]), _vm._v(" "), _c('th', [_vm._v("--~")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Add the Service Group for Mobile Operators")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stats-title"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("PAGA Balance")])])
}]}

/***/ }),
/* 161 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "container"
    }
  }, [_c('component-header'), _vm._v(" "), _c('section', {
    attrs: {
      "id": "main-content"
    }
  }, [(_vm.panelFlag) ? _c('section', {
    staticClass: "wrapper"
  }, [(_vm.viewFlag) ? _c('div', [_c('div', {
    staticClass: "agileits-w3layouts-stats"
  }, [_c('div', {
    staticClass: "col-md-4 stats-info widget"
  }, [_c('div', {
    staticClass: "stats-info-agileits"
  }, [_c('div', {
    staticClass: "stats-title"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.contract.contract_ref))])]), _vm._v(" "), _c('div', {
    staticClass: "stats-body"
  }, [_c('ul', {
    staticClass: "list-unstyled"
  }, [_c('li', [_vm._v("Contractor's ID "), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.contract.contract_contractor_id))])]), _vm._v(" "), _c('li', [_vm._v("Contractor's Name "), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.contract.contract_contractor_name))])]), _vm._v(" "), _c('li', [_vm._v("CNpro's ID "), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.contract.contract_cnpro_id))])]), _vm._v(" "), _c('li', [_vm._v("CNpro's Name "), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.contract.contract_cnpro_name))])]), _vm._v(" "), _c('li', [_vm._v("Contract Status "), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.contract.contract_status))])]), _vm._v(" "), _c('li', [_vm._v("Labour Cost "), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.contract.contract_labour_cost))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 stats-info stats-last widget-shadow"
  }, [_c('div', {
    staticClass: "notifications"
  }, [_c('header', {
    staticClass: "panel-heading"
  }, [_vm._v("\r\n                             Contract Quote Details\r\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "notify-w3ls"
  }, [_c('table', {
    staticClass: "table",
    attrs: {
      "ui-jq": "footable",
      "ui-options": "{\r\n                                \"paging\": {\r\n                                \"enabled\": true\r\n                                },\r\n                                \"filtering\": {\r\n                                \"enabled\": true\r\n                                },\r\n                                \"sorting\": {\r\n                                \"enabled\": true\r\n                                }}"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Quote Description")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.contract.contract_quote_description))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Material Details")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.contract.contract_material_details))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Labour Cost")]), _vm._v(" "), _c('td', [_vm._v("₦" + _vm._s(_vm.contract.contract_labour_cost))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Work Duration")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.contract.contract_work_duration) + " Day(s)")])]), _vm._v(" "), _vm._m(0)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "agileits-w3layouts-stats"
  }, [_c('div', {
    staticClass: "col-md-4 stats-info widget"
  }, [_c('div', {
    staticClass: "stats-info-agileits"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "stats-body"
  }, [_c('p', [_c('b', [_vm._v("Discussion: ")]), _vm._v(" "), (_vm.contract.contract_contract_threads) ? _c('span', [_vm._v("(" + _vm._s(_vm.contract.contract_contract_threads.length) + ") Message(s)")]) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setPanel('viewDiscussion', '')
      }
    }
  }, [_vm._v("View Discussion")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "stats-body"
  }, [_c('p', [_c('b', [_vm._v("Complaints: ")]), (_vm.contract.contract_contract_complaints) ? _c('span', [_vm._v("(" + _vm._s(_vm.contract.contract_contract_complaints.length) + ") Complaint(s)")]) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setPanel('viewComplaints', '')
      }
    }
  }, [_vm._v("View Complaints")])])]), _vm._v(" "), _c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 stats-info widget"
  }, [_c('div', {
    staticClass: "stats-info-agileits"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "stats-body"
  }, [_vm._m(3), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.contract.contract_status_id != 12) ? _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.endContract
    }
  }, [_vm._v("End Contract")]) : _vm._e(), _vm._v(" "), (_vm.contract.contract_status_id == 12) ? _c('div', [_c('p', {
    staticStyle: {
      "font-size": "12px",
      "color": "#ff0000"
    }
  }, [_vm._v("Ended By \r\n                                            "), (_vm.contract.contract_closed_by != 0) ? _c('span', [_c('u', [_vm._v("Contractor")])]) : _c('span', [_c('u', [_vm._v("Admin")])])]), _vm._v(" "), _c('br')]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]) : _vm._e(), _vm._v(" "), (_vm.viewDiscussion) ? _c('div', {
    staticClass: "agileits-w3layouts-stats"
  }, [_c('div', {
    staticClass: "col-md-8 col-md-offset-2 stats-info stats-last widget-shadow"
  }, [_c('div', {
    staticClass: "notifications"
  }, [_c('header', {
    staticClass: "panel-heading"
  }, [_vm._v("Discussions\r\n                            "), _c('button', {
    staticClass: "btn btn-success pull-right",
    on: {
      "click": function($event) {
        _vm.setPanel('view', _vm.contract.contract_id)
      }
    }
  }, [_vm._v("Back to Contract")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "notify-w3ls"
  }, _vm._l((_vm.contract.contract_contract_threads), function(thread) {
    return _c('div', {
      staticClass: "alert alert-success clearfix"
    }, [_vm._m(4, true), _vm._v(" "), _c('div', {
      staticClass: "notification-info"
    }, [_c('ul', {
      staticClass: "clearfix notification-meta"
    }, [_c('li', {
      staticClass: "pull-left notification-sender"
    }, [_c('span', [_c('a', {
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(thread.contract_thread_user_name))])]), _vm._v(" " + _vm._s(thread.contract_thread_thread))])]), _vm._v(" "), _c('p', [_vm._v("\r\n                                         " + _vm._s(thread.contract_thread_thread_date) + "\r\n                                      ")])])])
  }))])])]) : _vm._e(), _vm._v(" "), (_vm.viewComplaints) ? _c('div', {
    staticClass: "agileits-w3layouts-stats"
  }, [_c('div', {
    staticClass: "col-md-8 col-md-offset-2 stats-info stats-last widget-shadow"
  }, [_c('div', {
    staticClass: "notifications"
  }, [_c('header', {
    staticClass: "panel-heading"
  }, [_vm._v("Job Complaints\r\n                        "), _c('button', {
    staticClass: "btn btn-success pull-right",
    on: {
      "click": function($event) {
        _vm.setPanel('view', _vm.contract.contract_id)
      }
    }
  }, [_vm._v("Back to Contract")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "notify-w3ls"
  }, _vm._l((_vm.contract.contract_contract_complaints), function(complaint) {
    return _c('div', {
      staticClass: "alert alert-danger clearfix"
    }, [_vm._m(5, true), _vm._v(" "), _c('div', {
      staticClass: "notification-info"
    }, [_c('ul', {
      staticClass: "clearfix notification-meta"
    }, [_c('li', {
      staticClass: "pull-left notification-sender"
    }, [_c('span', [_c('a', {
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(complaint.contract_complaint_user_name))])]), _vm._v(" " + _vm._s(complaint.contract_complaint))])]), _vm._v(" "), _c('p', [_vm._v("\r\n                                     " + _vm._s(complaint.contract_complaint_date) + " | " + _vm._s(complaint.contract_complaint_status_name) + "\r\n                                  ")])])])
  }))])])]) : _vm._e()]) : _c('section', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "market-updates"
  }, [_c('div', {
    staticClass: "col-md-3 market-update-gd"
  }, [_c('div', {
    staticClass: "market-update-block clr-block-2"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 market-update-left"
  }, [_c('h4', [_vm._v("contracts")]), _vm._v(" "), (_vm.contracts) ? _c('h3', [_vm._v(_vm._s(_vm.contracts.length))]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("@ count Today")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "table-agile-info"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("\r\n         contracts Lists\r\n        ")]), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "table",
    attrs: {
      "ui-jq": "footable",
      "ui-options": "{\r\n            \"paging\": {\r\n              \"enabled\": true\r\n            },\r\n            \"filtering\": {\r\n              \"enabled\": true\r\n            },\r\n            \"sorting\": {\r\n              \"enabled\": true\r\n            }}"
    }
  }, [_vm._m(7), _vm._v(" "), _c('tbody', _vm._l((_vm.contracts), function(contract, index) {
    return _c('tr', {
      attrs: {
        "data-expanded": "true"
      }
    }, [_c('td', [_vm._v(_vm._s(++index))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(contract.contract_ref))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(contract.contract_contractor_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(contract.contract_cnpro_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(contract.contract_status))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-success",
      on: {
        "click": function($event) {
          _vm.setPanel('view', contract.contract_id)
        }
      }
    }, [_vm._v("View")])])])
  }))])])])])]), _vm._v(" "), _c('component-footer')], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th'), _vm._v(" "), _c('td', [_vm._v("  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stats-title"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("Contract Activity")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stats-title"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("End Contract")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("If all Contract staus are met and issues resolved. Admin can decide to end an "), _c('b', [_vm._v("Open")]), _vm._v(" Contract")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "alert-icon"
  }, [_c('i', {
    staticClass: "fa fa-meh-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "alert-icon"
  }, [_c('i', {
    staticClass: "fa fa-ban"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4 market-update-right"
  }, [_c('i', {
    staticClass: "fa fa-contracts"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "data-breakpoints": "xs"
    }
  }, [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Contract ID")]), _vm._v(" "), _c('th', [_vm._v("Contractor")]), _vm._v(" "), _c('th', {
    attrs: {
      "data-breakpoints": "xs"
    }
  }, [_vm._v("CNpro")]), _vm._v(" "), _c('th', {
    attrs: {
      "data-breakpoints": "xs sm md",
      "data-title": "DOB"
    }
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("~")])])])
}]}

/***/ }),
/* 162 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "container"
    }
  }, [_c('component-header'), _vm._v(" "), _c('section', {
    attrs: {
      "id": "main-content"
    }
  }, [(_vm.panelFlag) ? _c('section', {
    staticClass: "wrapper"
  }, [(_vm.viewFlag) ? _c('div', [_c('div', {
    staticClass: "agileits-w3layouts-stats"
  }, [_c('div', {
    staticClass: "col-md-8 col-md-offset-2 stats-info stats-last widget-shadow"
  }, [_c('div', {
    staticClass: "notifications"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "notify-w3ls col-md-offset-2"
  }, [_c('table', {
    staticClass: "table",
    attrs: {
      "ui-jq": "footable",
      "ui-options": "{\r\n                                    \"paging\": {\r\n                                    \"enabled\": true\r\n                                    },\r\n                                    \"filtering\": {\r\n                                    \"enabled\": true\r\n                                    },\r\n                                    \"sorting\": {\r\n                                    \"enabled\": true\r\n                                    }}"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Date of Transaction")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.transaction.transaction_payment_date))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Transaction Ref")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.transaction.transaction_payment_ref))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Transaction @")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.transaction.transaction_module_name))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Transaction Amount")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.transaction.transaction_amount_paid))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Transaction Type")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.transaction.transaction_type_name))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Transaction Mode")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.transaction.transaction_mode_name))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Transaction Mode Transaction Ref")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.transaction.transaction_mode_transaction_ref))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Transaction Payer Name")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.transaction.transaction_payer_name))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Transaction Payer Email")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.transaction.transaction_payer_email))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Transaction Payer Phone")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.transaction.transaction_payer_phone))])]), _vm._v(" "), (_vm.transaction.transaction_payer_user_name != 'error') ? _c('tr', [_c('th', [_vm._v("Transaction User Account")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.transaction.transaction_payer_user_name))])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Transaction Payment Ref")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.transaction.transaction_payment_ref))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Transaction Payer Date")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.transaction.transaction_payment_date))])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _vm._e()]) : _c('section', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "market-updates"
  }, [_c('div', {
    staticClass: "col-md-3 market-update-gd"
  }, [_c('div', {
    staticClass: "market-update-block clr-block-2"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 market-update-left"
  }, [(_vm.transactions) ? _c('h3', [_vm._v(_vm._s(_vm.todays_count))]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("@ count Today")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "table-agile-info"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("\r\n          CNpayments and Transactions\r\n        ")]), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "table",
    attrs: {
      "ui-jq": "footable",
      "ui-options": "{\r\n            \"paging\": {\r\n              \"enabled\": true\r\n            },\r\n            \"filtering\": {\r\n              \"enabled\": true\r\n            },\r\n            \"sorting\": {\r\n              \"enabled\": true\r\n            }}"
    }
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.transactions), function(transaction, index) {
    return _c('tr', {
      attrs: {
        "data-expanded": "true"
      }
    }, [_c('td', [_vm._v(_vm._s(++index))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(transaction.transaction_payment_date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(transaction.transaction_payment_ref))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(transaction.transaction_module_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(transaction.transaction_payer_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(transaction.transaction_amount_paid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(transaction.transaction_mode_name))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-success",
      on: {
        "click": function($event) {
          _vm.setPanel('view', transaction)
        }
      }
    }, [_vm._v("View")])])])
  }))])])])])]), _vm._v(" "), _c('component-footer')], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "panel-heading"
  }, [_vm._v("\r\n                                    Transaction Details\r\n                                    "), _c('a', {
    staticClass: "btn btn-success pull-right",
    attrs: {
      "href": "cnpayments"
    }
  }, [_vm._v("Back")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4 market-update-right"
  }, [_c('i', {
    staticClass: "fa fa-money-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "data-breakpoints": "xs"
    }
  }, [_vm._v("S/N")]), _vm._v(" "), _c('th', [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v("REF.")]), _vm._v(" "), _c('th', {
    attrs: {
      "data-breakpoints": "xs"
    }
  }, [_vm._v("Transaction")]), _vm._v(" "), _c('th', {
    attrs: {
      "data-breakpoints": "xs"
    }
  }, [_vm._v("Payer")]), _vm._v(" "), _c('th', {
    attrs: {
      "data-breakpoints": "xs sm md"
    }
  }, [_vm._v("Amount")]), _vm._v(" "), _c('th', {
    attrs: {
      "data-breakpoints": "xs sm md"
    }
  }, [_vm._v("Mode")]), _vm._v(" "), _c('th', [_vm._v("~")])])])
}]}

/***/ }),
/* 163 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "wthree-copyright"
  }, [_c('p', [_vm._v("© 2017 CityNeeds. All rights reserved")])])])
}]}

/***/ }),
/* 164 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "header fixed-top clearfix"
  }, [_c('div', {
    staticClass: "brand"
  }, [_c('a', {
    staticClass: "logo",
    attrs: {
      "href": "dashboard"
    }
  }, [_vm._v("\r\n            CityNeeds\r\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "sidebar-toggle-box hidden-sm hidden-xs",
    staticStyle: {
      "margin-left": "10em"
    }
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.toggle_sidebar
    }
  }, [_c('div', {
    staticClass: "fa fa-bars"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "sidebar-toggle-box hidden-lg hidden-md",
    staticStyle: {
      "margin-left": "10em"
    }
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.toggle_sidebar_mobile
    }
  }, [_c('div', {
    staticClass: "fa fa-bars"
  })])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('aside', {
    attrs: {
      "id": "sideToggle"
    }
  }, [_c('div', {
    staticClass: "nav-collapse",
    staticStyle: {
      "margin-top": "0em",
      "overflow": "auto"
    },
    attrs: {
      "id": "sidebar"
    }
  }, [_c('div', {
    staticClass: "leftside-navigation",
    staticStyle: {
      "margin-bottom": "20em"
    }
  }, [_c('ul', {
    staticClass: "sidebar-menu",
    attrs: {
      "id": "nav-accordion"
    }
  }, [_c('li', [_c('a', {
    class: {
      active: _vm.isActive('/dashboard')
    },
    attrs: {
      "href": "dashboard"
    }
  }, [_c('i', {
    staticClass: "fa fa-dashboard"
  }), _vm._v(" "), _c('span', [_vm._v("Dashboard")])])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      active: _vm.isActive('/users')
    },
    attrs: {
      "href": "users"
    }
  }, [_c('i', {
    staticClass: "fa fa-users"
  }), _vm._v(" "), _c('span', [_vm._v("Users")])])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      active: _vm.isActive('/cnpros')
    },
    attrs: {
      "href": "cnpros"
    }
  }, [_c('i', {
    staticClass: "fa fa-crosshairs"
  }), _vm._v(" "), _c('span', [_vm._v("CNpros")])])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      active: _vm.isActive('/businesses')
    },
    attrs: {
      "href": "businesses"
    }
  }, [_c('i', {
    staticClass: "fa fa-briefcase"
  }), _vm._v(" "), _c('span', [_vm._v("Businesses")])])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      active: _vm.isActive('/contracts')
    },
    attrs: {
      "href": "contracts"
    }
  }, [_c('i', {
    staticClass: "fa fa-tasks"
  }), _vm._v(" "), _c('span', [_vm._v("Contracts")])])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      active: _vm.isActive('/payments')
    },
    attrs: {
      "href": "payments"
    }
  }, [_c('i', {
    staticClass: "fa fa-money"
  }), _vm._v(" "), _c('span', [_vm._v("Payouts")])])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      active: _vm.isActive('/cnsurveys')
    },
    attrs: {
      "href": "cnsurveys"
    }
  }, [_c('i', {
    staticClass: "fa fa-crosshairs"
  }), _vm._v(" "), _c('span', [_vm._v("CNsurveys")])])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      active: _vm.isActive('/forums')
    },
    attrs: {
      "href": "forums"
    }
  }, [_c('i', {
    staticClass: "fa fa-meh-o"
  }), _vm._v(" "), _c('span', [_vm._v("Forums")])])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      active: _vm.isActive('/referrals')
    },
    attrs: {
      "href": "referrals"
    }
  }, [_c('i', {
    staticClass: "fa fa-users"
  }), _vm._v(" "), _c('span', [_vm._v("Referrals")])])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      active: _vm.isActive('/cwallets')
    },
    attrs: {
      "href": "cnwallets"
    }
  }, [_c('i', {
    staticClass: "fa fa-money"
  }), _vm._v(" "), _c('span', [_vm._v("CNwallets")])])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      active: _vm.isActive('/rewards')
    },
    attrs: {
      "href": "rewards"
    }
  }, [_c('i', {
    staticClass: "fa fa-money"
  }), _vm._v(" "), _c('span', [_vm._v("Rewards")])])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      active: _vm.isActive('/payments')
    },
    attrs: {
      "href": "cnpayments"
    }
  }, [_c('i', {
    staticClass: "fa fa-money"
  }), _vm._v(" "), _c('span', [_vm._v("CNpayments")])])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      active: _vm.isActive('/cnpaymentsremita')
    },
    attrs: {
      "href": "cnpaymentsremita"
    }
  }, [_c('i', {
    staticClass: "fa fa-glass"
  }), _vm._v(" "), _c('span', [_vm._v(" CNpay (Remita) ")])])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      active: _vm.isActive('/cnpaymentspaga')
    },
    attrs: {
      "href": "cnpaymentspaga"
    }
  }, [_c('i', {
    staticClass: "fa fa-glass"
  }), _vm._v(" "), _c('span', [_vm._v(" CNpay (PAGA) ")])])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      active: _vm.isActive('/cndiscounts')
    },
    attrs: {
      "href": "cndiscounts"
    }
  }, [_c('i', {
    staticClass: "fa fa-tasks"
  }), _vm._v(" "), _c('span', [_vm._v(" CNdiscounts ")])])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      active: _vm.isActive('/cninsurance')
    },
    attrs: {
      "href": "cninsurance"
    }
  }, [_c('i', {
    staticClass: "fa fa-tasks"
  }), _vm._v(" "), _c('span', [_vm._v(" CNinsurance ")])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('li', [_c('a', {
    class: {
      active: _vm.isActive('/login')
    },
    attrs: {
      "href": "login"
    }
  }, [_c('i', {
    staticClass: "fa fa-power-off"
  }), _vm._v(" "), _c('span', [_vm._v("Logout")])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top-nav clearfix"
  }, [_c('ul', {
    staticClass: "nav pull-right top-menu"
  }, [_c('li', {
    staticClass: "dropdown"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "data-toggle": "dropdown",
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "username"
  }, [_vm._v("Admin")]), _vm._v(" "), _c('b', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu extended logout"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "settings"
    }
  }, [_c('i', {
    staticClass: "fa fa-cog"
  }), _vm._v(" Settings")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "messages"
    }
  }, [_c('i', {
    staticClass: "fa fa-cog"
  }), _vm._v(" Messages")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "login"
    }
  }, [_c('i', {
    staticClass: "fa fa-key"
  }), _vm._v(" Log Out")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "settings"
    }
  }, [_c('i', {
    staticClass: "fa fa-gear"
  }), _vm._v(" "), _c('span', [_vm._v("Settings")])])])
}]}

/***/ }),
/* 165 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "container"
    }
  }, [_c('component-header'), _vm._v(" "), _c('section', {
    attrs: {
      "id": "main-content"
    }
  }, [(_vm.viewFlag) ? _c('section', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "agileits-w3layouts-stats"
  }, [_c('div', {
    staticClass: "col-md-4 stats-info widget"
  }, [_c('div', {
    staticClass: "stats-info-agileits"
  }, [_c('button', {
    staticClass: "btn btn-success pull-right",
    staticStyle: {
      "margin-bottom": "1em"
    },
    on: {
      "click": function($event) {
        _vm.setPanel('viewAll', '')
      }
    }
  }, [_vm._v("Back")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "stats-title"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.forum.forum_topic))])]), _vm._v(" "), _c('div', {
    staticClass: "stats-body"
  }, [_vm._m(0), _c('blockquote', [_vm._v(_vm._s(_vm.forum.forum_description))]), _c('p'), _vm._v(" "), _c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.img_url + _vm.forum.forum_created_by_image
    }
  }), _c('br'), _vm._v(" "), _c('ul', {
    staticClass: "list-unstyled"
  }, [_c('li', [_vm._v("Created By "), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.forum.forum_created_by))])]), _vm._v(" "), _c('li', [_vm._v("Category  "), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.forum.forum_category))])]), _vm._v(" "), _c('li', [_vm._v("Comments"), (_vm.forum.forum_comments.length) ? _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.forum.forum_comments.length))]) : _vm._e()]), _vm._v(" "), _c('li', [_vm._v("Date Created "), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.forum.forum_reg_date))])])]), _vm._v(" "), (_vm.setDeleteForum) ? _c('div', [_c('p', [_vm._v("Do you really want to delete this forum?")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.deleteForum()
      }
    }
  }, [_vm._v("Yes, Delete")])]) : _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setPanel('delete-forum', '')
      }
    }
  }, [_vm._v("Delete this forum")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 stats-info stats-last widget-shadow"
  }, [_c('div', {
    staticClass: "notifications"
  }, [_c('header', {
    staticClass: "panel-heading"
  }, [_vm._v("Discussions")]), _vm._v(" "), _c('div', {
    staticClass: "notify-w3ls"
  }, _vm._l((_vm.forum.forum_comments), function(comment) {
    return _c('div', {
      staticClass: "alert alert-info clearfix"
    }, [_c('span', {
      staticClass: "alert-icon"
    }, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": _vm.img_url + comment.forum_comment_user_image
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "notification-info"
    }, [_c('ul', {
      staticClass: "clearfix notification-meta"
    }, [_c('li', {
      staticClass: "pull-left notification-sender"
    }, [_c('span', [_c('a', {
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(comment.forum_comment_user))])]), _vm._v(" " + _vm._s(comment.forum_comment_comment))])]), _vm._v(" "), _c('p', [_vm._v("\r\n                                 " + _vm._s(comment.forum_comment_date) + "\r\n                              ")]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.setDeleteForumComment) ? _c('div', [_c('p', [_vm._v("Do you really want to delete this discussion?")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.deleteForumComment(comment.forum_comment_id)
        }
      }
    }, [_vm._v("Yes, Delete")])]) : _c('button', {
      staticClass: "btn btn-danger",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setPanel('delete-forum-comment', '')
        }
      }
    }, [_vm._v("Delete this discussion")])])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]) : _c('section', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "market-updates"
  }, [_c('div', {
    staticClass: "col-md-3 market-update-gd"
  }, [_c('div', {
    staticClass: "market-update-block clr-block-2"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 market-update-left"
  }, [_c('h4', [_vm._v("Forums")]), _vm._v(" "), (_vm.forums) ? _c('h3', [_vm._v(_vm._s(_vm.forums.length))]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("@ count Today")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "table-agile-info"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("\r\n         All Forums\r\n        ")]), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "table",
    attrs: {
      "ui-jq": "footable",
      "ui-options": "{\r\n            \"paging\": {\r\n              \"enabled\": true\r\n            },\r\n            \"filtering\": {\r\n              \"enabled\": true\r\n            },\r\n            \"sorting\": {\r\n              \"enabled\": true\r\n            }}"
    }
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.forums), function(forum, index) {
    return _c('tr', {
      attrs: {
        "data-expanded": "true"
      }
    }, [_c('td', [_vm._v(_vm._s(++index))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(forum.forum_ref))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(forum.forum_category))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(forum.forum_topic))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(forum.forum_created_by))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-success",
      on: {
        "click": function($event) {
          _vm.setPanel('view', forum)
        }
      }
    }, [_vm._v("View")])])])
  }))])])])])]), _vm._v(" "), _c('component-footer')], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('i')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4 market-update-right"
  }, [_c('i', {
    staticClass: "fa fa-meh-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "data-breakpoints": "xs"
    }
  }, [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Forum ID")]), _vm._v(" "), _c('th', [_vm._v("Category")]), _vm._v(" "), _c('th', {
    attrs: {
      "data-breakpoints": "xs"
    }
  }, [_vm._v("Topic")]), _vm._v(" "), _c('th', [_vm._v("Created By")]), _vm._v(" "), _c('th', [_vm._v("~")])])])
}]}

/***/ }),
/* 166 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', [_c('div', {
    staticClass: "nav-collapse",
    staticStyle: {
      "margin-top": "5em",
      "overflow": "auto"
    },
    attrs: {
      "id": "sidebar"
    }
  }, [_c('div', {
    staticClass: "leftside-navigation"
  }, [_c('ul', {
    staticClass: "sidebar-menu",
    attrs: {
      "id": "nav-accordion"
    }
  }, [_c('li', [_c('a', {
    class: {
      active: _vm.isActive('/dashboard')
    },
    attrs: {
      "href": "dashboard"
    }
  }, [_c('i', {
    staticClass: "fa fa-dashboard"
  }), _vm._v(" "), _c('span', [_vm._v("Dashboard")])])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      active: _vm.isActive('/users')
    },
    attrs: {
      "href": "users"
    }
  }, [_c('i', {
    staticClass: "fa fa-users"
  }), _vm._v(" "), _c('span', [_vm._v("Users")])])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      active: _vm.isActive('/cnpros')
    },
    attrs: {
      "href": "cnpros"
    }
  }, [_c('i', {
    staticClass: "fa fa-crosshairs"
  }), _vm._v(" "), _c('span', [_vm._v("CNPros")])])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      active: _vm.isActive('/businesses')
    },
    attrs: {
      "href": "businesses"
    }
  }, [_c('i', {
    staticClass: "fa fa-briefcase"
  }), _vm._v(" "), _c('span', [_vm._v("Businesses")])])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      active: _vm.isActive('/contracts')
    },
    attrs: {
      "href": "contracts"
    }
  }, [_c('i', {
    staticClass: "fa fa-tasks"
  }), _vm._v(" "), _c('span', [_vm._v("Contracts")])])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      active: _vm.isActive('/cnsurveys')
    },
    attrs: {
      "href": "cnsurveys"
    }
  }, [_c('i', {
    staticClass: "fa fa-crosshairs"
  }), _vm._v(" "), _c('span', [_vm._v("CNsurveys")])])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      active: _vm.isActive('/forums')
    },
    attrs: {
      "href": "forums"
    }
  }, [_c('i', {
    staticClass: "fa fa-meh-o"
  }), _vm._v(" "), _c('span', [_vm._v("Forums")])])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      active: _vm.isActive('/referrals')
    },
    attrs: {
      "href": "referrals"
    }
  }, [_c('i', {
    staticClass: "fa fa-users"
  }), _vm._v(" "), _c('span', [_vm._v("Referrals")])])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      active: _vm.isActive('/cwallets')
    },
    attrs: {
      "href": "cnwallets"
    }
  }, [_c('i', {
    staticClass: "fa fa-money"
  }), _vm._v(" "), _c('span', [_vm._v("CNwallets")])])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      active: _vm.isActive('/rewards')
    },
    attrs: {
      "href": "rewards"
    }
  }, [_c('i', {
    staticClass: "fa fa-money"
  }), _vm._v(" "), _c('span', [_vm._v("Rewards")])])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      active: _vm.isActive('/payments')
    },
    attrs: {
      "href": "payments"
    }
  }, [_c('i', {
    staticClass: "fa fa-money"
  }), _vm._v(" "), _c('span', [_vm._v("Payments")])])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      active: _vm.isActive('/cnpaymentsremita')
    },
    attrs: {
      "href": "cnpayments"
    }
  }, [_c('i', {
    staticClass: "fa fa-glass"
  }), _vm._v(" "), _c('span', [_vm._v(" CNpay (Remita) ")])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('li', [_c('a', {
    class: {
      active: _vm.isActive('/login')
    },
    attrs: {
      "href": "login"
    }
  }, [_c('i', {
    staticClass: "fa fa-power-off"
  }), _vm._v(" "), _c('span', [_vm._v("Logout")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "settings"
    }
  }, [_c('i', {
    staticClass: "fa fa-gear"
  }), _vm._v(" "), _c('span', [_vm._v("Settings")])])])
}]}

/***/ }),
/* 167 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "container"
    }
  }, [_c('component-header'), _vm._v(" "), _c('section', {
    attrs: {
      "id": "main-content"
    }
  }, [(_vm.viewFlag) ? _c('section', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "agileits-w3layouts-stats"
  }, [_c('div', {
    staticClass: "col-md-8 stats-info stats-last widget-shadow"
  }, [_c('div', {
    staticClass: "notifications"
  }, [_c('header', {
    staticClass: "panel-heading"
  }, [_vm._v("Profile")]), _vm._v(" "), _c('div', {
    staticClass: "notify-w3ls"
  }, [_c('table', {
    staticClass: "table",
    attrs: {
      "ui-jq": "footable",
      "ui-options": "{\r\n                              \"paging\": {\r\n                              \"enabled\": true\r\n                              },\r\n                              \"filtering\": {\r\n                              \"enabled\": true\r\n                              },\r\n                              \"sorting\": {\r\n                              \"enabled\": true\r\n                              }}"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.business.business_name))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Email")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.business.business_email))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("City")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.business.business_city_name))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Phone")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.business.business_phone))])]), _vm._v(" "), _c('tr', [_c('th'), _vm._v(" "), _c('td', [_c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Edit")]), _vm._v("  "), _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        _vm.requests('delete')
      }
    }
  }, [_vm._v("Delete")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('tr', [_c('th'), _vm._v(" "), (_vm.deleteRequest) ? _c('td', [_c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Do you really want to do this?")]), _vm._v(" "), _c('br'), _c('button', {
    staticClass: "btn btn-danger btn-xs",
    on: {
      "click": _vm.deleteListing
    }
  }, [_vm._v("Yes Delete")])]) : _vm._e()])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 stats-info widget"
  }, [_c('div', {
    staticClass: "stats-info-agileits"
  }, [_c('div', {
    staticClass: "stats-title"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.business.business_name))])]), _vm._v(" "), _c('div', {
    staticClass: "stats-body"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.img_url + _vm.business.business_image
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]) : _c('section', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "market-updates"
  }, [_c('div', {
    staticClass: "col-md-3 market-update-gd"
  }, [_c('div', {
    staticClass: "market-update-block clr-block-2"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 market-update-left"
  }, [_c('h4', [_vm._v("Businesses")]), _vm._v(" "), (_vm.businesses) ? _c('h3', [_vm._v(_vm._s(_vm.businesses.length))]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("@ count Today")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "table-agile-info"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("\r\n         Businesses Lists\r\n        ")]), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "table",
    attrs: {
      "ui-jq": "footable",
      "ui-options": "{\r\n            \"paging\": {\r\n              \"enabled\": true\r\n            },\r\n            \"filtering\": {\r\n              \"enabled\": true\r\n            },\r\n            \"sorting\": {\r\n              \"enabled\": true\r\n            }}"
    }
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.businesses), function(business, index) {
    return _c('tr', {
      attrs: {
        "data-expanded": "true"
      }
    }, [_c('td', [_vm._v(_vm._s(++index))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(business.business_ref))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(business.business_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(business.business_category_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(business.business_owner_name))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-success",
      on: {
        "click": function($event) {
          _vm.setPanel('view', business)
        }
      }
    }, [_vm._v("View")])])])
  }))])])])])]), _vm._v(" "), _c('component-footer')], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4 market-update-right"
  }, [_c('i', {
    staticClass: "fa fa-briefcase"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "data-breakpoints": "xs"
    }
  }, [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Business ID")]), _vm._v(" "), _c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', {
    attrs: {
      "data-breakpoints": "xs"
    }
  }, [_vm._v("Category")]), _vm._v(" "), _c('th', {
    attrs: {
      "data-breakpoints": "xs sm md",
      "data-title": "DOB"
    }
  }, [_vm._v("Owner")]), _vm._v(" "), _c('th', [_vm._v("~")])])])
}]}

/***/ }),
/* 168 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "header-wrapper"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "header-inner"
  }, [_c('div', {
    staticClass: "header-logo"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "7em"
    },
    attrs: {
      "src": "static/assets/img/logo.png",
      "alt": "Logo"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "header-content"
  }, [_c('div', {
    staticClass: "header-top"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "header-nav-secondary nav nav-pills"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("Login")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/register"
    }
  }, [_vm._v("Register")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "header-bottom"
  }, [_c('ul', {
    staticClass: "header-nav-primary nav nav-pills collapse navbar-collapse"
  }, [_c('li', {}, [_c('router-link', {
    attrs: {
      "to": "/forums"
    }
  }, [_vm._v("Forums")])], 1), _vm._v(" "), _c('li', {}, [_c('router-link', {
    attrs: {
      "to": "/cnpros"
    }
  }, [_vm._v("CNpros")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "cnsurveys"
    }
  }, [_vm._v("CNsurveys")])], 1), _vm._v(" "), _c('li', {}, [_c('router-link', {
    attrs: {
      "to": "#"
    }
  }, [_vm._v("How It Works")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/pricing"
    }
  }, [_vm._v("Plans & Pricing")])], 1), _vm._v(" "), (_vm.user != null && _vm.user != undefined && _vm.user != '') ? [_c('li', [_c('router-link', {
    attrs: {
      "to": "dashboard"
    }
  }, [_vm._v("Hello, " + _vm._s(_vm.user) + " "), _c('i', {
    staticClass: "fa fa-chevron-down"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "sub-menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "dashboard"
    }
  }, [_vm._v("My Account")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "login"
    }
  }, [_vm._v("Logout")])], 1)])], 1)] : [_c('li', {
    staticClass: "hidden-lg hidden-md"
  }, [_c('router-link', {
    attrs: {
      "to": "login"
    }
  }, [_vm._v("Log In")])], 1), _vm._v(" "), _c('li', {
    staticClass: "hidden-lg hidden-md"
  }, [_c('router-link', {
    attrs: {
      "to": "register"
    }
  }, [_vm._v("Sign Up")])], 1)]], 2), _vm._v(" "), _vm._m(1)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "header-nav-social social-links nav nav-pills"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-google-plus"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "navbar-toggle collapsed",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": ".header-nav-primary"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })])
}]}

/***/ }),
/* 169 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "container"
    }
  }, [_c('component-header'), _vm._v(" "), _c('section', {
    attrs: {
      "id": "main-content"
    }
  }, [(_vm.panelFlag) ? _c('section', {
    staticClass: "wrapper"
  }, [(_vm.viewFlag) ? _c('div', [_c('div', {
    staticClass: "agileits-w3layouts-stats"
  }, [_c('div', {
    staticClass: "col-md-8 col-md-offset-2 stats-info stats-last widget-shadow"
  }, [_c('div', {
    staticClass: "notifications"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "notify-w3ls col-md-offset-2"
  }, [_vm._m(1), _vm._v(" "), _c('table', {
    staticClass: "table",
    attrs: {
      "ui-jq": "footable",
      "ui-options": "{\r\n                                    \"paging\": {\r\n                                    \"enabled\": true\r\n                                    },\r\n                                    \"filtering\": {\r\n                                    \"enabled\": true\r\n                                    },\r\n                                    \"sorting\": {\r\n                                    \"enabled\": true\r\n                                    }}"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Date Activated")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.payment.contract_money_date))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Payment Ref")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.payment.contract_money_ref))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Contract")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.payment.contract_money_contract_ref))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("CNpro")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.payment.contract_money_contract_cnpro_name))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Service Charge")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.payment.contract_money_set_service_charge) + " %")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Labour Cost")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.payment.contract_money_labour_cost))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Amount To Pay")]), _vm._v(" "), _c('td', [_vm._v("₦" + _vm._s(_vm.payment.contract_money_pay_out_amount))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Payment Status")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.payment.contract_money_status))])]), _vm._v(" "), (_vm.payment.contract_money_paid_date) ? _c('tr', [_c('th', [_vm._v("Date Paid")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.payment.contract_money_paid_date))])]) : _vm._e(), _vm._v(" "), (_vm.payment.contract_money_status_id != 9) ? _c('tr', [_c('th'), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.payMoney
    }
  }, [_vm._v("Pay Money")]), _vm._v("  ")])]) : _vm._e()])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _vm._e()]) : _c('section', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "market-updates"
  }, [_c('div', {
    staticClass: "col-md-3 market-update-gd"
  }, [_c('div', {
    staticClass: "market-update-block clr-block-2"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 market-update-left"
  }, [_c('h4', [_vm._v("Payments")]), _vm._v(" "), (_vm.payments) ? _c('h3', [_vm._v(_vm._s(_vm.payments.length))]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("@ count Today")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "table-agile-info"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("\r\n         Payments Requests  \r\n        ")]), _vm._v(" "), _c('div', [_vm._m(3), _vm._v(" "), _c('table', {
    staticClass: "table",
    attrs: {
      "ui-jq": "footable",
      "ui-options": "{\r\n            \"paging\": {\r\n              \"enabled\": true\r\n            },\r\n            \"filtering\": {\r\n              \"enabled\": true\r\n            },\r\n            \"sorting\": {\r\n              \"enabled\": true\r\n            }}"
    }
  }, [_vm._m(4), _vm._v(" "), _c('tbody', _vm._l((_vm.payments), function(payment, index) {
    return _c('tr', {
      attrs: {
        "data-expanded": "true"
      }
    }, [_c('td', [_vm._v(_vm._s(++index))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(payment.contract_money_date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(payment.contract_money_ref))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(payment.contract_money_contract_cnpro_name))]), _vm._v(" "), _c('td', {
      style: ({
        background: payment.contract_money_status_color,
        color: '#fff',
        padding: '0.4em'
      })
    }, [_vm._v(_vm._s(payment.contract_money_status))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-success",
      on: {
        "click": function($event) {
          _vm.setPanel('view', payment)
        }
      }
    }, [_vm._v("View")])])])
  }))])])])])]), _vm._v(" "), _c('component-footer')], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "panel-heading"
  }, [_vm._v("\r\n                                    Payment Details\r\n                                    "), _c('a', {
    staticClass: "btn btn-success pull-right",
    attrs: {
      "href": "payments"
    }
  }, [_vm._v("Back")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-left"
  }, [_c('hr'), _vm._v(" "), _c('p', [_c('b', [_vm._v("Activated:")]), _vm._v("(Contract has ended, Money is available)")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Pending:")]), _vm._v("(CNpro has requested For Money)")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Paid:")]), _vm._v("(Cityneeds has paid CNpro)")]), _vm._v(" "), _c('hr')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4 market-update-right"
  }, [_c('i', {
    staticClass: "fa fa-money-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-left"
  }, [_c('hr'), _vm._v(" "), _c('p', [_c('b', [_vm._v(" Activated:")]), _vm._v("(Contract has ended, Money is available)")]), _vm._v(" "), _c('p', [_c('b', [_vm._v(" Pending:")]), _vm._v("(CNpro has requested For Money)")]), _vm._v(" "), _c('p', [_c('b', [_vm._v(" Paid:")]), _vm._v("(Cityneeds has paid CNpro)")]), _vm._v(" "), _c('hr')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "data-breakpoints": "xs"
    }
  }, [_vm._v("S/N")]), _vm._v(" "), _c('th', [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v("REF.")]), _vm._v(" "), _c('th', {
    attrs: {
      "data-breakpoints": "xs"
    }
  }, [_vm._v("CNpro")]), _vm._v(" "), _c('th', {
    attrs: {
      "data-breakpoints": "xs sm md",
      "data-title": "DOB"
    }
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("~")])])])
}]}

/***/ }),
/* 170 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "container"
    }
  }, [_c('component-header'), _vm._v(" "), _c('section', {
    attrs: {
      "id": "main-content"
    }
  }, [(_vm.viewFlag) ? _c('section', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "agileits-w3layouts-stats"
  }, [_c('div', {
    staticClass: "col-md-8 stats-info stats-last widget-shadow"
  }, [_c('div', {
    staticClass: "notifications"
  }, [_c('header', {
    staticClass: "panel-heading"
  }, [_vm._v("\r\n                             CNsurvey Details\r\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "notify-w3ls"
  }, [_c('table', {
    staticClass: "table",
    attrs: {
      "ui-jq": "footable",
      "ui-options": "{\r\n                                \"paging\": {\r\n                                \"enabled\": true\r\n                                },\r\n                                \"filtering\": {\r\n                                \"enabled\": true\r\n                                },\r\n                                \"sorting\": {\r\n                                \"enabled\": true\r\n                                }}"
    }
  }, [(_vm.setDeleteSurvey) ? _c('thead', [_vm._m(0), _vm._v(" "), _c('tr', [_c('th'), _vm._v(" "), _c('td', [_c('a', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.deleteSurvey()
      }
    }
  }, [_vm._v("Yes Delete")]), _vm._v("  \r\n                                    ")])])]) : _c('thead', [_c('tr', [_c('th', [_vm._v("Title")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnsurvey.cnsurvey_title))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("State")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnsurvey.cnsurvey_state_name))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("City")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnsurvey.cnsurvey_city_name))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Business")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnsurvey.cnsurvey_business_name))])]), _vm._v(" "), _c('tr', [_c('th'), _vm._v(" "), _c('td', [_c('a', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        _vm.setPanel('setDelete', '')
      }
    }
  }, [_vm._v("Delete")])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 stats-info widget"
  }, [_c('div', {
    staticClass: "stats-info-agileits"
  }, [_c('div', {
    staticClass: "stats-title"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("CNsurvey Status: "), _c('u', [_vm._v(_vm._s(_vm.cnsurvey.cnsurvey_status_name))])])]), _vm._v(" "), _c('div', {
    staticClass: "stats-body"
  }, [(_vm.cnsurvey.cnsurvey_status == 2) ? _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.approveSurvey(_vm.cnsurvey.cnsurvey_id)
      }
    }
  }, [_vm._v("Approve This Survey")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_c('b', [_vm._v("Activation Fee: ")]), _vm._v(_vm._s(_vm.cnsurvey.cnsurvey_activation_fee))]), _vm._v(" "), (_vm.cnsurvey.cnsurvey_activation_fee == 0) ? _c('div', [_c('label', [_vm._v("Set CNsurvey Activation Fee")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activation_fee),
      expression: "activation_fee"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.activation_fee)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.activation_fee = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.setActivationFee
    }
  }, [_vm._v("Enter")])]) : _vm._e(), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _vm._m(1)])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "agileits-w3layouts-stats"
  }, [_vm._m(2), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _vm._l((_vm.cnsurvey.cnsurveys_questions), function(svq, index) {
    return _c('div', {
      staticClass: "col-md-4 stats-info widget"
    }, [_c('div', {
      staticClass: "stats-info-agileits"
    }, [_c('div', {
      staticClass: "stats-title"
    }, [_c('h4', {
      staticClass: "title"
    }, [_vm._v(_vm._s(svq.cnsurvey_question))])]), _vm._v(" "), _c('div', {
      staticClass: "stats-body"
    }, [_c('ul', {
      staticClass: "list-unstyled"
    }, _vm._l((svq.cnsurveys_option), function(opt) {
      return _c('li', [_vm._v("\r\n                                                " + _vm._s(opt.cnsurvey_option_option) + " "), _c('span', {
        staticClass: "pull-right"
      }, [_vm._v("78%")]), _vm._v(" "), _vm._m(3, true)])
    }))])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 2)]) : _c('section', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "market-updates"
  }, [_c('div', {
    staticClass: "col-md-3 market-update-gd"
  }, [_c('div', {
    staticClass: "market-update-block clr-block-2"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 market-update-left"
  }, [_c('h4', [_vm._v("cnsurveys")]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.cnsurveys.length))]), _vm._v(" "), _c('p', [_vm._v("@ count Today")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "col-md-12 stats-info widget"
  }, [_c('div', {
    staticClass: "stats-info-agileits"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "stats-body"
  }, _vm._l((_vm.cnsurveys), function(cnsurvey) {
    return _c('ul', {
      staticClass: "list-unstyled"
    }, [_c('li', [_c('button', {
      staticClass: "btn btn-success",
      on: {
        "click": function($event) {
          _vm.setPanel('view', cnsurvey)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-eye"
    })]), _vm._v("\r\n                                                " + _vm._s(cnsurvey.cnsurvey_title)), _c('span', {
      staticClass: "pull-right"
    }, [_vm._v("85%")]), _vm._v(" "), _vm._m(6, true)])])
  }))])])])]), _vm._v(" "), _c('component-footer')], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th'), _vm._v(" "), _c('td', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Do you really want to delete this CNsurvey?")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', [_c('u', [_vm._v("Payment details")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    attrs: {
      "align": "center"
    }
  }, [_c('u', [_vm._v("CNsurvey Questions")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress progress-striped active progress-right"
  }, [_c('div', {
    staticClass: "bar green",
    staticStyle: {
      "width": "85%"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4 market-update-right"
  }, [_c('i', {
    staticClass: "fa fa-cnsurveys"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stats-title"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("Cnsurveys")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress progress-striped active progress-right"
  }, [_c('div', {
    staticClass: "bar green",
    staticStyle: {
      "width": "85%"
    }
  })])
}]}

/***/ }),
/* 171 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "container"
    }
  }, [_c('component-header'), _vm._v(" "), _c('section', {
    attrs: {
      "id": "main-content"
    }
  }, [(_vm.panelFlag) ? _c('section', {
    staticClass: "wrapper"
  }, [(_vm.viewFlag) ? _c('div', [_c('div', {
    staticClass: "agileits-w3layouts-stats"
  }, [_c('div', {
    staticClass: "col-md-8 col-md-offset-2 stats-info stats-last widget-shadow"
  }, [_c('div', {
    staticClass: "notifications"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "notify-w3ls col-md-offset-2"
  }, [_c('table', {
    staticClass: "table",
    attrs: {
      "ui-jq": "footable",
      "ui-options": "{\r\n                                    \"paging\": {\r\n                                    \"enabled\": true\r\n                                    },\r\n                                    \"filtering\": {\r\n                                    \"enabled\": true\r\n                                    },\r\n                                    \"sorting\": {\r\n                                    \"enabled\": true\r\n                                    }}"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Date of Reg")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cndiscount.cndiscount_reg_date))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Status")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cndiscount.cndiscount_status_name))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Payment")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cndiscount.cndiscount_payment_status_name))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Ref")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cndiscount.cndiscount_ref))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Business")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cndiscount.cndiscount_business_name))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Caption")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cndiscount.cndiscount_caption))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Discount Code")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cndiscount.cndiscount_code))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Discount Description")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cndiscount.cndiscount_description))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Discount Claim Link")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cndiscount.cndiscount_link))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Start Date")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cndiscount.cndiscount_start_date))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Expiry Date")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cndiscount.cndiscount_expiry_date))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Normal Price")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cndiscount.cndiscount_normal_price))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Discount Price")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cndiscount.cndiscount_discount_price))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Discount Media")]), _vm._v(" "), _c('td', [(_vm.cndiscount.cndiscount_media && (_vm.cndiscount.cndiscount_media != '')) ? _c('div', {
    staticStyle: {
      "height": "250px",
      "width": "100%"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "src": _vm.img_url + _vm.cndiscount.cndiscount_media
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.cndiscount.cndiscount_status == 1) ? _c('div', [_vm._m(1), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Payment Date")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cndiscount.cndiscount_payment_date))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Amount Paid")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cndiscount.cndiscount_amount_paid))])])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [(_vm.cndiscount.cndiscount_status == 1) ? _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        _vm.updateDiscountStatus(_vm.cndiscount, _vm.index, 21)
      }
    }
  }, [_vm._v("Deactivate")]) : _vm._e(), _vm._v(" "), (_vm.cndiscount.cndiscount_status == 21) ? _c('button', {
    staticClass: "btn btn-warning",
    on: {
      "click": function($event) {
        _vm.updateDiscountStatus(_vm.cndiscount, _vm.index, 1)
      }
    }
  }, [_vm._v("Activate")]) : _vm._e()])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _vm._e()]) : _c('section', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "market-updates"
  }, [_c('div', {
    staticClass: "col-md-3 market-update-gd"
  }, [_c('div', {
    staticClass: "market-update-block clr-block-2"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 market-update-left"
  }, [_c('h4', [_vm._v(" CNdiscounts")]), _vm._v(" "), (_vm.cndiscounts) ? _c('h3', [_vm._v(_vm._s(_vm.count_today))]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("@ count Today")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "table-agile-info"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("\r\n         CNiscount Submissions\r\n        ")]), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "table",
    attrs: {
      "ui-jq": "footable",
      "ui-options": "{\r\n            \"paging\": {\r\n              \"enabled\": true\r\n            },\r\n            \"filtering\": {\r\n              \"enabled\": true\r\n            },\r\n            \"sorting\": {\r\n              \"enabled\": true\r\n            }}"
    }
  }, [_vm._m(3), _vm._v(" "), _c('tbody', _vm._l((_vm.cndiscounts), function(cndiscount, index) {
    return _c('tr', {
      attrs: {
        "data-expanded": "true"
      }
    }, [_c('td', [_vm._v(_vm._s((index + 1)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(cndiscount.cndiscount_reg_date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(cndiscount.cndiscount_ref))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(cndiscount.cndiscount_business_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(cndiscount.cndiscount_caption))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(cndiscount.cndiscount_start_date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(cndiscount.cndiscount_expiry_date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(cndiscount.cndiscount_status_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(cndiscount.cndiscount_payment_status_name))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-success",
      on: {
        "click": function($event) {
          _vm.setPanel('view', cndiscount)
        }
      }
    }, [_vm._v("View")])]), _vm._v(" "), _c('td', [(cndiscount.cndiscount_status == 1) ? _c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          _vm.updateDiscountStatus(cndiscount, index, 21)
        }
      }
    }, [_vm._v("Deactivate")]) : _vm._e(), _vm._v(" "), (cndiscount.cndiscount_status == 21) ? _c('button', {
      staticClass: "btn btn-warning",
      on: {
        "click": function($event) {
          _vm.updateDiscountStatus(cndiscount, index, 1)
        }
      }
    }, [_vm._v("Activate")]) : _vm._e()])])
  }))])])])])]), _vm._v(" "), _c('component-footer')], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "panel-heading"
  }, [_vm._v("\r\n                                    CNdsicount Details\r\n                                    "), _c('a', {
    staticClass: "btn btn-success pull-right",
    attrs: {
      "href": "cndiscounts"
    }
  }, [_vm._v("Back")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('u', [_vm._v("Payment Details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4 market-update-right"
  }, [_c('i', {
    staticClass: "fa fa-money-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "data-breakpoints": "xs"
    }
  }, [_vm._v("S/N")]), _vm._v(" "), _c('th', [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v("REF.")]), _vm._v(" "), _c('th', [_vm._v("Business")]), _vm._v(" "), _c('th', [_vm._v("Caption")]), _vm._v(" "), _c('th', [_vm._v("Start Date")]), _vm._v(" "), _c('th', [_vm._v("Expiry Date")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Payment")]), _vm._v(" "), _c('th', [_vm._v("~")]), _vm._v(" "), _c('th', [_vm._v("~")])])])
}]}

/***/ }),
/* 172 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "container"
    }
  }, [_c('component-header'), _vm._v(" "), _c('section', {
    attrs: {
      "id": "main-content"
    }
  }, [_c('section', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "market-updates"
  }, [_c('div', {
    staticClass: "col-md-3 market-update-gd"
  }, [_c('div', {
    staticClass: "market-update-block clr-block-2"
  }, [_c('div', {
    staticClass: "col-md-12 market-update-left"
  }, [_c('h4', [_vm._v("Total Rewards Transactions")]), _vm._v(" "), (_vm.users) ? _c('h3', [_vm._v("₦" + _vm._s(_vm.formatCurrency(_vm.total_rewards_spent)))]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("@ count Today")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "table-agile-info"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("\r\n        Rewards Transactions\r\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "notifications"
  }, [_c('table', {
    staticClass: "table hidden-sm hidden-xs"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.wallet_transactions), function(txn) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(txn.wallet_transaction_reg_date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(txn.wallet_transaction_ref))]), _vm._v(" "), _c('td', [_c('span', {
      staticStyle: {
        "padding": "5px",
        "color": "#ffffff"
      },
      style: ({
        backgroundColor: txn.wallet_transaction_type_color
      })
    }, [_vm._v(_vm._s(txn.wallet_transaction_type))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatCurrency(txn.wallet_transaction_amount)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatCurrency(txn.wallet_transaction_current_balance)))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-default btn-sm",
      attrs: {
        "type": "button",
        "data-toggle": "modal",
        "data-target": "#viewWalletTransaction"
      },
      on: {
        "click": function($event) {
          _vm.setWalletTransaction(txn)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-info-circle"
    }), _vm._v(" More Details")])])])
  })], 2), _vm._v(" "), _c('table', {
    staticClass: "table hidden-md hidden-lg"
  }, _vm._l((_vm.wallet_transactions), function(txn) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "padding": "1em"
      }
    }, [_c('p', [_c('b', [_vm._v("Date: ")]), _vm._v(_vm._s(txn.wallet_transaction_reg_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("REF: ")]), _vm._v(_vm._s(txn.wallet_transaction_ref))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Transaction: ")]), _c('span', {
      staticStyle: {
        "padding": "5px",
        "color": "#ffffff"
      },
      style: ({
        backgroundColor: txn.wallet_transaction_type_color
      })
    }, [_vm._v(_vm._s(txn.wallet_transaction_type))])]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Amount: ")]), _vm._v("₦" + _vm._s(_vm.formatCurrency(txn.wallet_transaction_amount)))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Current Balance: ")]), _vm._v("₦" + _vm._s(_vm.formatCurrency(txn.wallet_transaction_current_balance)))]), _vm._v(" "), _c('p', [_c('button', {
      staticClass: "pull-left btn btn-default btn-sm",
      attrs: {
        "type": "button",
        "data-toggle": "modal",
        "data-target": "#viewWalletTransaction"
      },
      on: {
        "click": function($event) {
          _vm.setWalletTransaction(txn)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-info-circle"
    }), _vm._v(" More Details")])])])])
  }))])])])]), _vm._v(" "), _c('component-footer')], 1), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    staticStyle: {
      "margin-top": "7em"
    },
    attrs: {
      "id": "viewWalletTransaction",
      "tabindex": "-10",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "border-radius": "3px"
    }
  }, [_c('button', {
    staticClass: "pull-right btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.closeModal('#viewWalletTransaction')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', [_c('h5', [_vm._v("Transaction Details")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Date: ")]), _vm._v(_vm._s(_vm.wallet_transaction.wallet_transaction_reg_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("REF: ")]), _vm._v(_vm._s(_vm.wallet_transaction.wallet_transaction_ref))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Transaction: ")]), _c('span', {
    staticStyle: {
      "padding": "5px",
      "color": "#ffffff"
    },
    style: ({
      backgroundColor: _vm.wallet_transaction.wallet_transaction_type_color
    })
  }, [_vm._v(_vm._s(_vm.wallet_transaction.wallet_transaction_type))])]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Amount: ")]), _vm._v("₦" + _vm._s(_vm.formatCurrency(_vm.wallet_transaction.wallet_transaction_amount)))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Current Balance: ")]), _vm._v("₦" + _vm._s(_vm.formatCurrency(_vm.wallet_transaction.wallet_transaction_current_balance)))]), _vm._v(" "), (_vm.wallet_transaction.wallet_transaction_service_ref != '') ? _c('div', [(_vm.wallet_transaction.wallet_transaction_service != 'error') ? _c('p', [_c('b', [_vm._v(_vm._s(_vm.wallet_transaction.wallet_transaction_type) + " Service: ")]), _vm._v(_vm._s(_vm.wallet_transaction.wallet_transaction_service))]) : _vm._e(), _vm._v(" "), (_vm.wallet_transaction.wallet_transaction_service != 'error') ? _c('p', [_c('b', [_vm._v(_vm._s(_vm.wallet_transaction.wallet_transaction_type) + " Service Details: ")]), _vm._v(_vm._s(_vm.wallet_transaction.wallet_transaction_service_transaction_name))]) : _vm._e(), _vm._v(" "), _c('p', [_c('b', [_vm._v("Service REF: ")]), _vm._v(_vm._s(_vm.wallet_transaction.wallet_transaction_service_ref))])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.wallet_transaction.wallet_transaction_action_by_admin == 1) ? _c('div', [_vm._m(1), _vm._v(" "), _c('p', [_c('b', [_vm._v("Details: ")]), _vm._v(_vm._s(_vm.wallet_transaction.wallet_transaction_action_by_admin_descr))])]) : _vm._e()])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("~"), _c('span', {
    staticStyle: {
      "font-size": "11px"
    }
  }, [_vm._v("Date")])]), _vm._v(" "), _c('th', [_vm._v("REF")]), _vm._v(" "), _c('th', [_vm._v("Transaction")]), _vm._v(" "), _c('th', [_vm._v("Amount(₦)")]), _vm._v(" "), _c('th', [_vm._v("Current Balance(₦)")]), _vm._v(" "), _c('th', [_vm._v(" --- ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Topup By Admin: ")]), _vm._v("Yes")])
}]}

/***/ }),
/* 173 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "container"
    }
  }, [_c('component-header'), _vm._v(" "), _c('section', {
    attrs: {
      "id": "main-content"
    }
  }, [_c('section', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "market-updates"
  }, [_c('div', {
    staticClass: "col-md-3 market-update-gd"
  }, [_c('div', {
    staticClass: "market-update-block clr-block-2"
  }, [_c('div', {
    staticClass: "col-md-12 market-update-left"
  }, [_c('h4', [_vm._v("Total Wallet Transactions")]), _vm._v(" "), (_vm.users) ? _c('h3', [_vm._v("₦" + _vm._s(_vm.formatCurrency(_vm.total_wallet_balance)))]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("@ count Today")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "table-agile-info"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("\r\n        Wallet Transactions\r\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "notifications"
  }, [_c('table', {
    staticClass: "table hidden-sm hidden-xs"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.wallet_transactions), function(txn) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(txn.wallet_transaction_reg_date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(txn.wallet_transaction_ref))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(txn.wallet_transaction_user))]), _vm._v(" "), _c('td', [_c('span', {
      staticStyle: {
        "padding": "5px",
        "color": "#ffffff"
      },
      style: ({
        backgroundColor: txn.wallet_transaction_type_color
      })
    }, [_vm._v(_vm._s(txn.wallet_transaction_type))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatCurrency(txn.wallet_transaction_amount)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatCurrency(txn.wallet_transaction_current_balance)))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-default btn-sm",
      attrs: {
        "type": "button",
        "data-toggle": "modal",
        "data-target": "#viewWalletTransaction"
      },
      on: {
        "click": function($event) {
          _vm.setWalletTransaction(txn)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-info-circle"
    }), _vm._v(" More Details")])])])
  })], 2), _vm._v(" "), _c('table', {
    staticClass: "table hidden-md hidden-lg"
  }, _vm._l((_vm.wallet_transactions), function(txn) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "padding": "1em"
      }
    }, [_c('p', [_c('b', [_vm._v("Date: ")]), _vm._v(_vm._s(txn.wallet_transaction_reg_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("REF: ")]), _vm._v(_vm._s(txn.wallet_transaction_ref))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("User: ")]), _vm._v(_vm._s(txn.wallet_transaction_user))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Transaction: ")]), _c('span', {
      staticStyle: {
        "padding": "5px",
        "color": "#ffffff"
      },
      style: ({
        backgroundColor: txn.wallet_transaction_type_color
      })
    }, [_vm._v(_vm._s(txn.wallet_transaction_type))])]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Amount: ")]), _vm._v("₦" + _vm._s(_vm.formatCurrency(txn.wallet_transaction_amount)))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Current Balance: ")]), _vm._v("₦" + _vm._s(_vm.formatCurrency(txn.wallet_transaction_current_balance)))]), _vm._v(" "), _c('p', [_c('button', {
      staticClass: "pull-left btn btn-default btn-sm",
      attrs: {
        "type": "button",
        "data-toggle": "modal",
        "data-target": "#viewWalletTransaction"
      },
      on: {
        "click": function($event) {
          _vm.setWalletTransaction(txn)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-info-circle"
    }), _vm._v(" More Details")])])])])
  }))])])])]), _vm._v(" "), _c('component-footer')], 1), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    staticStyle: {
      "margin-top": "7em"
    },
    attrs: {
      "id": "viewWalletTransaction",
      "tabindex": "-10",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "border-radius": "3px"
    }
  }, [_c('button', {
    staticClass: "pull-right btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.closeModal('#viewWalletTransaction')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', [_c('h5', [_vm._v("Transaction Details")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Date: ")]), _vm._v(_vm._s(_vm.wallet_transaction.wallet_transaction_reg_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("REF: ")]), _vm._v(_vm._s(_vm.wallet_transaction.wallet_transaction_ref))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Transaction: ")]), _c('span', {
    staticStyle: {
      "padding": "5px",
      "color": "#ffffff"
    },
    style: ({
      backgroundColor: _vm.wallet_transaction.wallet_transaction_type_color
    })
  }, [_vm._v(_vm._s(_vm.wallet_transaction.wallet_transaction_type))])]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Amount: ")]), _vm._v("₦" + _vm._s(_vm.formatCurrency(_vm.wallet_transaction.wallet_transaction_amount)))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Current Balance: ")]), _vm._v("₦" + _vm._s(_vm.formatCurrency(_vm.wallet_transaction.wallet_transaction_current_balance)))]), _vm._v(" "), (_vm.wallet_transaction.wallet_transaction_service_ref != '') ? _c('div', [(_vm.wallet_transaction.wallet_transaction_service != 'error') ? _c('p', [_c('b', [_vm._v(_vm._s(_vm.wallet_transaction.wallet_transaction_type) + " Service: ")]), _vm._v(_vm._s(_vm.wallet_transaction.wallet_transaction_service))]) : _vm._e(), _vm._v(" "), _c('p', [_c('b', [_vm._v("Service REF: ")]), _vm._v(_vm._s(_vm.wallet_transaction.wallet_transaction_service_ref))])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.wallet_transaction.wallet_transaction_action_by_admin == 1) ? _c('div', [_vm._m(1), _vm._v(" "), _c('p', [_c('b', [_vm._v("Details: ")]), _vm._v(_vm._s(_vm.wallet_transaction.wallet_transaction_action_by_admin_descr))])]) : _vm._e()])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("~"), _c('span', {
    staticStyle: {
      "font-size": "11px"
    }
  }, [_vm._v("Date")])]), _vm._v(" "), _c('th', [_vm._v("REF")]), _vm._v(" "), _c('th', [_vm._v("User")]), _vm._v(" "), _c('th', [_vm._v("Transaction")]), _vm._v(" "), _c('th', [_vm._v("Amount(₦)")]), _vm._v(" "), _c('th', [_vm._v("Current Balance(₦)")]), _vm._v(" "), _c('th', [_vm._v(" --- ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Topup By Admin: ")]), _vm._v("Yes")])
}]}

/***/ }),
/* 174 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "container"
    }
  }, [_c('component-header'), _vm._v(" "), _c('section', {
    attrs: {
      "id": "main-content"
    }
  }, [_c('section', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "table-agile-info"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("\r\n         Business Categories\r\n        ")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "pull-right"
  }, [_c('label', [_vm._v("Add New Category")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('add', '')
      }
    }
  }, [_vm._v("Add New Category")])]), _vm._v(" "), (_vm.addRequest) ? _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.category.business_category_name),
      expression: "category.business_category_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.category.business_category_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.category.business_category_name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addBusinessCategory
    }
  }, [_vm._v("Add")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-action', '')
      }
    }
  }, [_vm._v("Cancel")])]) : _vm._e(), _vm._v(" "), _c('table', {
    staticClass: "table",
    attrs: {
      "ui-jq": "footable",
      "ui-options": "{\r\n            \"paging\": {\r\n              \"enabled\": true\r\n            },\r\n            \"filtering\": {\r\n              \"enabled\": true\r\n            },\r\n            \"sorting\": {\r\n              \"enabled\": true\r\n            }}"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.categories), function(cc, index) {
    return _c('tr', {
      attrs: {
        "data-expanded": "true"
      }
    }, [_c('td', [_vm._v(_vm._s(++index))]), _vm._v(" "), _c('td', [((_vm.category.editRequest && (cc.business_category_id == _vm.category.business_category_id))) ? _c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (cc.business_category_name),
        expression: "cc.business_category_name"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (cc.business_category_name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          cc.business_category_name = $event.target.value
        }
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "btn btn-info",
      attrs: {
        "type": "button"
      },
      on: {
        "click": _vm.editBusinessCategories
      }
    }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('reset-action', '')
        }
      }
    }, [_vm._v("Cancel")])]) : _c('span', [_vm._v("\r\n                        " + _vm._s(cc.business_category_name) + "\r\n                    ")])]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-primary",
      on: {
        "click": function($event) {
          _vm.setComponent('edit', cc)
        }
      }
    }, [_vm._v("Edit")])])])
  }))])])])])]), _vm._v(" "), _c('component-footer')], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "data-breakpoints": "xs"
    }
  }, [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Category")]), _vm._v(" "), _c('th', [_vm._v("~")])])])
}]}

/***/ }),
/* 175 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-wrapper"
  }, [_c('section', {
    attrs: {
      "id": "container"
    }
  }, [_c('component-header'), _vm._v(" "), _c('section', {
    attrs: {
      "id": "main-content"
    }
  }, [_c('section', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "market-updates"
  }, [_c('div', {
    staticClass: "col-md-3 market-update-gd"
  }, [_c('a', {
    staticStyle: {
      "color": "inherit"
    },
    attrs: {
      "href": "users"
    }
  }, [_c('div', {
    staticClass: "market-update-block clr-block-2"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 market-update-left"
  }, [_c('h4', [_vm._v("Users")]), _vm._v(" "), (_vm.users) ? _c('h3', [_vm._v(_vm._s(_vm.users.length))]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("@ count Today")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 market-update-gd"
  }, [_c('a', {
    staticStyle: {
      "color": "inherit"
    },
    attrs: {
      "href": "businesses"
    }
  }, [_c('div', {
    staticClass: "market-update-block clr-block-1"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 market-update-left"
  }, [_c('h4', [_vm._v("Businesses")]), _vm._v(" "), (_vm.businesses) ? _c('h3', [_vm._v(_vm._s(_vm.businesses.length))]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("@ count Today")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 market-update-gd"
  }, [_c('a', {
    staticStyle: {
      "color": "inherit"
    },
    attrs: {
      "href": "cnpros"
    }
  }, [_c('div', {
    staticClass: "market-update-block clr-block-3"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 market-update-left"
  }, [_c('h4', [_vm._v("CNpros")]), _vm._v(" "), (_vm.cnpros) ? _c('h3', [_vm._v(_vm._s(_vm.cnpros.length))]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("@ count Today")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 market-update-gd"
  }, [_c('a', {
    staticStyle: {
      "color": "inherit"
    },
    attrs: {
      "href": "forums"
    }
  }, [_c('div', {
    staticClass: "market-update-block clr-block-4"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 market-update-left"
  }, [_c('h4', [_vm._v("Forums")]), _vm._v(" "), (_vm.forums) ? _c('h3', [_vm._v(_vm._s(_vm.forums.length))]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("@ count Today")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "agil-info-calendar"
  }, [_c('div', {
    staticClass: "col-md-12 w3agile-notifications"
  }, [_c('div', {
    staticClass: "notifications"
  }, [_c('header', {
    staticClass: "panel-heading"
  }, [_vm._v("\r\n                                Real Time Activities\r\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "notify-w3ls"
  }, _vm._l((_vm.activities), function(act) {
    return _c('div', [_c('div', {
      class: 'alert ' + act.activity_info_type + ' clearfix'
    }, [_c('span', {
      staticClass: "alert-icon"
    }, [_c('i', {
      class: act.activity_info_icon
    })]), _vm._v(" "), _c('div', {
      staticClass: "notification-info"
    }, [_c('ul', {
      staticClass: "clearfix notification-meta"
    }, [_c('li', {
      staticClass: "pull-left notification-sender"
    }, [_vm._v(_vm._s(act.activity_subject))]), _vm._v(" "), _c('li', {
      staticClass: "pull-right notification-time"
    }, [_vm._v(_vm._s(act.activity_date))])]), _vm._v(" "), _c('p', [_vm._v("\r\n                                                    " + _vm._s(act.activity_snippet) + "\r\n                                            ")])])])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 w3agile-notifications"
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]), _vm._v(" "), _c('component-footer')], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4 market-update-right"
  }, [_c('i', {
    staticClass: "fa fa-users"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4 market-update-right"
  }, [_c('i', {
    staticClass: "fa fa-briefcase"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4 market-update-right"
  }, [_c('i', {
    staticClass: "fa fa-crosshairs"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4 market-update-right"
  }, [_c('i', {
    staticClass: "fa fa-meh-o",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-md-12 w3ls-graph"
  })])])
}]}

/***/ }),
/* 176 */,
/* 177 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[84]);


// WEBPACK FOOTER //
// static/js/app.88177bd0286947f7538c.js